import React from "react";
import "./home.css";
import Select from "react-select";
import { renderToString } from 'react-dom/server'
import queryString from 'query-string';
import axios from 'axios';
import { AppProvider, Modal, Button, Toast, Frame, Icon, TextContainer, TextField, Banner } from "@shopify/polaris";
import { ChevronRightMinor, MobileBackArrowMajor, QuestionMarkMajor } from "@shopify/polaris-icons";
import { Select2 } from "select2-react-component";
import CustomSelect from "./custom-select-menu/custom-select";
import Service from "../../service";
import enTranslations from "@shopify/polaris/locales/en.json";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { WithContext as ReactTags } from 'react-tag-input';
import "select2-component/dist/select2.min.css"
import { category, customer, order, product, other, countryData, currencyData, browserData, deviceData, operating_systemData, product_conditionsData, customer_conditionsData, custome_addressData, fraudAnalysisData, fulfillmentStatusData, fulfillmentStatusDataOne, weight_unitData, carrierData, ConditionData,ConditionDatas, paymentData, paymentSatatusData, shipmentData, salesData, orderStatusData, languageData } from '../../trigger_data/trigger';
import config from "../../config";
import Dynamicthankyou from "./dynamicthankyou";
import DynamicAdd from "./dynamicAdd";
import LoaderSection from "./loaderSection";
import NextSection from "./nextSection";
import AnootationDetails from "./AnootationDetails";
import AnootationDetailsThankyou from "./anootationDetailsThankyou";
import DeleteTrigger from "./deleteTrigger";
import ActionButton from "./ActionButton";
import ActionButtonThankyou from "./ActionButtonThankyou";
import CommanModal from './CommanModal';
import FallbackTemplate from "./FallbackTemplate";
import { ClipLoader } from "react-spinners";
import { css } from "@emotion/core";
import parse from "html-react-parser";
import { _ as __, addLocale, useLocale } from 'ttag';
import congoGif from "../../image/app_activation.webp";
import Switch from "react-switch";
import {encode, decode} from 'html-entities';
import DataId from "./add_data_id";

let moment = require('moment');


const keyCodes = {
  comma: 188,
  enter: 13,
};

const override = css`
display: block;
margin: 0 auto;
border-color: '#bcf9bc';
`;
const delimiters = [keyCodes.comma, keyCodes.enter];
let timeout = null;
let no_img_url = `/assets/img/no-image-placeholder.jpg`
const formatOptionLabel = ({ value, label, customAbbreviation }) => (
  <div className={value == "add" ? "icon-custome" : ""}>
    <div>{label}</div>
    {/* <div style={{ marginLeft: "10px", color: "#ccc" }}>
          {customAbbreviation}
      </div> */}
  </div>
);
class Home extends React.PureComponent {
  constructor(props) {
    super(props);
    let url = this.props.location.search;
    let params = queryString.parse(url);
    this.state = {
      offer_options: [],
      parametersData: [],
      customer_conditionsData: customer_conditionsData,
      custome_addressData: custome_addressData,
      product_conditionsData: product_conditionsData,
      operating_systemData: operating_systemData,
      fraudAnalysisData: fraudAnalysisData,
      fulfillmentStatusData: fulfillmentStatusData,
      fulfillmentStatusDataOne: fulfillmentStatusDataOne,
      currencyData: currencyData,
      weight_unitData: weight_unitData,
      carrierData: carrierData,
      countryData: countryData,
      deviceData: deviceData,
      browserData: browserData,
      paymentData: paymentData,
      paymentSatatusData: paymentSatatusData,
      shipmentData: shipmentData,
      orderStatusData: orderStatusData,
      salesData: salesData,
      languageData: languageData,
      productTypeData: '',
      vendorData: '',
      parameters: [],
      active: false,
      sampleActive: false,
      sampleActiveURL: "",
      premadeTemplate: false,
      templateActive: false,
      direction: "",
      addDownshell: 0,
      addUpshell: 0,
      selectedDropdownId: '',
      selectedOption: null,
      selectedOption_fallback: null,
      show_select: false,
      store_client_id: "",
      funnel_id: params.funnel_id,
      token: params.app_hmac_auth,
      app_hmac_auth: "",
      version: "/v1",
      redirect: "",
      funnel_dashboard: params.f ? params.f : "",
      page_dashboard: params.p ? params.p : "",
      shop: "",
      email: "",
      scid: '',
      offerUser_down: [],
      defaultOffer: [],
      funnel_offer: [],
      defaultData: [],
      funnel_toast: false,
      funnel_toast_error: false,
      toaster_msg: "",
      emptyTemplate: false,
      selectCategores: { value: "all orders", label: __("All orders") },
      parameter: { value: "accepts-marketing", label: __("Accepts marketing") },
      conditions: { value: 'yes', label: __("Yes") },
      trigger: [{}],
      mainTrigger: [{ trigger: [{}] }],
      conditionsDataOne: [],
      ConditionData: ConditionData,
      ConditionDatas: ConditionDatas,
      ConditionDatasSampl: ConditionDatas,
      weight_unit: "",
      txt_value: "",
      tmp_data: [],
      template_data: [],
      delete_offer: [],
      tmp: '',
      addDownshellThankyou: false,
      loading: false,
      myParent: "",
      myTrigger: [{}],
      remove_my_trigger: [],
      templateURL: "",
      createOfferLoader: false,
      premadTmp: [],
      category_array: category,
      expandView: true,
      delete_offer_template: false,
      offer_delete: true,
      record_delete_data: "",
      startDate: '',
      endDate: '',
      tags: [],
      isDraft: false,
      isPublish: false,
      open_iframe: false,
      open_recomm: false,
      open_devTemplate: false,
      hostname: window.location.hostname,
      right_arrowIcon: true,
      funnel_title: '',
      iframeLoader: false,
      premadeTemplate_rightSide: false,
      animateLeft: false,
      app_language: "en",
      theme_language: "",
      edit_funnel_offers_id: '',
      create_funnel_offers_id: '',
      create_funnel_template_id: '',
      show_toast: false,
      toast_error: false,
      table_selector: '',
      anaytics_data: '',
      anaytics_data_value: '',
      selectedOption_fallback_id: '',
      default_selectedOption_fallback_id: 0,
      specificCustomer: '',
      allsurveyList: '',
      fallback_active: false,
      showInput: false,
      rmvBoarder: false,
      appStatus: '',
      is_default: '',
      show_offerLoader: true,
      getCollection: '',
      getproduct: '',
      suveytaken: '',
      allsuveytaken: '',
      trigger_errmessage: '',
      showTimepicker: false,
      currancyFormate: '',
      helpVidio: false,
      fromFallback: false,
      rct_token: "",
      get_lg: "",
      get_theme_id: "",
      butttonloading: false,
      isDefault: '',
      isbelowDefault: '',
      isFirst: params.is_first ? params.is_first : '',
      isPublishFirst: params.is_publish ? params.is_publish : '',
      publishFirst: false,
      toggle_status: false,
      new_toggle_status: false,
      change_toggle: false,
      addDisable: false,
      respo: false,
      draftEnable: true,
      publishEnable: true,
      confirmationPhp: false ,
      Condition2Data: [
        { value: "month", label: __("Months") },
        { value: "week", label: __("Weeks") },
        { value: "day", label: __("Days") },
      ],
      funnel_activity: [],
      percentage: "30",
      premadeDesc : "",
      check_pp_app_status: 1,
      app_title: "Reconvert",
      check_status_popup_view: false,
      is_fallback: true,
      top_banner_data : {},
      banner_type : "",
      is_show_banner : 0,
      display_rules : '',
    };
    this.service = new Service();
    this.wrapperRef = React.createRef();
    this.videoRef = React.createRef();
    this.closeModal = this.closeModal.bind(this);
    this.getAllOfferList = this.getAllOfferList.bind(this);
    this.get_offer_template = this.get_offer_template.bind(this);
    this.handleClose_premade = this.handleClose_premade.bind(this);
    this.delete_offer = this.delete_offer.bind(this);
    this.closeshowDropdown = this.closeshowDropdown.bind(this);
    this.thankyouClick = this.thankyouClick.bind(this);
    this.handleclick = this.handleclick.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAddition = this.handleAddition.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.openfallback = this.openfallback.bind(this);
    this.doubleclick = this.doubleclick.bind(this);
    this.save_funnel = this.save_funnel.bind(this);
    this.publish_funnel = this.publish_funnel.bind(this);
    this.openhelpvidio = this.openhelpvidio.bind(this);
    this.getDefaultProductOptions_product = this.getDefaultProductOptions_product.bind(this);
    this.getSpecificName = this.getSpecificName.bind(this);
    this.getText = this.getText.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleChnageappfirstPopup = this.handleChnageappfirstPopup.bind(this)
    this.redirecttoDashboard = this.redirecttoDashboard.bind(this)
    this.changeToggle = this.changeToggle.bind(this)
    this.check_pp_app_status = this.check_pp_app_status.bind(this);
    this.handleClickVideo = this.handleClickVideo.bind(this)
    this.getBrowserName = this.getBrowserName.bind(this)
    this.closeBanner = this.closeBanner.bind(this)
  }
  /**
   * IW0079
   * Remove tags
   */
  handleDelete(e, i, j, tags) {
    const new_tags = tags.filter((tag, index) => index !== e)
    tags.length === 0 ? this.setState({ isDraft: false, isPublish: false, draftEnable: false }) : this.setState({ isDraft: true, isPublish: true, draftEnable: true })
    Object.assign(this.state.mainTrigger[j].trigger[i], { tags: new_tags })
    this.setState({ tags })
  }
  /* Add tags */
  handleAddition(tag, i, j, tags, param) {
    if (tag.id && tag.id !== "\n") {
      if (!tags) {
        tags = []
      }
      if (param === "phone-number") {
        const re = /^[0-9 ()+-]+$/;
        if (tag.id === '' || re.test(tag.id)) {
          Object.assign(this.state.mainTrigger[j].trigger[i], { tags: [...tags, tag] })
          this.setState({ isDraft: true, isPublish: true, tags, draftEnable: true })
        }
      }
      else if (param === "order-id") {
        const re = /^[0-9\b]+$/;
        if (tag.id === '' || re.test(tag.id)) {
          Object.assign(this.state.mainTrigger[j].trigger[i], { tags: [...tags, tag] })
          this.setState({ isDraft: true, isPublish: true, tags, draftEnable: true })
        }
      }
      else {
        const new_tag =  tag.id.includes("\t") ? { "id": tag.id.toString().replace(/\t/g, ' '), "text": tag.text.toString().replace(/\t/g, ' ') } :{ "id": tag.id.toLowerCase(), "text": tag.text.toLowerCase() }
        let a_new_tag =  tag.id.includes("\n") ? { "id": tag.id.toString().replace(/^\s+|\s+$/g, ''), "text": tag.text.toString().replace(/^\s+|\s+$/g, '') } : new_tag
        Object.assign(this.state.mainTrigger[j].trigger[i], { tags: [...tags, a_new_tag] })
        this.setState({ isDraft: true, isPublish: true, tags, draftEnable: true })
      }
    }
  }
  /* outer click of tag input value */
  handleInputBlur() {  }
  componentDidMount() {
    /* new funnel on publish button click in onboarding page */
    if(this.state.isPublishFirst === "1"){
      this.setState({ publishFirst: true })
    }
    /* create new funnel in editor page */
    if (this.state.isFirst === "1") {
      this.setState({ show_toast: true, toast_message: __("Funnel created successfully", "default"), toast_error: false })
    }
    const self = this;
    /* page reload and tab close event */
    window.onbeforeunload = function () {
      if (self.state.isDraft) {
        return window.confirm("Confirm refresh");
      }
    }
    // document.addEventListener('visibilitychange', function () {
    //   document.title = document.visibilityState;
    //   console.log(document.visibilityState);
    // });
    // window.addEventListener('blur', () => {
    //   window.confirm('Come back! :c');
    // });
    // window.addEventListener('focus', () => {
    //   window.confirm('focus');
    // });
    this.service.get("/funnel/api/checkStore?token=" + this.state.token, function (status, data) {
      if (status === 200 && data.status === "success") {
        self.setState({ respo: true })
        if (data && data.data && data.data.store_status === "1") {
          self.setState({
            redirect: data.redirect,
            scid: data.data.scid,
            table_selector: data.data.table_selector,
            shop: data.data.shop,
            email: data.data.email,
            rct_token: data.data.token,
            currancyFormate: data.data.currency,
            get_lg: data.data.get_lg,
            get_theme_id: data.data.get_theme_id,
            app_hmac_auth: data.app_hmac_auth
          })
          no_img_url=config.iFrame_url + self.state.version+no_img_url
          document.title = "Funnel Editor | " + data.data.shop
          /*  remove unwanted offer of current user only */
          self.remove_offer_template();
          /* get funnel data of current user */
          self.getFunnelDetails(true);
          self.check_pp_app_status(false);
        }
      }
      else {
        if (data && data.data === "redirect") {
          window.location.href = data.redirect != "" ? `${config.iFrame_url + self.state.version}/${data.redirect}?app_hmac_auth=${self.state.token}` : "https://accounts.shopify.com/store-login?redirect=apps"
        }
        else {
          self.setState({ show_toast: true, toast_message: data.message, toast_error: true })
        }
      }
    });
    this.setState({
      parametersData: customer,
      parameters: customer
    })
    document.addEventListener('mousedown', this.handleclick);
    document.addEventListener('mousedown', this.handleClickVideo);
  }
  /* when page refresh it remove unwanted offer of current user only */
  remove_offer_template() {
    this.service.get(
      "/funnel/api/remove_offer_template?token=" + this.state.token + "&app_language=" + this.state.app_language + "&theme_language=" + this.state.theme_language,
      function (status) {
        if (status === 200) { }
        else { }
      }
    );
  }
  closeBanner(display_rule){
    if(display_rule == "0") {
      this.setState({ is_show_banner : 0 })
    } else if(display_rule == "1") {
      var data = {
        banner_id : this.state.top_banner_data.banner_id,
        store_client_id : this.state.store_client_id
      }
      this.service.post("/funnel/api/bannerClickCount", data, function (
        status,
        data
      ) {
        if (status === 200 && data.status === "success") {
          this.setState( {is_show_banner : data.is_show_banner })
        } else {
          this.setState({ show_toast: true, toast_message: data.message, toast_error: true })
        }
      });
    } 
  }
  /* get funnel data of current user */
  getFunnelDetails(flag) {
    const self = this;
    this.service.get(
      "/funnel/api/getFunnel?token=" + this.state.token, function (status, data) {
        console.log("data1", data)
        if (status === 200 || "success") {
          if (window.location.hostname != "localhost") {
            let crisp_scid = data.data && data.data.length ? data.data[0].store_client_id : '';
            window.$crisp = [];
            window.CRISP_TOKEN_ID = btoa((crisp_scid * 6));
            window.CRISP_WEBSITE_ID = "56918d27-713e-4f7f-9786-961982ae4884";
            (function () {
              let d = document;
              let s = d.createElement("script");
              s.src = "https://client.crisp.chat/l.js";
              s.async = 1;
              d.getElementsByTagName("head")[0].appendChild(s);
            })();
            console.log("data2", data)
          }
          if (data.data.length) {
            var is_show_banner = data.data[0].is_show_banner;
            self.setState({
              store_client_id: data.data && data.data.length ? data.data[0].store_client_id : '',
              funnel_title:decode(data.data[0].funnel_title),
              is_default: data.data[0].is_default,
              appStatus: data.data[0].app_status,
              app_language: data.data[0].app_language,
              theme_language: data.data[0].theme_language,
              selectedOption_fallback_id: data.data[0].fallback_page_id,
              default_selectedOption_fallback_id: data.data[0].fallback_page_id,
              toggle_status: data.data[0].status !== "0",
              new_toggle_status: data.data[0].status !== "0",
              banner_type: is_show_banner == "1" ? data.data[0].banner_type : "",
              top_banner_data : is_show_banner == "1" ? data.data[0].top_banner : "",
              is_show_banner : is_show_banner,
              display_rules :  is_show_banner == "1" ? data.data[0].display_rules : "",
            });
            /* set default language */
            let app_language = data.data[0].app_language ? data.data[0].app_language : data.data[0].theme_language;
            if (app_language !== 'en') {
              app_language = self.changeAppLanguage(app_language)
              const translationsObj = require(`../../languages/lang_json/${app_language}.po.json`);
              addLocale(app_language, translationsObj);
              useLocale(app_language);
            }
            /**
             * IW0070
             * Bellow code are use for multilanguage in hall trigger's drop down, without it, it will not work for multi language
             */
            category.forEach(element => { Object.assign(element, { label: __(element.label) }) });
            customer.forEach(element => { Object.assign(element, { label: __(element.label) }) })
            order.forEach(element => { Object.assign(element, { label: __(element.label) }) })
            product.forEach(element => { Object.assign(element, { label: __(element.label) }) })
            other.forEach(element => { Object.assign(element, { label: __(element.label) }) })
            countryData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            currencyData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            browserData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            deviceData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            operating_systemData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            product_conditionsData.forEach(element => { Object.assign(element, { label: __(element.label) }) })
            customer_conditionsData.forEach(element => { Object.assign(element, { label: __(element.label) }) })
            custome_addressData.forEach(element => { Object.assign(element, { label: __(element.label) }) })
            fraudAnalysisData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            fulfillmentStatusData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            fulfillmentStatusDataOne.forEach(element => { Object.assign(element, { label: (element.label) }) })
            weight_unitData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            carrierData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            ConditionData.forEach(element => { Object.assign(element, { label: __(element.label) }) })
            paymentData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            paymentSatatusData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            shipmentData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            salesData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            orderStatusData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            languageData.forEach(element => { Object.assign(element, { label: (element.label) }) })
            let conditions = data.data[0].conditions;
            conditions = JSON.parse(conditions);
            conditions.forEach(element => {
              if (element.condition_values) {
                Object.assign(element, {
                  condition_values: element.condition_values.replaceAll('$72$', '"')
                })
              }
            });
            if (conditions.length) {
              self.manageTrigger(conditions)
            }
            if (flag) {
              self.get_offer_template();
              self.getAllOfferList();
              self.getAllTemplate(data.data[0].fallback_page_id, false);
            }
          }
          else {
            self.setState({ show_toast: true, toast_message: data.message, toast_error: true })
            window.location.href = `${config.iFrame_url + self.state.version}/${self.state.redirect}?app_hmac_auth=${self.state.token}`
          }
        }
      }
    );
  }
  /**
   * IW0079
   * In this function we change app_language value according to our language
   */
  changeAppLanguage(app_language) {
    let app_lang = [{id : 'zh-CN' , value :'zh-CN'},
                    {id : 'zh-TW' , value :'zh-TW'},
                    {id : 'fil' , value :'fil_PH'},
                    {id : 'pt' , value :'pt_BR'},
                    {id : 'fr' , value :'fr'},
                    {id : 'es' , value :'es'},
                    {id : 'ja' , value :'ja'},
                    {id : 'gr' , value :'gr'},
                    {id : 'jp' , value :'jp'},
                    {id : 'ru' , value :'ru'},
                    {id : 'sp' , value :'sp'},
                    {id : 'de' , value :'de'},
      { id: 'he', value: 'he-IL' },
                    {id : 'hi' , value :'hi'}]
    if(app_language.includes("-") && ['zh-CN','zh-TW'].includes(app_language) !== true){
      let primary_lang = app_language.split("-");
      app_language = primary_lang[0]
    }
    app_lang.map((e) => {
        if(e.id === app_language){
          app_language = e.value
        }
      })
  return app_language;
  }
  /* manage trigger data on getFunnelDetails */
  manageTrigger(conditions) {
    const trigger_data = [{ trigger: [] }];
    conditions.forEach((element, i) => {
      Object.assign(element, { conditions: element.conditions + "@$@" + element.parameters })
      if (element.condition_values) {
        const dd = []
        const tags = element.condition_values.split(',')
        tags.forEach((ele) => {
          while(ele.includes("$44$")) {
            ele = element.parameters === "product-collection" || element.parameters === "specific-product" ? ele.replace("$44$",',') : ele;
          }
          dd.push({ id: element.parameters === "product-collection" || element.parameters === "specific-product" ? ele : ele.replace("@$@", ','), text: element.parameters === "product-collection" || element.parameters === "specific-product" ? ele : ele.replace("@$@", ',') })
        })
        if (["sales-channel", "carrier", "operating-system"].includes(element.parameters)) {
          dd.forEach(element => {
            element.text = this.getText(element.id)
          });
        }
        Object.assign(element, { tags: dd })
        if (element.parameters === "birthday" || element.parameters === "order-date" || element.parameters === "total-items-count" || element.parameters === "customer-created" || element.parameters === "order-time" || element.parameters === "order-value") {
          if (element.condition_values.split(' - ')) {
            Object.assign(element, { "txt_valueFrom": element.condition_values.split(' - ')[0], "txt_valueTo": element.condition_values.split(' - ')[1], "from": element.condition_values.split(' - ')[0], "to": element.condition_values.split(' - ')[1] })
          }
        }
        else {
          if (element.condition_values.split('-')) {
            Object.assign(element, { "txt_valueFrom": element.condition_values.split('@$@')[0], "txt_valueTo": element.condition_values.split('@$@')[1], "from": element.condition_values.split('@$@')[0], "to": element.condition_values.split('@$@')[1] })
          }
        }
      }
      trigger_data[trigger_data.length - 1].trigger.push(element);
      if (element.condition_type === "OR" && conditions[i + 1]) {
        trigger_data.push({ trigger: [] });
      }
      if(element?.tags) {
        if(element.parameters === 'product-collection' || element.parameters === 'specific-product') {
            this.getDefaultProductOptions_product(element.tags,element.parameters);
        }
      }
    });
    this.setState({ mainTrigger: trigger_data })
    trigger_data.forEach((ele, j) => {
      ele.trigger.forEach((el, i) => {
        this.selectCategoresChange(el.categores, "selectCategores", i, j, false, el);
      })
    })
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleclick);
    document.removeEventListener('mousedown', this.handleClickVideo);
  }
  handleClickVideo(e) {
    if (this.videoRef && this.videoRef.current && this.videoRef.current.contains && !this.videoRef.current.contains(e.target)) {
      this.openhelpvidio()
    }
  }
  /* open premadeTemplte in create new template */
  open_premadeTemplate(tmp) {
    this.setState({ premadeTemplate_rightSide: tmp });
  }
  callFromPHP() {
    if (!this.state.percentage) {
      this.setState({ show_toast: true, toast_message: "Discount value required", toast_error: true });
      return;
    }
    this.setState({ emptyTemplate: true , addDisable: true, iframeLoader :true })
    const tmp = this.state.premadeTemplate_rightSide;
    this.setState({ isDraft: true, isPublish: true, draftEnable: true });
    const formData = new FormData();
    const self = this;
    formData.append("hmac_auth_str", this.state.app_hmac_auth)
    formData.append("method_name", "create_thankyou_page");
    formData.append("is_funnel",true);
    formData.append("seg_fun_name",this.state.funnel_title)
    formData.append("shop", this.state.shop);
    formData.append("template_type", "is_premade");
    formData.append("discount", this.state.percentage);
    if (tmp) {
      formData.append("page_id", tmp.page_id);
      formData.append("template_title", tmp.title);
    }
    else {
      // formData.append("method_name", "create_thankyou_page");
      // formData.append("shop", this.state.shop);
      formData.append("page_id", "0");
      formData.append("template_title", "Empty template");
      // formData.append("template_type", "is_premade");
    }
    const headers = {
      'Content-Type': 'application/json'
    }
    axios.post(config.ajaxUrl + this.state.version + '/client/ajax_responce_react.php', formData, {
      headers: headers
    })
      .then((res) => {
        this.handleClose_premade();
        self.setState({ selected_fall: { value: res.data.page_id, label: tmp?.title ? tmp.title : "Empty template" } });
        if (self.state.fromFallback === true) {
          self.setState({ show_toast: true, toast_message: res.data.msg, toast_error: false })
          self.setState({ templateURL: res.data.url, templateActive: true })
        }
        else {
          const data = {
            store_client_id: self.state.store_client_id,
            shop: self.state.shop,
            token: self.state.token,
            offer_id: null,
            temp_id: res.data.page_id,
            parent_id: self.state.myParent.funnel_offers_id || 0,
            open: self.state.myParent.open || false,
            direction: self.state.direction,
            section_id: null,
            offer_name: "copy_" + (self.state.myParent.p_offer_name || self.state.myParent.c_offer_name || __("Offer name")),
            tmp_name: res.data.name,
            name: tmp && tmp.title ? tmp.title : "Empty template",
            location_no: self.state.myParent.location_no,
            table_selector: self.state.table_selector,
            app_hmac_auth: self.state.app_hmac_auth,
            app_language: this.state.app_language,
            theme_language: this.state.theme_language,
          };
          self.state.funnel_activity.push("Thank you page")
          if (res.data.page_id) {
            self.setState({ create_funnel_template_id: res.data.page_id })
          }
          self.service.post("/funnel/api/duplicate_offer_template", data, function (
            status,
            data
          ) {
            self.setState({ loading: false })
            self.setState({ emptyTemplate: false , addDisable : false })
            if (status === 200 && data.status === "success") {
              self.setState({ templateURL: res.data.url, templateActive: true })
              /* no need to call again api it will give response so set it in current array */
              const sendData = self.state.defaultOffer;
              sendData.push(data.data)
              const list_to = self.list_to_tree(sendData);
              self.setState({
                offerUser_down: list_to,
                defaultOffer: sendData,
                defaultData: sendData
              });
              self.setState({ show_toast: true, toast_message: data.message, toast_error: false , iframeLoader:false })
              /* after create dublicate offer again call api for get offer so it can feel in to select box */
              self.getAllOfferList();
            } else {
              self.setState({ show_toast: true, toast_message: data.message, toast_error: true })
            }
          });
        }
      })
      .catch((error) => { console.log('Error',error)})
  }
  close_rightSide_template() {
    this.setState({ animateLeft: true })
    setTimeout(() => {
      this.setState({ premadeTemplate_rightSide: false, animateLeft: false })
    }, 500);
  }
  handleclick(e) {
    if (this.wrapperRef && this.wrapperRef.current && this.wrapperRef.current.contains && !this.wrapperRef.current.contains(e.target)) {
      if (this.state.showTimepicker) {
        this.setState({ showTimepicker: false })
      }
      if (this.state.showInput) {
        this.setState({ showInput: false })
      }
      if (this.state.show_select) {
        this.setState({ show_select: false })
      }
      if (this.state.selectedDropdownId) {
        this.setState({ selectedDropdownId: false })
      }
      else {
        this.setState({ addDownshell: 0, addDownshellThankyou: false, show_select: false })
      }
    }
  }
  getAllTemplate(fallback_page_id, flag) {
    fallback_page_id = fallback_page_id ? fallback_page_id : this.state.create_funnel_template_id;
    const self = this;
    this.service.get("/funnel/api/getTemplate?store_client_id=" + this.state.store_client_id + "&app_language=" + this.state.app_language + "&theme_language=" + this.state.theme_language, function (status, data) {
      if (status === 200) {
        const fallback_data = []
        const template_data = [{ value: "add", label: __("Create a new thank you page") }]
        let selected_fall;
        fallback_data.push({ value: "add", label: __("Create a new thank you page"), classes: 'create_new_temp' })
        data.data.forEach(element => {
          fallback_data.push({
            value: element.page_id,
            label: element.name
            /* id: self.state.funnel_id */
          })
          template_data.push({
            value: element.page_id,
            label: element.name
          })
          if (fallback_page_id === element.page_id) {
            selected_fall = element
            const offerUser_down = self.state.offerUser_down;
            const temp_title = element.name;
            remove_childs(offerUser_down);
            function remove_childs(data) {
              data.forEach((element, i) => {
                if (element.temp_id === fallback_page_id) {
                  Object.assign(element, { name: temp_title })
                }
                else {
                  remove_childs(element.child);
                }
              });
            }
          }
        });
        self.setState({
          anaytics_data: fallback_data,
          tmp_data: data.data,
          template_data: template_data
        })
        if (selected_fall && !flag) {
          Object.assign(selected_fall, { label: selected_fall.name, value: selected_fall.page_id, id: selected_fall.funnel_id })
          self.handleChangeTemplate(selected_fall.page_id, flag)
        }
      }
      else { }
    })
  }
  handleChangeTemplate = (selectedOption, isChange) => {
    if (selectedOption === "add") {
      this.setState({ fromFallback: true, emptyTemplate: false, addDisable: false })
      this.getPremadTmp();
    }
    else {
      let selectedOption_fallback;
      this.state.anaytics_data.forEach(element => {
        if (element.value === selectedOption) {
          selectedOption_fallback = element
        }
      });
      const self = this
      Object.assign(selectedOption_fallback, { "label": selectedOption_fallback.label, "value": selectedOption_fallback.value });
      this.setState({ selectedOption_fallback });
      this.service.get('/funnel/api/getAnaliticsThankyou?page_id=' + selectedOption_fallback.value + '&token=' + self.state.token + '&table_selector=' + this.state.table_selector + '&scid=' + this.state.scid + "&app_language=" + this.state.app_language + "&theme_language=" + this.state.theme_language, function (status, data) {
        if (status === 200) {
          self.setState({ anaytics_data_value: data.data, selectedOption_fallback_id: selectedOption_fallback.value })
        }
      }
      );
    }
  }
  handleChangeTemplateFallback = (selectedOption, isChange) => {
    this.setState({is_fallback : false})
    if (selectedOption === "add") {
      this.setState({ fromFallback: true, emptyTemplate: false, addDisable: false })
      this.getPremadTmp();
    }
    else {
      let selectedOption_fallback;
      this.state.anaytics_data.forEach(element => {
        if (element.value === selectedOption) {
          selectedOption_fallback = element
        }
      });
      const self = this
      Object.assign(selectedOption_fallback, { "label": selectedOption_fallback.label, "value": selectedOption_fallback.value });
      this.setState({ selectedOption_fallback });
      this.service.get('/funnel/api/getAnaliticsThankyou?page_id=' + selectedOption_fallback.value + '&token=' + self.state.token + '&table_selector=' + this.state.table_selector + '&scid=' + this.state.scid + "&app_language=" + this.state.app_language + "&theme_language=" + this.state.theme_language, function (status, data) {
        if (status === 200) {
          self.setState({ isDraft: isChange })
          self.setState({ anaytics_data_value: data.data, selectedOption_fallback_id: selectedOption_fallback.value })
        }
      }
      );
    }
  }
  openfallback() {
    this.setState({ anaytics_data: this.state.anaytics_data })
  }
  handleToggle() {
    setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
    }, 170);
    this.setState({ fallback_active: !this.state.fallback_active })
  }
  get_offer_template() {
    const self = this;
    this.service.get(
      "/funnel/api/offer?token=" + this.state.token + '&table_selector=' + this.state.table_selector + '&app_hmac_auth=' + this.state.app_hmac_auth + "&app_language=" + this.state.app_language + "&theme_language=" + this.state.theme_language,
      function (status, data) {
        if (status === 200) {
          if(data.data.length && (data.data[0].location_no !== '1' || data.data[0].parent_id !== 0)){
            let detail= {
              action: 'genrate_db_log',
              table: 'shorttime_funnel_save_setting',
              log:{
                store_client_id:self.state.store_client_id,
                funnel_id:data.data[0].funnel_id,
              }
            }
            self.service.post("/store/reconvert", detail, function (
              status,
              data
            ) {});
          }
          self.setState({ show_offerLoader: false })
          const list_to = self.list_to_tree(data.data);
          self.setState({
            offerUser_down: list_to,
            defaultOffer: data.data,
            defaultData: data.data
          });
          if (self.state.isFirst) {
            self.removeParam("is_first")
          }
          else if(self.state.isPublishFirst) {
            self.removeParam("is_publish")
          }
        } else { }
      }
    );
  }
  removeParam(parameter) {
    var url = window.location.href;
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
      var urlBase = urlparts.shift();
      var queryString = urlparts.join("?");
      var prefix = encodeURIComponent(parameter) + '=';
      var pars = queryString.split(/[&;]/g);
      for (var i = pars.length; i-- > 0;)
        if (pars[i].lastIndexOf(prefix, 0) !== -1)
          pars.splice(i, 1);
      url = urlBase + '?' + pars.join('&');
      window.history.pushState('', window.location.title, url); // added this line to push the new url directly to url bar .
    }
    return url;
  }
  get_specific_offer_template(id) {
    const self = this;
    this.service.get(
      "/funnel/api/offer?token=" + this.state.token + "&id=" + id + '&table_selector=' + this.state.table_selector + '&app_hmac_auth=' + this.state.app_hmac_auth + "&app_language=" + this.state.app_language + "&theme_language=" + this.state.theme_language,
      function (status, data) {
        if (status === 200) {
          const get_offer = data.data[0]
          if (get_offer) {
            const defaultOffer = self.state.defaultOffer;
            defaultOffer.forEach(element => {
              if (get_offer.offer_id !== null) {
                /* Offer check */
                if (element.offer_id === get_offer.offer_id) {
                  Object.assign(element, get_offer)
                }
              }
              else {
                /* thank you page check */
                if (element.temp_id === get_offer.temp_id && element.location_no == get_offer.location_no) {
                  Object.assign(element, get_offer)
                }
              }
            });
            Object.assign(defaultOffer[0], { open: self.state.offerUser_down[0].open })
            const list_to = self.list_to_tree(defaultOffer);
            self.setState({
              offerUser_down: list_to,
              defaultOffer: defaultOffer,
              defaultData: defaultOffer
            });
          }
        } else { }
      }
    );
  }
  /* create tree array from simple array */
  list_to_tree(list) {
    let map = {}, node, roots = [], i;
    for (i = 0; i < list.length; i += 1) {
      map[list[i].funnel_offers_id] = i;  /* initialize the map */
      list[i].child = [];
      list[i].downchild = [];
      list[i].rightchild = [];
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parent_id !== 0) {
        if (node.direction === "1") {
          list[map[node.parent_id]].downchild.push(node);
        }
        else {
          list[map[node.parent_id]].rightchild.push(node);
        }
        list[map[node.parent_id]].child.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }
  /* get offers show in select box */
  getAllOfferList() {
    const self = this;
    this.service.get("/funnel/api/select_offer?store_client_id=" + this.state.store_client_id + "&app_language=" + this.state.app_language + "&theme_language=" + this.state.theme_language, function (status, data) {
      if (status === 200) {
        const options = [{ value: "add", label: __("Create a new offer") }];
        data.data.forEach((element) => {
          options.push({
            value: element.offer_id,
            label: element.offer_name,
          });
        });
        self.setState({
          offer_options: options,
          funnel_offer: data.data,
        });
      } else { }
    });
  }
  /* create duplicate offer from select box */
  handleChange = (selectedOption) => {
    this.setState({ isDraft: true, isPublish: true, draftEnable: true });
    const selectedArray = this.state.funnel_offer.find(
      (element) => element.offer_id === selectedOption.value
    );
    const self = this;
    if (selectedOption.value === "add") {
      /* open popup for create new offer
       MAKE THIS COMMENT FOR RECOMMANDATION DISABLE */
      this.open_sampleModal('upsell', false, true, 24)
    } else {
      let selected_offer_parent;
      findFromChild(this.state.offerUser_down)
      function findFromChild(dat) {
        dat.forEach(element => {
          if (element.offer_id === selectedArray.offer_id) {
            selected_offer_parent = element
          }
          else {
            findFromChild(element.child)
          }
        });
      }
      const data = {
        store_client_id: self.state.store_client_id,
        shop: self.state.shop,
        token: this.state.token,
        offer_id: selectedArray.offer_id,
        from_tbl: selectedArray.from_tbl,
        temp_id: "0",
        parent_id: this.state.myParent.funnel_offers_id || 0,
        open: this.state.myParent.open || false,
        direction: this.state.direction,
        section_id: selectedArray.section_id,
        offer_name: "copy_" + selectedOption.label,
        product_type: this.state.myParent.product_type,
        product_id: selected_offer_parent ? selected_offer_parent.product_id : '',
        product_title: selected_offer_parent ? selected_offer_parent.product_title : '',
        main_image_gr: selected_offer_parent ? selected_offer_parent.main_image_gr : '',
        location_no: this.state.myParent.location_no,
        table_selector: self.state.table_selector,
        app_hmac_auth: self.state.app_hmac_auth,
        app_language: self.state.app_language,
        theme_language: self.state.theme_language,
      };
      this.setState({ loading: true, createOfferLoader: true })
      this.state.funnel_activity.push(this.state.direction === "0" ? "Uspell" : data.parent_id === 0 ? "Uspell" : "Downsell")
      this.service.post("/funnel/api/duplicate_offer_template", data, function (
        status,
        data
      ) {
        self.setState({ loading: false, createOfferLoader: false });
        if (status === 200 && data.status === "success") {
          self.setState({ show_toast: true, toast_message: data.message, toast_error: false });
          /* no need to call again api it will give response so set it in current array */
          self.setState({ create_funnel_offers_id: data.data.funnel_offers_id })
          const sendData = self.state.defaultOffer;
          sendData.push(data.data);
          const list_to = self.list_to_tree(sendData);
          self.setState({
            offerUser_down: list_to,
            defaultOffer: sendData,
            defaultData: sendData
          });
          /* after create dublicate offer again call api for get offer so it can feel in to select box */
          self.getAllOfferList();
          self.open_sampleModal("upsell", data.data, false, parseInt(data.data.section_id));
        } else {
          self.setState({ show_toast: true, toast_message: data.message, toast_error: true });
        }
      });
      this.setState({
        addDownshell: false,
        show_select: false,
      });
    }
  };
  getPremadTmp() {
    const self = this;
    this.service.get("/funnel/api/getPremadTmp?language=" + this.state.theme_language + "&app_language=" + this.state.app_language + "&theme_language=" + this.state.theme_language, function (status, data) {
      if (status === 200) {

        if (data.data && data.data.length) {
          self.setState({ premadeDesc: data.data[0].description })
          data.data[0].description = self.premadeDescChasnge(data.data[0].description, 30)
        }
        self.setState({ premadTmp: data.data, premadeTemplate: true, percentage: "30" });
      }
      else {
        self.setState({ show_toast: true, toast_message: data.message, toast_error: true });
      }
    })
  }
  /* create duplicate template from select box */
  handleChange_thanks = (selectedOption) => {
    this.setState({ isDraft: true, isPublish: true, draftEnable: true });
    const self = this;
    if (selectedOption.value === "add") {
      this.setState({ fromFallback: false })
      this.getPremadTmp();
    } else {
      const selectedArray = this.state.tmp_data.find(
        (element) => element.page_id === selectedOption.value
      );
      const data = {
        store_client_id: self.state.store_client_id,
        shop: self.state.shop,
        token: this.state.token,
        offer_id: null,
        temp_id: selectedArray.page_id,
        name: selectedArray.name,
        parent_id: this.state.myParent.funnel_offers_id || 0,
        open: this.state.myParent.open || false,
        direction: this.state.direction,
        section_id: null,
        offer_name: "copy_" + selectedOption.label,
        location_no: this.state.myParent.location_no,
        table_selector: self.state.table_selector,
        app_hmac_auth: self.state.app_hmac_auth,
        app_language: self.state.app_language,
        theme_language: self.state.theme_language,
      };
      this.state.funnel_activity.push("Thank you page")
      this.service.post("/funnel/api/duplicate_offer_template", data, function (
        status,
        data
      ) {
        self.setState({ loading: false })
        if (status === 200 && data.status === "success") {
          self.setState({ show_toast: true, toast_message: data.message, toast_error: false });
          /* no need to call again api it will give response so set it in current array */
          const sendData = self.state.defaultOffer;
          sendData.push(data.data);
          const list_to = self.list_to_tree(sendData);
          self.setState({
            offerUser_down: list_to,
            defaultOffer: sendData,
            defaultData: sendData
          });
          /* after create dublicate offer again call api for get offer so it can feel in to select box */
          self.getAllOfferList();
        } else {
          self.setState({ show_toast: true, toast_message: data.message, toast_error: true });
        }
      });
      this.setState({
        addDownshell: false,
        show_select: false,
      });
    }
  }
  delete_offer_templateModal(el, which_delete) {
    this.setState({ delete_offer_template: !this.state.delete_offer_template, record_delete_data: el, offer_delete: which_delete });
  }
  delete_offer() {
    const self = this;
    const el = this.state.record_delete_data;
    const funnel_offers_id = el.funnel_offers_id;
    this.setState({ isDraft: true, isPublish: true, draftEnable: true });
    const defaultData = this.state.defaultData;
    /* For first offer to open or close */
    Object.assign(defaultData[0], { open: this.state.offerUser_down[0].open })
    this.state.funnel_activity.push(el.temp_id ? "Thank you page" : el.direction === "0" ? "Uspell" : el.parent_id === 0 ? "Uspell" : "Downsell")
    if (el.child.length) {
      remove_childs(funnel_offers_id);
      remove_last(funnel_offers_id);
    }
    else {
      remove_last(funnel_offers_id);
    }
    function remove_childs(id) {
      defaultData.forEach((element, i) => {
        if (element.parent_id === id) {
          let magenicVendor = defaultData.filter(v => v.parent_id === id);
          magenicVendor.forEach(e => {
            self.state.funnel_activity.push(e.temp_id ? "Thank you page" : e.direction === "0" ? "Uspell" : e.parent_id === 0 ? "Uspell" : "Downsell")
            defaultData.splice(i, 1);
            self.setState({ delete_offer_template: !self.state.delete_offer_template });
            self.state.delete_offer.push({ delete: true, live: false, funnel_offers_id: e.funnel_offers_id });
            remove_childs(e.funnel_offers_id);
          });
        }
      });
    }
    function remove_last(id) {
      defaultData.forEach((element, i) => {
        if (element.funnel_offers_id === id) {
          defaultData.splice(i, 1);
          self.setState({ delete_offer_template: !self.state.delete_offer_template });
          self.state.delete_offer.push({ delete: true, live: false, funnel_offers_id: element.funnel_offers_id });
        }
      });
    }
    const offerUser_down = this.list_to_tree(defaultData);
    this.setState({
      delete_offer: this.state.delete_offer,
      offerUser_down: offerUser_down
    })
    this.setState({
      show_select: false,
      selectedDropdownId: false,
      addDownshellThankyou: false,
    });
  }
  /* edit offer or template */
  editOffer(ele) {
    this.setState({ iframeLoader: true, edit_funnel_offers_id: ele.funnel_offers_id });
    this.open_sampleModal("upsell", ele, false, parseInt(ele.section_id));
  }
  /* preview offer or template on new tab */
  previewOffer(ele) {
    let sendUrl;
    if (ele.temp_id) {
      sendUrl = config.iFrame_url + this.state.version + "/client/editor.php?app_hmac_auth=" + ele.app_hmac_auth;
    }
    else {
      if (parseInt(ele.section_id) === 24) {
        sendUrl = config.iFrame_url + this.state.version + "/client/editor/product_upsell_preview.php?app_hmac_auth=" + ele.app_hmac_auth;
      }
      else {
        sendUrl = config.iFrame_url + this.state.version + "/client/editor/product_recommendations_preview.php?app_hmac_auth=" + ele.app_hmac_auth;
      }
    }
    window.open(sendUrl, "_blank")
  }
  closeModal() {
    this.setState({ active: false });
  }
  open_sampleModal(val, offer_template, call_api, section_id) {
    const title = this.getCookie('rct_title');
    const self = this;
    if (call_api) {
      const data = {
        token: self.state.token,
        parent_id: self.state.myParent.funnel_offers_id || 0,
        direction: self.state.direction || 1,
        location_no: self.state.myParent.location_no,
        offer_name: __("Offer name"),
        store_client_id: this.state.store_client_id,
        shop: this.state.shop,
        rct_token: this.state.rct_token,
        get_lg: this.state.get_lg,
        get_theme_id: this.state.get_theme_id,
        product_title: title ? title : __("Most expensive product purchased"),
        app_language: this.state.app_language,
        theme_language: this.state.theme_language,
        app_hmac_auth: this.state.app_hmac_auth
      }
      switch (val) {
        case "upsell":
          data["section_id"] = 24;
          break;
        default:
          data["section_id"] = 25;
          break;
      }
      self.state.funnel_activity.push(val === "upsell" ? "Uspell" : "Downsell")
      self.service.post("/funnel/api/create_offer_template", data, function (status, data) {
        if (data.status === "success") {
          self.setState({ create_funnel_offers_id: data.data.funnel_offers_id })
          const sendData = self.state.defaultOffer;
          sendData.push(data.data);
          const list_to = self.list_to_tree(sendData);
          self.setState({
            offerUser_down: list_to,
            defaultOffer: sendData,
            defaultData: sendData
          });
          self.setState({ sampleActiveURL: data.url.replace("/@$@ver",self.state.version.toString()), sampleActive: true });
        } else { }
      });
    }
    else {
      let sendUrl;
      if (offer_template.temp_id) {
        sendUrl = config.iFrame_url + this.state.version + "/client/editor.php?app_hmac_auth=" + offer_template.app_hmac_auth
      }
      else {
        if (section_id === 24) {
          sendUrl = config.iFrame_url + this.state.version + "/client/editor/product_upsell_editor.php?app_hmac_auth=" + offer_template.app_hmac_auth;
        }
        else {
          sendUrl = config.iFrame_url + this.state.version + "/client/editor/product_recommendations_editor.php?app_hmac_auth=" + offer_template.app_hmac_auth;
        }
      }
      this.setState({ sampleActiveURL: sendUrl, sampleActive: true });
    }
    this.setState({ iframeLoader: true });
    this.setState({ active: false });
  }
  /* only for local to open local product upsell modal */
  open_upsellModal() {
    this.setState({ open_iframe: !this.state.open_iframe, iframeLoader: true });
  }
  /* only for local to close local product upsell modal */
  close_upsellModal() {
    this.setState({ open_iframe: !this.state.open_iframe, iframeLoader: false });
  }
  /* only for local to open local product recommendation modal */
  open_recommendationsModal() {
    this.setState({ open_recomm: !this.state.open_recomm, iframeLoader: true });
  }
  /* only for local to close local product recommendation modal */
  close_recommendationsModal() {
    this.setState({ open_recomm: !this.state.open_recomm, iframeLoader: false });
  }
  /* only for local to open dev template modal */
  open_devTemplateModal() {
    this.setState({ open_devTemplate: !this.state.open_devTemplate, iframeLoader: true });
  }
  /* only for local to close dev template modal */
  close_devTemplateModal() {
    this.setState({ open_devTemplate: !this.state.open_devTemplate, iframeLoader: false });
  }
  /* only for local to open local template */
  open_localTemplateModal() {
    this.setState({ open_localTemplate: !this.state.open_localTemplate, iframeLoader: true });
  }
  /* only for local to close local template */
  close_localTemplateModal() {
    this.setState({ open_localTemplate: !this.state.open_localTemplate, iframeLoader: false });
  }
  /* close premade template pop-up on click of add premade template  */
  handleClose_premade() {
    this.setState({ premadeTemplate: false, premadeTemplate_rightSide: false });
  }
  getCookie(c_name) {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(c_name + "=");
      if (c_start !== -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(";", c_start);
        if (c_end === -1) {
          c_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  }
  /**
   * IW0079
   * this function is called when user close pop-up 
   */
  close_sampleCloseModal() {
    const iframe = document.getElementById("Edit_offer");
    const warningMsg = iframe.getAttribute('is_save_editor');;
   /* now we have to check that user close pop-up without save or not if close pop-up without save then show warning msg pop-up*/
    if (warningMsg == "false") {
    this.setState({confirmationPhp : true})
   }
   else{
     this.close_sampleCloseModal_Final();
   }
  }
  /**
   * IW0079
   * this function is called when user close pop-up with save 
   */
  close_sampleCloseModal_Final(){
    if(this.state.confirmationPhp){
      this.setState({confirmationPhp:false})
    }
    this.getAllOfferList();
    this.setState({ active: false, templateActive: false});
    let offer_id;
    if (this.state.edit_funnel_offers_id) {
      offer_id = this.state.edit_funnel_offers_id;
    }
    else {
      offer_id = this.state.create_funnel_offers_id;
    }
    this.get_specific_offer_template(offer_id);
    this.setState({ sampleActive: false, iframeLoader: false, edit_funnel_offers_id: false, create_funnel_offers_id: false });
    document.cookie = "is_updated=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }
  close_TemplateModal_loader() {
    const warnMsg =this.getCookie("is_updated")
    if(warnMsg=== "TRUE"){
      this.setState({confirmationPhp : true})
     }
    else {
      this.setState({ templateActive: false, iframeLoader: false });
      this.getAllTemplate(this.state.selected_fall.value, this.state.is_fallback);
     }
    /* const offerUser_down = this.state.offerUser_down;
    const temp_title = this.getCookie('rct_template_title');
    const offer_id = this.state.create_funnel_template_id
    remove_childs(offerUser_down);
    function remove_childs(data) {
      data.forEach((element, i) => {

        if (element.temp_id === offer_id) {

          Object.assign(element, { name: temp_title })
        }
        else {
          remove_childs(element.child);
        }
      });
    } */
  }
  addDownshell(el, data, myParent) {
    this.setState({
      myParent: myParent ? myParent : this.state.offerUser_down[this.state.offerUser_down.length - 1],
      addDownshell: this.state.addDownshell + 1,
      direction: "1",
      selectedDropdownId: data ? data : false,
    });
    this.setState({ show_select: true, addDownshellThankyou: false, tmp: 'no' });
  }
  addDownshellThankyou(el, data, myParent) {
    this.setState({
      myParent: myParent ? myParent : this.state.offerUser_down[this.state.offerUser_down.length - 1],
      addDownshellThankyou: true, tmp: 'yes', show_select: false,
      direction: "1",
      selectedDropdownId: data ? data : false,
    });
  }
  addupshell(e, data, myParent) {
    this.setState({ myParent: myParent, addUpshell: this.state.addUpshell + 1, selectedDropdownId: data, direction: "0", tmp: 'no' });
    this.setState({ show_select: true });
  }
  thankyouClick(e, data, myParent) {
    this.setState({
      myParent: myParent,
      selectedDropdownId: data,
      direction: "0",
      tmp: 'yes'
    });
  } 
  /**
   *  IW0070
   *  Need this function in feature
   */
  // createTree(data, isSub, lev) {
  //   let level = lev || 0;
  //   let children = [];
  //   for (let i in data) {
  //     if (typeof (data[i].nested_values) === 'object') { /* Sub array found, build structure */
  //       children.push(
  //         <div class={"filter-group level-" + (level)}>
  //           <div class="filter-heading">{data[i].value}</div>
  //           {this.createTree(data[i].nested_values, true, level)}
  //         </div>
  //       );
  //     }
  //     else { /* No submenu, bottom of tree */
  //       children.push(
  //         <span key={i}>
  //           {data[i].value}
  //         </span>
  //       );
  //     }
  //   }
  //   return <div className='filter-body open'>{children}</div>;
  // }
  toggleSaveToaster() {
    this.setState({ show_toast: !this.state.show_toast });
  }
  getcustomer(shopName, value) {
    const getcustomerData = {
      word: value ? value : '',
      shop: shopName,
      action: "get_customer_data",
      token: this.state.token,
      app_language: this.state.app_language,
      theme_language: this.state.theme_language,
    }
    const self = this;
    const specific_customerData = []
    self.service.post(
      "/funnel/api/getSpecificCustomer", getcustomerData,
      function (status, data) {
        if (status === 200) {
          if (data?.data?.edges) {
            data.data.edges.map((el) => {
              const id = el.node.id.split('/');
              specific_customerData.push({
                value: id[id.length - 1],
                label: el.node.firstName || el.node.lastName ? el.node.firstName + " " + el.node.lastName : el.node.email
              })
            })
            self.setState({ specificCustomer: specific_customerData })
          }
        }
      })
  }
  getvendor(shopName, value) {
    const getvendorData = {
      word: value ? value : '',
      shop: shopName,
      action: "productVendors",
      token: this.state.token,
      app_language: this.state.app_language,
      theme_language: this.state.theme_language,
    }
    const self = this;
    const specific_vendor = []
    self.service.post(
      "/funnel/api/getSpecificCustomer", getvendorData,
      function (status, data) {
        if (status === 200) {
          self.setState({ vendorData: data.data.edges })
          if (data?.data?.edges) {
            data.data.edges.map((el) => {
              specific_vendor.push({
                value: el.node,
                label: el.node
              })
            })
            self.setState({ vendorData: specific_vendor })
          }
        }
      })
  }
  getproducttype(shopName) {
    const getproductTypeData = {
      shop: shopName,
      action: "productTypes",
      token: this.state.token,
      app_language: this.state.app_language,
      theme_language: this.state.theme_language,
    }
    const self = this;
    const product_typeData = []
    self.service.post(
      "/funnel/api/getSpecificCustomer", getproductTypeData,
      function (status, data) {
        if (status === 200) {
          self.setState({ productTypeData: data.data.edges })
          if (data?.data?.edges) {
            data.data.edges.map((el) => {
              product_typeData.push({
                value: el.node,
                label: el.node
              })
            })
            self.setState({ productTypeData: product_typeData })
          }
        }
      })
  }
  getcollection(shopName, value) {
    const getcollectionData = {
      word: value ? value : '',
      shop: shopName,
      action: "get_collection_list_data",
      token: this.state.token,
      app_language: this.state.app_language,
      theme_language: this.state.theme_language,
    }
    const self = this;
    const collection = []
    self.service.post(
      "/funnel/api/getSpecificCustomer", getcollectionData,
      function (status, data) {
        if (status === 200) {
          if(data?.data?.edges) {
          data.data.edges.map((el) => {
            const id = el.node.id.split('/');
            const img = el.node.image ? el.node.image.url : no_img_url
            collection.push({
              value: el.node.title,
              label: (<div className="label image_dropdown">
                <img src={el.node.image ? el.node.image.url : no_img_url} alt="flag" className="dropdown_image" />
                <span>{el.node.title}</span>
              </div>),
              id: id[id.length - 1],
              id_str: id[id.length - 1] + "@$@" + el.node.title.split(" ").join("+") + "@$@" + img
            })
            Object.assign(el.node, { id: id[id.length - 1] })
          })
          self.setState({ getCollection: collection })
          clearTimeout(timeout);
        }
        }
      })
  }
  getproduct(shopName, value) {
    const getproductData = {
      word: value ? value : '',
      shop: shopName,
      action: "get_product_list_data",
      token: this.state.token,
      app_language: this.state.app_language,
      theme_language: this.state.theme_language,
    }
    const self = this;
    const product = []
    self.service.post(
      "/funnel/api/getSpecificCustomer", getproductData,
      function (status, data) {
        if (status === 200) {
          if(data?.data?.edges) {
            data.data.edges.map((el) => {
              const id = el.node.id.split('/');
              const img = el.node.featuredImage && el.node.featuredImage.url ? el.node.featuredImage.url : no_img_url;
              product.push({
                value: el.node.title,
                label: (<div className="label image_dropdown">
                  <img src={el.node.featuredImage && el.node.featuredImage.url ? el.node.featuredImage.url : no_img_url} alt="flag" className="dropdown_image" />
                  <span>{el.node.title}</span>
                </div>),
                id: id[id.length - 1],
                id_str: id[id.length - 1] + "@$@" + el.node.title.split(" ").join("+") + "@$@" + img
              })
              Object.assign(el.node, { id: id[id.length - 1] })
            })
            self.setState({ getproduct: product })
            clearTimeout(timeout);
          }
        }
      })
  }
  getsurveylist(shopName) {
    const getsurveyData = {
      shop: shopName,
      action: "survey",
      token: this.state.token,
      app_language: this.state.app_language,
      theme_language: this.state.theme_language,
    }
    const self = this;
    const surveyList = []
    self.service.post(
      "/funnel/api/getSpecificCustomer", getsurveyData,
      function (status, data) {
        if (status === 200) {
          data.data.map((el) => {
            surveyList.push({
              value: el.survey_id,
              label: el.title
            })
          })
          if(data.data.length === 0) {
            surveyList.push({
              value: "Not found any survey",
              label: "Not found any survey",disabled: true
            })
          }
          self.setState({ suveytaken: surveyList, allsuveytaken: surveyList, allsurveyList: data.data })
        }
      })
  }
  getDefaultSurveyOptions(tags) {
    let defaultData = this.state.allsuveytaken
    if (defaultData) {
      const product = [];
      defaultData.forEach(el => {
        const found = el.value !== "Not found any survey" && tags.some(element => element.id.toString() === el.value.toString());
        if (found) {
          product.push(
            el.value
          )
        }
      });
      return product
    }
  }
  getDefaultProductOptions_product(tags,param) {
    const product = [];
    tags.forEach(element => {
      if (element.id) {
        const ele = element.id.split("@$@")
        const id = ele[0];
        const title = ele[1] ? ele[1].split("+").join(" ") : ""
        const img = ele[2];
        product.push({
          value: title,
          label: (<div className="label image_dropdown">
            <img src={img ? img : no_img_url} alt="flag" className="dropdown_image" />
            <span>{title}</span>
          </div>),
          id: id,
          id_str: element.id
        })
      }
    });
    if (param === "product-collection") {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.setState({ getCollection: product })
      }, 1000);
    }
    if (param === "specific-product") {
      this.setState({getproduct: product  })
    }
    return product;
  }
  getText(text) {
    let data;
    let allData = [...category, ...customer, ...order, ...product, ...other, ...countryData, ...currencyData, ...browserData, ...deviceData, ...operating_systemData, ...product_conditionsData, ...customer_conditionsData, ...custome_addressData, ...fraudAnalysisData, ...fulfillmentStatusData, ...fulfillmentStatusDataOne, ...weight_unitData, ...carrierData, ...ConditionData, ...ConditionDatas, ...paymentData, ...paymentSatatusData, ...shipmentData, ...salesData, ...orderStatusData, ...languageData]
    allData.forEach(element => {
      if (element.value === text) {
        data = element.label
      }
    });
    return data;
  }
  getSpecificName(flag, id) {
    const data = [];
    if (flag === "specific-customers") {
      if (this.state.specificCustomer) {
        this.state.specificCustomer.forEach(element => {
          const found = id.some(el => el.id === element.value);
          if (found) {
            data.push(element.label)
          }
        });
      }
    }
    else if (flag === "product-collection" || flag === "specific-product") {
      id.forEach(element => {
        if(element.id && element.id.split("@$@")[1]){
          data.push(element.id.split("@$@")[1].split("+").join(" "))
          }
      });
    }
    else if (flag === "survey-taken") {
      if (this.state.allsurveyList) {
        this.state.allsurveyList.forEach(element => {
          const found = id.some(el => el.id == element.survey_id);
          if (found) {
            data.push(element.title)
          }
        });
      }
    }
    else if (flag === "language") {
      this.state.languageData.forEach(element => {
        const found = id.some(el => el.id === element.value);
        if (found) {
          data.push(element.label)
        }
      });
    }
    else if (flag === "billing-country" || flag === "shipping-country") {
      this.state.countryData.forEach(element => {
        const found = id.some(el => el.id === element.value);
        if (found) {
          data.push(element.label)
        }
      });
    } 
    else if (flag == "currency") {
      this.state.currencyData.forEach(element => {
        const found = id.some(el => el.id === element.value);
        if (found) {
          data.push(element.label)
        }
      });
    }
    return data.toString();
  }
  save_comman(funnel_status, is_default, is_publish) {
    const self = this;
    this.setState({ butttonloading: true, isDefault: is_default, isbelowDefault: funnel_status })
    this.setState({ isDraft: false, draftEnable: false })
    /**
     * When remove any condition from trigger added on remove_my_trigger so when click on save mix that trigger at save time with remove  
     */
    const add = [], remove = [...this.state.remove_my_trigger];
    this.state.mainTrigger.forEach(ele => {
      ele.trigger.forEach(element => {
        if (element.parameters == undefined) {
          element.parameters = "";
        }
        if (element.categores !== element.category || element.parameters !== element.parameter) {
          if (element.category || element.parameter) {
            add.push({ categores: element.category, parameters: element.parameter, condition_type: element.condition_type })
          }
          if (element.categores || element.parameters) {
            remove.push({ categores: element.categores, parameters: element.parameters, condition_type: element.condition_type })
          }
        }
      });
    });
    /**
     * IW0070
     * Remove blank object from array object
     */
    const add_trigger = add.filter(function (el) {
      return el.categores;
    });
    const remove_trigger = remove.filter(function (el) {
      return el.categores;
    });
    const liveData = [];
    const child_node = [];
    this.state.offerUser_down.forEach(element => {
      child_node.push(element)
      if (element.status === "0") {
        liveData.push({ delete: false, live: true, funnel_offers_id: element.funnel_offers_id })
      }
      child(element)
    });
    function child(element) {
      element.child.forEach(el => {
        child_node.push(el);
        if (el.status === "0") {
          liveData.push({ delete: false, live: true, funnel_offers_id: el.funnel_offers_id });
        }
        if (el.child.length > 0) {
          child(el);
        }
      })
    }
    const funnel_activity_data = this.state.funnel_activity;
    let funnel_activity = funnel_activity_data.filter(function (item, pos) {
      return funnel_activity_data.indexOf(item) == pos;
    })
    let trigger_format = renderToString(this.getTriggerData());
    trigger_format = trigger_format.replaceAll("<!-- -->", "");
    trigger_format = trigger_format.replaceAll('data-reactroot=""', "");
    const funnel_data = {
      funnel_title: encode(this.state.funnel_title),
      app_status: funnel_status,
      mainTrigger: this.state.mainTrigger,
      fallback_page_id: this.state.selectedOption_fallback_id,
      is_fallback_change: this.state.default_selectedOption_fallback_id != this.state.selectedOption_fallback_id,
      offerUser_down: this.state.delete_offer,
      liveData: liveData,
      token: this.state.token,
      status: this.state.toggle_status === false ? "0" : "1",
      change_toggle: this.state.change_toggle,
      is_default: is_default,
      s_c_id: this.state.store_client_id,
      email: this.state.email,
      is_publish: is_publish,
      add_trigger: add_trigger,
      remove_trigger: remove_trigger,
      shop: this.state.shop,
      funnel_activity: funnel_activity.toString(),
      app_language: this.state.app_language,
      theme_language: this.state.theme_language,
      trigger_format: trigger_format
    }
    this.service.post("/funnel/api/saveoffer", funnel_data, function (status, data) {
      self.setState({
        remove_my_trigger: [{}],
        funnel_activity: []
      })
      if (status === 200 && data.status === "success") {
        if (is_publish) {
          self.setState({ show_toast: true, toast_message: data.message, toast_error: false, trigger_errmessage: '', butttonloading: false, isDraft: false, isPublish: false, publishEnable: false, draftEnable: false });
        } else {
          self.setState({ show_toast: true, toast_message: data.message, toast_error: false, trigger_errmessage: '', butttonloading: false });
        }
        self.getAllOfferList();
        self.getAllTemplate(false, true);
        self.getFunnelDetails(false)
      }
      else if (data.status === "showPopup") {
        self.setState({ butttonloading: false, trigger_errmessage: '', publishFirst: true })
        self.getAllOfferList();
        self.getAllTemplate(false, true);
        self.getFunnelDetails(false)
      }
      else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        self.setState({ show_toast: false, toast_message: data.message, toast_error: true, trigger_errmessage: data.message, butttonloading: false });
        self.setState({ isDraft: true, isPublish: false, draftEnable: true });
      }
    });
    return funnel_data;
  }
  save_funnel(e, funnel_status, is_default) {    
    if(this.state.funnel_title === ""){
      this.setState({show_toast:true ,toast_message :"Funnel title is required.", toast_error: true})
    }
    else{
      this.save_comman(funnel_status, is_default, false)
    }
  }
  publish_funnel(e, funnel_status, is_default) {
    this.save_comman(funnel_status, is_default, true)
    /**
     * Segment call when click on publish button
     * This is now on testing to gave access only two developer's store 
     */
    if (window.location.hostname === "www.stilyoapps.com" || window.location.hostname === "stilyoapps.com") {
      window.analytics.track('App enabled', {
        Email: this.state.email,
        Location: 'Funnel builder',
        myshopifyurl: this.state.shop,
        userId: this.state.store_client_id
      });
    }
  }
  /* **** TRIGGER  ****   
     when Change categores */
  selectCategoresChange = (selectCategores, id, i, j, isChange, el) => {
    if (isChange) {
      Object.assign(this.state.mainTrigger[j].trigger[i], { category: selectCategores, condition_values: "" });
      this.setState({ isDraft: true, isPublish: true, draftEnable: true });
    }
    this.setState({ selectCategores });
    Object.assign(this.state.mainTrigger[j].trigger[i], { category: selectCategores });
    let parametersData;
    if (id === "selectCategores") {
      switch (selectCategores) {
        case "all orders":
          this.parameterChange(el && el.parameters ? "" : "", 0, i, j, false, el);
          if (this.state.mainTrigger[j].trigger[0].category === "all orders") {
            if (this.state.mainTrigger[0].trigger[0].category === "all orders") {
              Object.assign(this.state, { mainTrigger: this.state.mainTrigger.slice(0, 1) })
              Object.assign(this.state.mainTrigger[0], { trigger: this.state.mainTrigger[0].trigger.slice(0, 1) })
            }
            else {
              Object.assign(this.state.mainTrigger[j], { trigger: this.state.mainTrigger[j].trigger.slice(0, 1) })
            }
          }
          else {
            Object.assign(this.state.mainTrigger[j].trigger[i], { parameter: '', conditions: "" });
          }
          break;
        case "customer":
          parametersData = customer;
          this.setState({
            parametersData: customer
          })
          this.parameterChange(el && el.parameters ? el.parameters : customer[0].value, 0, i, j, false, el);
          Object.assign(this.state.mainTrigger[j].trigger[i], { 'parametersData': customer, "default_data": customer });
          break;
        case "order":
          parametersData = order;
          this.setState({
            parametersData: order
          })
          this.parameterChange(el && el.parameters ? el.parameters : order[0].value, 0, i, j, false, el);
          Object.assign(this.state.mainTrigger[j].trigger[i], { 'parametersData': order, "default_data": order });
          break;
        case "product":
          parametersData = product;
          this.setState({
            parametersData: product
          })
          this.parameterChange(el && el.parameters ? el.parameters : product[0].value, 0, i, j, false, el);
          Object.assign(this.state.mainTrigger[j].trigger[i], { 'parametersData': product, "default_data": product });
          break;
        case "other":
          parametersData = other;
          this.setState({
            parametersData: other
          })
          this.parameterChange(el && el.parameters ? el.parameters : other[0].value, 0, i, j, false, el);
          Object.assign(this.state.mainTrigger[j].trigger[i], { 'parametersData': other, "default_data": other });
          break;
        default:
          break;
      }
      this.setState({ parameters: parametersData });
    }
  }
  fraudAnalysisChange = (fraudAnalysis, id, i, j, isChange) => {
    if (isChange) {
      this.setState({ isDraft: true, isPublish: true, draftEnable: true });
    }
    Object.assign(this.state.mainTrigger[j].trigger[i], { condition_values: fraudAnalysis });
  }
  fulfillmentStatusChange = (tags, i, j, isChange) => {
    if (isChange) {
      this.setState({ isDraft: true, isPublish: true, draftEnable: true });
    }
    const new_tags = []
    tags.forEach(element => {
      const selected_text = this.getText(element);
      new_tags.push({ id: element, "text": selected_text ? selected_text : element })
    });
    Object.assign(this.state.mainTrigger[j].trigger[i], { tags: new_tags });
    this.setState({ tags });
  }
  searchApi(e, param) {
    if (e.target.value && e.target.value.length > 3) {
      if (param === "specific-customers") {
        this.getcustomer(this.state.shop, e.target.value)
      }
      else if (param === "product-vendor") {
        setTimeout(() => {
          this.getvendor(this.state.shop, e.target.value)
        }, 3000);
      }
    }
  }
  searchCustomer(e, param) {
    if (e.length === 0) {
      if (param === "product-collection") {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.getcollection(this.state.shop, e)
        }, 1000);
      }
      else if (param === "specific-product") {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.getproduct(this.state.shop, e)
        }, 1000);
      }
    }
    if (e.length >= 3) {
      if (param === "product-collection") {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.getcollection(this.state.shop, e)
        }, 1000);
      }
      else if (param === "specific-product") {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.getproduct(this.state.shop, e)
        }, 1000);
      }
    }
  }
  productChnage = (tags, id, i, j, isChange) => {
    if(id === "specific-product"){
      setTimeout(() => {
        this.getproduct(this.state.shop)
      }, 3000);
    }
    else{
      setTimeout(() => {
        this.getcollection(this.state.shop)
      }, 3000);
    }
    if (tags) {
      if (isChange) {
        this.setState({ isDraft: true, isPublish: true, draftEnable: true });
      }
      const new_tags = []
      tags.forEach(element => {
        new_tags.push({ id: element.id_str })
      });
      Object.assign(this.state.mainTrigger[j].trigger[i], { tags: new_tags });
      this.setState({ tags });
    }
  }
  change_date_formate(date) {
    date = new Date(date);
    const yy = date.getFullYear();
    let mm = date.getMonth() + 1;
    mm = mm < 10 ? "0" + mm : mm;
    let dd = date.getDate();
    dd = dd < 10 ? "0" + dd : dd;
    return yy + "-" + mm + "-" + dd;
  }
  handleDateChange(startDate, id, i, j) {
    if (id === "startDate") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { "txt_valueFrom": this.change_date_formate(startDate) });
      this.setState({ startDate: startDate });
    }
    else if (id === "startDate_between") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { condition_values: this.change_date_formate(startDate), startDate: startDate, "txt_valueFrom": this.change_date_formate(startDate) });
      this.setState({ startDate: startDate });
    }
    else {
      Object.assign(this.state.mainTrigger[j].trigger[i], { condition_values: this.state.mainTrigger[j].trigger[i].condition_values + ' - ' + this.change_date_formate(startDate), endDate: startDate, "txt_valueTo": this.change_date_formate(startDate) });
      this.setState({ endDate: startDate });
    }
    this.setState({ isDraft: true, isPublish: true, draftEnable: true });
  }
  handleChangeCust(customer_name, id, i, j) {
    customer_name = customer_name.toLowerCase();
    if (id === "condition_values" || id === "billing-address-1" || id === "billing-address-2" || id === "customer-note" || id === "first-name" || id === "time" || id === "last-name" || id === "number-of-orders" || id === "shipping-province" || id === "harmonizedSystemCode" || id === "billing-province" || id === "shipping-method" || id === "time-since-last-order" || id === "shipping-address-1" || id === "shipping-address-2") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { "condition_values": customer_name });
    }
    if (id === "order-number" || id === "txt_value" || id === "discount-value" || id === "weight" || id === "number-orders" || id === "order-value" || id === "tax" || id === "birthday") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { "condition_values": customer_name });
    }
    else if (id === "specific-customers") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { "tags": [{ "text": customer_name, "id": customer_name }] });
    }
    else {
      Object.assign(this.state.mainTrigger[j].trigger[i], { "customer_name": customer_name });
    }
    this.setState({ customer_name });
    this.setState({ isDraft: true, isPublish: true, draftEnable: true });
  }
  handleChange_txt(e, id, i, j) {
    this.setState({ isDraft: true, isPublish: true, draftEnable: true });
    if (id === "txt_value") {
      const value = e.target.value;
      Object.assign(this.state.mainTrigger[j].trigger[i], { "txt_value": value });
    }
    if (id === "time") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { "txt_value": e.target.value });
    }
    else if (id === "txt_valueFrom") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { txt_valueFrom: e.target.value });
    }
    else if (id === "txt_valueTo") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { txt_valueTo: e.target.value });
    }
    else if (id === "fromtime") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { txt_valueFrom: e.target.value });
    }
    else if (id === "totime") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { txt_valueTo: e.target.value });
    }
    else if (id === "txt_rs") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { "txt_value": e.target.value });
    }
    else {
      Object.assign(this.state.mainTrigger[j].trigger[i], { id: id === 'startDate' || id === 'endDate' ? e : e.target.value });
    }
    const mainTrigger = this.state.mainTrigger
    this.setState({ mainTrigger });
  }
  weight_unitChange = (weight_unit, i, j, isChange) => {
    if (isChange) {
      this.setState({ isDraft: true, isPublish: true, draftEnable: true });
    }
    Object.assign(this.state.mainTrigger[j].trigger[i], { weight_unit: weight_unit });
    this.setState({ weight_unit });
  }
  parameterChange = (parameter, id, i, j, isChange, el) => {
    if (isChange) {
      Object.assign(this.state.mainTrigger[j].trigger[i], { condition_values: "", txt_valueFrom: "", txt_valueTo: "" });
    }
    Object.assign(this.state.mainTrigger[j].trigger[i], {
      back_condition_values: "",
      customer_name: "",
      from: parameter === "time-since-last-order" || parameter === "number-of-orders" ? this.state.mainTrigger[j].trigger[i].from : "",
      front_para: "",
      second_conditions: ((parameter === "birthday") && (this.state.mainTrigger[j].trigger[i].conditions === "less_then_ago@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "pass-x-time-ago@$@" + parameter)) || parameter === "phone-number" || parameter === "shipping-address-1" || parameter === "shipping-address-2" || parameter === "shipping-city" || parameter === "shipping-country" || parameter === "shipping-province" || parameter === "shipping-zip-code" || parameter === "company" || parameter === "time-since-last-order" || parameter === "discount-value" || parameter === "refund-value" || parameter === "available-at-sales-channel" || parameter === "charge-taxes-on-this-products" || parameter === "compare-at-price" || parameter === "barcode" || parameter === "product-collection" || parameter === "specific-product" || parameter === "harmonizedSystemCode" || parameter === "inventory-policy" || parameter === "overselling" || parameter === "product-description" || parameter === "product-price" || parameter === "product-tags" || parameter === "product-title" || parameter === "product-type" || parameter === "product-vendor" || parameter === "inventory-quantity" || parameter === "sku" || parameter === "variant-name" || parameter === "weight" || parameter === "cost-per-item" || parameter === "physical-product" ? this.state.mainTrigger[j].trigger[i].second_conditions : "",
      status: "",
      tags: parameter === "tags" || parameter === "survey-taken" || parameter === "first-name" || parameter === "last-name" || parameter === "email" || ((parameter === "birthday") && (this.state.mainTrigger[j].trigger[i].conditions === "is@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "is-not@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "between@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "not-between@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "before@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "after@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "is-empty@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "is-not-empty@$@" + parameter)) || parameter === "phone-number" || parameter === "shipping-city" || parameter === "shipping-country" || parameter === "billing-country" || parameter === "carrier" || parameter === "fulfillment-status" || parameter === "payment-method" || parameter === "payment-status" || parameter === "shipment-status" || parameter === "sales-channel" || parameter === "order-status" || parameter === "currency" || parameter === "language" || parameter === "available-at-sales-channel" || parameter === "product-type" || parameter === "specific-customers" || parameter === "product-vendor" || parameter === "shipping-zip-code" || parameter === "survey-answers" || parameter === "company" || parameter === "billing-address-first-name" || parameter === "billing-address-last-name" || parameter === "billing-city" || parameter === "billing-zip-code" || parameter === "billing-company" || parameter === "discount-code-used" || parameter === "order-id" || parameter === "order-name" || parameter === "order-notes" || parameter === "order-tags" || parameter === "shipping-address-first-name" || parameter === "shipping-address-last-name" || parameter === "shipping-company" || parameter === "tracking-number" || parameter === "barcode" || parameter === "product-description" || parameter === "product-tags" || parameter === "product-title" || parameter === "sku" || parameter === "variant-name" || parameter === "customer-created" || parameter === "order-date" || parameter === "product-collection" || parameter === "specific-product" || parameter === "operating-system" || parameter === "browser" || parameter === "device" ? this.state.mainTrigger[j].trigger[i].tags : [],
      condition_values: ((parameter === "birthday") && (this.state.mainTrigger[j].trigger[i].conditions === "less_then_ago@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "pass-x-time-ago@$@" + parameter)) || parameter === "customer-note" || parameter === "fraud-analysis" || parameter === "number-of-orders" || parameter === "shipping-province" || parameter === "total-item-bought" || parameter === "total-revenue-generated" || parameter === "billing-address-1" || parameter === "billing-address-2" || parameter === "billing-province" || parameter === "order-number" || parameter === "order-value" || parameter === "shipping-method" || parameter === "discount-value" || parameter === "tax-value" || parameter === "total-items-count" || parameter === "total-revenue" || parameter === "compare-at-price" || parameter === "harmonizedSystemCode" || parameter === "product-price" || parameter === "inventory-quantity" || parameter === "time-since-last-order" || parameter === "order-time" || parameter === "refund-value" || parameter === "shipping-value" || parameter === "weight" || parameter === "cost-per-item" || parameter === "shipping-address-1" || parameter === "shipping-address-2" || parameter === "user-impressions-for-this-order" || parameter === "user-impressions-for-all-orders" ? this.state.mainTrigger[j].trigger[i].condition_values : '',
      to: parameter === "time-since-last-order" || parameter === "number-of-orders" ? this.state.mainTrigger[j].trigger[i].to : "",
      weight_unit: parameter === "weight" ? this.state.mainTrigger[j].trigger[i].weight_unit : "",
      startDate: "",
      endDate: "",
      txt_valueFrom: ((parameter === "birthday") && (this.state.mainTrigger[j].trigger[i].conditions === "is@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "is-not@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "between@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "not-between@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "before@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "after@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "is-empty@$@" + parameter || this.state.mainTrigger[j].trigger[i].conditions === "is-not-empty@$@" + parameter)) || parameter === "customer-created" || parameter === "number-of-orders" || parameter === "time-since-last-order" || parameter === "total-item-bought" || parameter === "total-revenue-generated" || parameter === "compare-at-price" || parameter === "product-price" || parameter === "discount-value" || parameter === "order-date" || parameter === "order-time" || parameter === "order-value" || parameter === "refund-value" || parameter === "shipping-value" || parameter === "tax-value" || parameter === "total-items-count" || parameter === "total-revenue" || parameter === "inventory-quantity" || parameter === "cost-per-item" || parameter === "weight" || parameter === "user-impressions-for-this-order" || parameter === "user-impressions-for-all-orders" ? this.state.mainTrigger[j].trigger[i].txt_valueFrom : "",
      txt_valueTo: parameter === "birthday" || parameter === "customer-created" || parameter === "number-of-orders" || parameter === "time-since-last-order" || parameter === "total-item-bought" || parameter === "total-revenue-generated" || parameter === "compare-at-price" || parameter === "product-price" || parameter === "discount-value" || parameter === "order-date" || parameter === "order-time" || parameter === "order-value" || parameter === "refund-value" || parameter === "shipping-value" || parameter === "tax-value" || parameter === "total-items-count" || parameter === "total-revenue" || parameter === "inventory-quantity" || parameter === "cost-per-item" || parameter === "weight" || parameter === "user-impressions-for-this-order" || parameter === "user-impressions-for-all-orders" ? this.state.mainTrigger[j].trigger[i].txt_valueTo : ""
    })
    let conditionsDataOne;
    let is_isnot = [{ value: "is@$@" + parameter, label: __("Is") },
                    { value: "is-not@$@" + parameter, label: __("Is not") },]
    let contains_not =[{ value: "contains@$@" + parameter, label: __("Contains") },
                       { value: "does-not-contain@$@" + parameter, label: __("Does not contain") },]
    let is_empty = [{ value: "is-empty@$@" + parameter, label: __("Is empty") },
                    { value: "is-not-empty@$@" + parameter, label: __("Is not empty") },]
    let is_equalto = [{ value: "is-equal-to@$@" + parameter, label: __("Is equal to") },
                      { value: "is-not-equal-to@$@" + parameter, label: __("Is not equal to") },]
    let btw_not =[{ value: "between@$@" + parameter, label: __("Between") },
                  { value: "not-between@$@" + parameter, label: __("Not between") },]
    let large_small =[{ value: "larger-than@$@" + parameter, label: __("Larger than") },
                      { value: "smaller-than@$@" + parameter, label: __("Smaller than") },]
    let is_moreLess =[{ value: "larger-than@$@" + parameter, label: __("Is more than") },
                      { value: "smaller-than@$@" + parameter, label: __("Is less than") },]
    let start_end =[{ value: "starts-with@$@" + parameter, label: __("Starts with") },
                    { value: "ends-with@$@" + parameter, label: __("Ends with") },]
    let not_startEnd =[{ value: "starts-with@$@" + parameter, label: __("Starts with") },
                       { value: "does-not-start-with@$@" + parameter, label: __("Does not start with") },
                       { value: "ends-with@$@" + parameter, label: __("Ends with") },
                       { value: "does-not-end-with@$@" + parameter, label: __("Does not end with") },]
    let yes_no= [{ value: 'yes@$@' + parameter, label: __("Yes") },
                 { value: 'no@$@' + parameter, label: __("No") },]
    let before_after =[{ value: "before@$@" + parameter, label: __("Before") },
                       { value: "after@$@" + parameter, label: __("After") }]
    let less_more = [{ value: "before@$@" + parameter, label: __("Less than") },
                     { value: "after@$@" + parameter, label: __("More than") },]
    let pass_x =[{ value: "less_then_ago@$@" + parameter, label: __("Is in less then") },
                 { value: "pass-x-time-ago@$@" + parameter, label: __("Passed X time ago") },]
    let none = [{ value: "none@$@" + parameter, label: __("None") },]
    if (isChange) {
      this.setState({ isDraft: true, isPublish: true, draftEnable: true })
    }
    Object.assign(this.state.mainTrigger[j].trigger[i], { parameter: parameter })
    this.setState({ parameter })
    if (parameter === "specific-customers") {
      setTimeout(() => {
        this.getcustomer(this.state.shop)
      }, 1000);
    }
    if (parameter === "product-collection") {
      setTimeout(() => {
        this.getcollection(this.state.shop)
      }, 1000);
    }
    if (parameter === "product-vendor") {
      setTimeout(() => {
        this.getvendor(this.state.shop)
      }, 1000);
    }
    if (parameter === "product-type") {
      setTimeout(() => {
        this.getproducttype(this.state.shop)
      }, 1000);
    }
    if (parameter === "specific-product") {
      setTimeout(() => {
        this.getproduct(this.state.shop)
      }, 1000);
    }
    if (parameter === "survey-taken") {
      setTimeout(() => {
        this.getsurveylist(this.state.shop)
      }, 1000);
    }
    if (parameter === "accepts-marketing" || parameter === "charge-taxes-on-this-products" || parameter === "overselling" || parameter === "physical-product") {
      conditionsDataOne = [...yes_no];
    }
    else if (parameter === "first-name" || parameter === "last-name" || parameter === "phone-number" || parameter === "product-description") {
      conditionsDataOne = [...is_isnot, ...contains_not, ...start_end, ...is_empty]
    }
    else if (parameter === "billing-address-first-name" || parameter === "billing-address-last-name" || parameter === "company" || parameter === "shipping-address-2" || parameter === "email" || parameter === "customer-note" || parameter === "billing-address-2" || parameter === "billing-address-first-name" || parameter === "billing-company" || parameter === "discount-code-used" || parameter === "order-notes" || parameter === "order-tags" || parameter === "shipping-address-first-name" || parameter === "shipping-company" || parameter === "tracking-number" || parameter === "barcode" || parameter === "harmonizedSystemCode" || parameter === "product-type" || parameter === "sku" || parameter === "variant-name" || ((this.state.mainTrigger[j].trigger[i].category === "customer") && (parameter === "shipping-city"))) {
      conditionsDataOne = [...is_isnot, ...contains_not, ...is_empty]
    }
    else if (parameter === "tags" || parameter === "product-tags") {
      conditionsDataOne = [...is_equalto, ...contains_not, ...is_empty]
    }
    else if (parameter === "total-item-bought" ) {
      conditionsDataOne = [...is_equalto, ...btw_not, ...large_small]
    }
    else if (parameter === "total-revenue-generated") {
      conditionsDataOne = [...is_equalto, ...btw_not, ...is_moreLess]
    }
    else if (parameter === "time-since-last-order") {
      conditionsDataOne = [...btw_not, ...is_moreLess]
    }
    else if (parameter === "order-number") {
      conditionsDataOne = [...is_equalto, ...contains_not, ...not_startEnd]
    }
    else if (parameter === "shipping-method") {
      conditionsDataOne = [...is_equalto, ...contains_not, ...not_startEnd, ...is_empty]
    }
    else if (parameter === "shipping-zip-code" || parameter === "shipping-province" || parameter === "billing-address-1" || parameter === "billing-city" || parameter === "billing-province" || parameter === "billing-zip-code" || parameter === "order-id" || parameter === "order-name" || parameter === "shipping-address-1" || parameter === "shipping-address-last-name" || parameter === "shipping-city" ) {
      conditionsDataOne = [...is_isnot, ...contains_not]
    }
    else if (parameter === "number-of-orders" || parameter === "total-items-count" || parameter === "total-revenue" || parameter === "weight" || parameter === "user-impressions-for-this-order" || parameter === "user-impressions-for-all-orders") {
      conditionsDataOne = [...is_isnot, ...large_small, ...btw_not]
    }
    else if (parameter === "discount-value") {
      conditionsDataOne = [...is_equalto, ...large_small, ...btw_not]
    }
    else if (parameter === "refund-value") {
      conditionsDataOne = [...is_equalto, ...large_small, ...btw_not, ...is_empty]
    }
    else if (parameter === "tax-value" || parameter === "cost-per-item" || parameter === "shipping-value") {
      conditionsDataOne = [...is_isnot, ...large_small, ...btw_not, ...is_empty]
    }
    else if (parameter === "customer-created") {
      conditionsDataOne = [...is_isnot, ...btw_not, ...before_after]
    }
    else if (parameter === "order-date" || parameter === "order-time") {
      conditionsDataOne = [...is_isnot, ...before_after, ...btw_not]
    }
    else if (parameter === "order-value") {
      conditionsDataOne = [...is_isnot, ...less_more, ...btw_not]
    }
    else if (parameter === "product-price" || parameter === "inventory-quantity") {
      conditionsDataOne = [...is_isnot, ...is_moreLess, ...btw_not]
    }
    else if (parameter === "compare-at-price") {
      conditionsDataOne = [...is_isnot, ...is_moreLess, ...btw_not, ...is_empty]
    }
    else if (parameter === "birthday") {
      conditionsDataOne = [...is_isnot, ...btw_not, ...before_after, ...pass_x, ...is_empty];
    }
    else if (parameter === "survey-taken") {
      conditionsDataOne = [...is_isnot, ...none]
    }
    else if (parameter === "product-title") {
      conditionsDataOne = [...is_isnot, ...contains_not, ...start_end]
    }
    else if (parameter === "tax-settings") {
      conditionsDataOne = [{ value: "pays_tax@$@" + parameter, label: __("Pays tax") },
      { value: "tax_exempt@$@" + parameter, label: __("Tax exempt") }]
    }
    else if (parameter === "timeline-comments") {
      conditionsDataOne = [{ value: "is@$@" + parameter, label: __("Comment exists") },
      { value: "is-not@$@" + parameter, label: __("Comment doesn’t exists") }]
    }
    else if (parameter === "available-at-sales-channel") {
      conditionsDataOne = [{ value: "available-at@$@" + parameter, label: __("Available at") },
      { value: "not-available-at@$@" + parameter, label: __("Not available at") }]
    }
    else if (parameter === "product-collection") {
      conditionsDataOne = [{ value: "is-in-collections@$@" + parameter, label: __("Is in collections") },
      { value: "is-not-in-collections@$@" + parameter, label: __("Is not in collections") }]
    }
    else if (parameter === "inventory-policy") {
      conditionsDataOne = [{ value: "track-inventory@$@" + parameter, label: __("Track inventory") },
      { value: "dont-track-value@$@" + parameter, label: __("Dont track inventory") }];
    }
    else if (parameter === "survey-answers") {
      conditionsDataOne = [{ value: "is@$@" + parameter, label: __("Answer is") },
      { value: "is-not@$@" + parameter, label: __("Answer is not") },
      { value: "contains@$@" + parameter, label: __("Answer contains") },
      { value: "does-not-contain@$@" + parameter, label: __("Answer does not contain") },
      { value: "is-empty@$@" + parameter, label: __("Answer is empty") },
      { value: "is-not-empty@$@" + parameter, label: __("Answer is not empty") }]
    }
    else{
      conditionsDataOne = [...is_isnot]
    }
    if ((this.state.mainTrigger[j].trigger[i].category === "customer") && (parameter === "shipping-address-1" || parameter === "shipping-address-2" || parameter === "shipping-country" || parameter === "shipping-province" || parameter === "shipping-zip-code" || parameter === "company" || parameter === "shipping-city")) {
      Object.assign(this.state.mainTrigger[j].trigger[i], { 'secondconditionFinal': this.state.custome_addressData })
    }
    else if (parameter === "phone-number") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { 'secondconditionFinal': this.state.customer_conditionsData })
    }
    else if (parameter === "available-at-sales-channel" || parameter === "barcode" || parameter === "charge-taxes-on-this-products" || parameter === "compare-at-price" || parameter === "product-collection" || parameter === "specific-product" || parameter === "harmonizedSystemCode" || parameter === "inventory-policy" || parameter === "overselling" || parameter === "product-description" || parameter === "product-price" || parameter === "product-tags" || parameter === "product-title" || parameter === "product-type" || parameter === "product-vendor" || parameter === "inventory-quantity" || parameter === "sku" || parameter === "variant-name" || parameter === "cost-per-item" || parameter === "physical-product") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { 'secondconditionFinal': this.state.product_conditionsData })
    }
    else if (parameter === "weight") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { 'secondconditionFinal': this.state.product_conditionsData, 'weight_unitFinal': this.state.weight_unitData })
    }
    else if (parameter === "time-since-last-order") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { 'secondconditionFinal': this.state.ConditionDatas })
    }
    else if (parameter === "discount-value" || parameter === "refund-value") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { 'secondconditionFinal': this.state.ConditionData })
    }
    else if (parameter === "fraud-analysis") {
      Object.assign(this.state.mainTrigger[j].trigger[i], { secondconditionFinal: fraudAnalysisData })
    }
    if (conditionsDataOne.length) {
      Object.assign(this.state.mainTrigger[j].trigger[i], { 'conditionsDataOne': conditionsDataOne, conditionsDataOneFinal: conditionsDataOne })
      this.setState({ conditionsDataOne })
      if (el && el.conditions) {
        this.conditionsChange(el.conditions, 0, i, j, false)
      }
      else {
        this.conditionsChange(conditionsDataOne[0].value, 0, i, j, false)
        Object.assign(this.state.mainTrigger[j].trigger[i], { tags: [] })
      }
    }
    if (parameter === "weight") {
      if (el && el.weight_unit) {
        this.weight_unitChange(el.weight_unit, i, j, false)
      }
      else {
        this.weight_unitChange(this.state.weight_unitData[0].value, i, j, false)
      }
    }
    if ( parameter === "available-at-sales-channel" || parameter === "discount-value" || parameter === "refund-value" || parameter === "time-since-last-order" || parameter === "phone-number" || ((this.state.mainTrigger[j].trigger[i].category === "customer") && (parameter === "shipping-address-1" || parameter === "shipping-address-2" || parameter === "shipping-country" || parameter === "shipping-province" || parameter === "shipping-zip-code" || parameter === "company" || parameter === "shipping-city"))) {
      if (el && el.second_conditions) {
        this.second_conditionChange(el.second_conditions, i, j, false)
      }
      else {
        if(parameter === "phone-number"){
          this.second_conditionChange(this.state.customer_conditionsData[0].value, i, j, false)
        }
        else if(parameter === "time-since-last-order"){
          this.second_conditionChange(this.state.ConditionDatas[0].value, i, j, false)
        }
        else if(parameter === "discount-value" || parameter === "refund-value"){
          this.second_conditionChange(this.state.ConditionData[0].value, i, j, false)
        }
        else if(parameter === "available-at-sales-channel"){
          this.second_conditionChange(this.state.product_conditionsData[0].value, i, j, false)
        }
        else{
        this.second_conditionChange(this.state.custome_addressData[0].value, i, j, false)
        }
      }
    }
  }
  second_conditionChange = (Condition2, i, j, isChange) => {
    if (isChange) {
      this.setState({ isDraft: true, isPublish: true, draftEnable: true });
    }
    Object.assign(this.state.mainTrigger[j].trigger[i], { second_conditions: Condition2 });
    this.forceUpdate();
  }
  conditionsChange = (conditions, id, i, j, isChange) => {
    let parameters = this.state.parameter;
    let second_condition = this.state.mainTrigger[j].trigger[i].second_conditions;
    if (isChange) {
      this.setState({ isDraft: true, isPublish: true, draftEnable: true })
      if (parameters === "refund-value") {
        Object.assign(this.state.mainTrigger[j].trigger[i], {
          txt_valueFrom: conditions === "is-empty@$@" + parameters || conditions === "is-not-empty@$@" + parameters ? "" : this.state.mainTrigger[j].trigger[i].txt_valueFrom,
          txt_valueTo: conditions === "is-empty@$@" + parameters || conditions === "is-not-empty@$@" + parameters || conditions === "is@$@" + parameters || conditions === "is-not@$@" + parameters || conditions === "before@$@" + parameters || conditions === "after@$@" + parameters || conditions === "less_then_ago@$@" + parameters || conditions === "pass-x-time-ago@$@" + parameters || conditions === "larger-than@$@" + parameters || conditions === "smaller-than@$@" + parameters || conditions === "is-not-equal-to@$@" + parameters || conditions === "is-equal-to@$@" + parameters ? "" : this.state.mainTrigger[j].trigger[i].txt_valueTo,
          customer_name: conditions === "is-empty@$@" + parameters || conditions === "is-not-empty@$@" + parameters ? "" : this.state.mainTrigger[j].trigger[i].customer_name,
          second_conditions: conditions === "is-empty@$@" + parameters || conditions === "is-not-empty@$@" + parameters ? "" : this.state.mainTrigger[j].trigger[i].second_conditions,
          condition_values: conditions === "is-empty@$@" + parameters || conditions === "is-not-empty@$@" + parameters ? "" : this.state.mainTrigger[j].trigger[i].condition_values,
          tags: conditions === "is-empty@$@" + parameters || conditions === "is-not-empty@$@" + parameters ? [] : this.state.mainTrigger[j].trigger[i].tags,
        })
      }
      else if (parameters === "birthday" || parameters === "customer-created" || parameters === "order-date") {
        Object.assign(this.state.mainTrigger[j].trigger[i], {
          txt_valueFrom: "",
          txt_valueTo: "",
          condition_values: conditions === "less_then_ago@$@" + parameters || conditions === "pass-x-time-ago@$@" + parameters ? this.state.mainTrigger[j].trigger[i].condition_values : "",
          tags: [],
          second_conditions: conditions === "less_then_ago@$@" + parameters || conditions === "pass-x-time-ago@$@" + parameters ? second_condition : ""
        })
      }
      else {
        Object.assign(this.state.mainTrigger[j].trigger[i], {
          txt_valueFrom: conditions === "is-empty@$@" + parameters || conditions === "is-not-empty@$@" + parameters ? "" : this.state.mainTrigger[j].trigger[i].txt_valueFrom,
          txt_valueTo: conditions === "is-empty@$@" + parameters || conditions === "is-not-empty@$@" + parameters || conditions === "is@$@" + parameters || conditions === "is-not@$@" + parameters || conditions === "before@$@" + parameters || conditions === "after@$@" + parameters || conditions === "less_then_ago@$@" + parameters || conditions === "pass-x-time-ago@$@" + parameters || conditions === "larger-than@$@" + parameters || conditions === "smaller-than@$@" + parameters || conditions === "is-not-equal-to@$@" + parameters || conditions === "is-equal-to@$@" + parameters ? "" : this.state.mainTrigger[j].trigger[i].txt_valueTo,
          customer_name: conditions === "is-empty@$@" + parameters || conditions === "is-not-empty@$@" + parameters || conditions === "none@$@" + parameters ? "" : this.state.mainTrigger[j].trigger[i].customer_name,
          condition_values: conditions === "is-empty@$@" + parameters || conditions === "is-not-empty@$@" + parameters || conditions === "none@$@" + parameters ? "" : this.state.mainTrigger[j].trigger[i].condition_values,
          tags: conditions === "is-empty@$@" + parameters || conditions === "is-not-empty@$@" + parameters || conditions === "none@$@" + parameters ? [] : this.state.mainTrigger[j].trigger[i].tags,
        })
      }
    }
    if (parameters === "birthday") {
      Object.assign(this.state.mainTrigger[j].trigger[i], {
        'conditions': conditions,
        second_conditions: ((parameters === "birthday") && (conditions === "less_then_ago@$@" + parameters || conditions === "pass-x-time-ago@$@" + parameters)) ? second_condition : "",
        condition_values: ((parameters === "birthday") && (conditions === "less_then_ago@$@" + parameters || conditions === "pass-x-time-ago@$@" + parameters)) ? this.state.mainTrigger[j].trigger[i].condition_values : ""
      })
    }
    if ((parameters === "birthday") && (conditions === "less_then_ago@$@" + parameters || conditions === "pass-x-time-ago@$@" + parameters)) {
      Object.assign(this.state.mainTrigger[j].trigger[i], { 'secondconditionFinal': this.state.Condition2Data })
    }
    if ((parameters === "birthday") && (conditions === "less_then_ago@$@" + parameters || conditions === "pass-x-time-ago@$@" + parameters)) {
      if (second_condition) {
        this.second_conditionChange(second_condition, i, j, false)
      }
      else {
        this.second_conditionChange(this.state.Condition2Data[0].value, i, j, false)
      }
    }
    Object.assign(this.state.mainTrigger[j].trigger[i], { 'conditions': conditions })
    this.setState({ conditions })
  }
  addTrigger(e, j, i) {
    let temp = this.state.mainTrigger
    temp[j].trigger.push({})
    this.setState({ mainTrigger: temp })
    this.selectCategoresChange(category[1].value, "selectCategores", i + 1, j, true)
    setTimeout(() => {
      this.setState({ myTrigger: [...this.state.myTrigger, { condition_type: "AND" }] })
      Object.assign(this.state.mainTrigger[j].trigger[i], { condition_type: "AND" })
      Object.assign(this.state.mainTrigger[j].trigger[i + 1], { condition_type: "OR" })
    }, 100);
  }
  OrTrigger(e, j) {
    this.setState({ mainTrigger: [...this.state.mainTrigger, { trigger: [{ category: "all orders", condition_type: "OR" }] }] })
    setTimeout(() => {
      Object.assign(this.state.mainTrigger[j].trigger[this.state.mainTrigger[j].trigger.length - 1], { condition_type: "OR" })
      this.selectCategoresChange(category[1].value, "selectCategores", 0, j + 1, true)
      this.setState({ myTrigger: [...this.state.myTrigger, { condition_type: "OR" }] })
    }, 1);
  }
  deleteTrigger(e, ele, i, j) {
    const temp = this.state.mainTrigger;
    this.setState({ remove_my_trigger: [...this.state.remove_my_trigger, { categores: this.state.mainTrigger[j].trigger[i].category, parameters: this.state.mainTrigger[j].trigger[i].parameter }] })
    temp[j].trigger.splice(i, 1)
    this.setState({ mainTrigger: temp })
    this.setState({ myTrigger: [...this.state.myTrigger, {}], isDraft: true, isPublish: true, draftEnable: true })
    Object.assign(this.state.mainTrigger[j].trigger[i > 0 ? i - 1 : i], {
      condition_type: ""
    })
    if (i === this.state.mainTrigger[j].trigger.length) {
      Object.assign(this.state.mainTrigger[j].trigger[i > 0 ? i - 1 : i], {
        condition_type: "OR"
      })
    }
    else if (this.state.mainTrigger[j].trigger.length === 1) {
      Object.assign(this.state.mainTrigger[j].trigger[0], {
        condition_type: "OR"
      })
    }
    else if (i !== this.state.mainTrigger[j].trigger.length) {
      Object.assign(this.state.mainTrigger[j].trigger[i > 0 ? i - 1 : i], {
        condition_type: "AND"
      })
    }
  }
  deleteMainTrigger(e, j) {
    let data = [];
    this.state.mainTrigger[j].trigger.forEach(element => {
      data.push({ categores: element.category, parameters: element.parameter })
    });
    const new_data = [...data, ...this.state.remove_my_trigger]
    this.setState({ remove_my_trigger: new_data })
    this.setState({
      mainTrigger: this.state.mainTrigger.filter(function (person, i) {
        return i !== j
      }),
      isDraft: true,
      isPublish: true,
      draftEnable: true
    });
    Object.assign(this.state.mainTrigger[j - 1].trigger[this.state.mainTrigger[j - 1].trigger.length - 1], {
      condition_type: ""
    })
    if (j !== this.state.mainTrigger.length) {
      Object.assign(this.state.mainTrigger[j - 1].trigger[this.state.mainTrigger[j - 1].trigger.length - 1], {
        condition_type: "OR"
      })
    }
  }
  /* dropDown onClose event in select */
  closeshowDropdown() { }
  openParameter(i, j) {
    const parametersData = this.state.mainTrigger[j].trigger[i].parametersData;
    const type = this.state.mainTrigger[j].trigger[i].default_data;
    Object.assign(this.state.mainTrigger[j].trigger[i], { 'parametersData': type });
    this.setState({ parametersData });
  }
  accordion_handleToggle(e, element, i, isChild) {
    const self = this;
    const funnel_offers_id = element.funnel_offers_id;
    this.setState({
      expandView: element.open ? true : ''
    })
    this.setState(prevState => {
      return {
        offerUser_down: prevState.offerUser_down.map((el) =>
          el.funnel_offers_id === funnel_offers_id ?
            { ...el, open: !el.open}
            :
            getChildisOpenorNot(el)
        )
      }
    });
    function getChildisOpenorNot(el) {
      Object.assign({}, el, {
        child: el.child.map((it) => {
          if (it.funnel_offers_id === funnel_offers_id)
            it.open = !it.open
          else
            getChildisOpenorNot(it);
          return it;
        })
      })
      return el
    }
    if (element.section_id) {
      if (!element.annotationSet) {
        Object.assign(element, { annotationSet: true })
        this.get_specific_offer_template(element.id)
      }
    }
    else {
      if (!element.annotationSet) {
        this.service.get('/funnel/api/getAnaliticsThankyou?page_id=' + element.temp_id + '&token=' + this.state.token + '&table_selector=' + this.state.table_selector + '&scid=' + this.state.scid + "&app_language=" + this.state.app_language + "&theme_language=" + this.state.theme_language, function (status, data) {
          if (status === 200) {
            if (data.data) {
              if (isChild && element.parent_id) {
                self.setState(prevState => {
                  return {
                    offerUser_down: prevState.offerUser_down.map((el, j) =>
                      j === i ?
                        Object.assign({}, el, {
                          child: el.child.map((it) => {
                            if (it.funnel_offers_id === element.funnel_offers_id) {
                              it.impressions = data.data.impressions
                              it.orders = data.data.orders
                              it.Revenue = data.data.Revenue
                              it.annotationSet = true
                              it.CVR = data.data.CVR
                            }
                            child: it.child.map((it) => {
                              if (it.funnel_offers_id === element.funnel_offers_id) {
                                it.impressions = data.data.impressions
                                it.orders = data.data.orders
                                it.Revenue = data.data.Revenue
                                it.annotationSet = true
                                it.CVR = data.data.CVR
                              }
                              return it;
                            })
                            return it;
                          })
                        })
                        :
                        el
                    )
                  };
                });
              }
              else {
                self.setState(prevState => ({
                  offerUser_down: prevState.offerUser_down.map(
                    (el) => el.funnel_offers_id === element.funnel_offers_id ? {
                      ...el, impressions: data.data.impressions,
                      orders: data.data.orders,
                      Revenue: data.data.Revenue,
                      annotationSet: true,
                      CVR: data.data.CVR
                    } : el
                  )
                }))
              }
            }
          }
        })
      }
    }
  }
  /* **** end TRIGGER  **** */
  compactview_btn() {


    this.setState({
      expandView: true,
      right_arrowIcon: true,
      fallback_active: false
    })
    this.setState(prevState => {
      return {
        offerUser_down: prevState.offerUser_down.map((el) =>
          getChildisOpenorNot(el)
        )
      }
    });
    function getChildisOpenorNot(el) {
      el.open = false
      Object.assign({}, el, {
        child: el.child.map((it) => {
          it.open = false
          getChildisOpenorNot(it)
          return it;
        })
      })
      return el
    }
  }
  expandView() {
    this.setState({
      expandView: false,
      right_arrowIcon: false,
      fallback_active: true
    })
    this.setState(prevState => {
      return {
        offerUser_down: prevState.offerUser_down.map((el) =>
          getChildisOpenorNot(el)
        )
      }
    });
    function getChildisOpenorNot(el) {
      el.open = true
      Object.assign({}, el, {
        child: el.child.map((it) => {
          it.open = true
          getChildisOpenorNot(it)
          return it;
        })
      })
      return el
    }
  }
  anootationDetails(ele, i, val, k, selectedDropdownId, direction, tmp) {
    return (
      <>
        {ele.temp_id === 0 ?
          <div className={ele.temp_id !== 0 ? "offer_section rmv_after_before" : "offer_section"}>
            <AnootationDetails ele={ele} i={i} direction={direction} tmp={tmp} selectedDropdownId={selectedDropdownId} val={val} k={k} accordion_handleToggle={(e) => this.accordion_handleToggle(e, ele, i, false, k)} />
            <ActionButton editOffer={(e) => this.editOffer(ele)} previewOffer={(e) => this.previewOffer(ele)} delete_offer_templateModal={(e) => this.delete_offer_templateModal(ele, true)} />
          </div>
          :
          /* thank you page accordian */
          <div className={ele.temp_id !== 0 ? "offer_section rmv_after_before" : "offer_section"}>
            <AnootationDetailsThankyou ele={ele} i={i} direction={direction} tmp={tmp} selectedDropdownId={selectedDropdownId} val={val} k={k} accordion_handleToggle={(e) => this.accordion_handleToggle(e, ele, i, true, k)} />
            <ActionButtonThankyou editOffer={(e) => this.editOffer(ele)} delete_offer_templateModal={(e) => this.delete_offer_templateModal(ele, false)} />
          </div>
        }
      </>
    );
  }
  child_node(data) {
    let children = [];
    data.forEach((ele, i) => {
      children.push(
        <div key={i} className={ele.temp_id !== 0 ? "up_space rmv_after_before remove_margin_bottom" : "up_space"}>
          <div className="dynamic_append">
            {ele.temp_id !== 0 ? <div className="tooltip_title"><h3 className="accordian_main">{__('thank you page')}</h3> <span className="tooltiptext down_tooltip">{__('thank you page')}</span></div> : <div className="tooltip_title"><h3 className="accordian_main">{ele.p_offer_name || ele.c_offer_name}</h3><span className="tooltiptext down_tooltip">{ele.p_offer_name || ele.c_offer_name}</span></div>}
            <div className="dynamic_append_inner">
              {this.anootationDetails(ele, i, true, 0, this.state.selectedDropdownId, this.state.direction, this.state.tmp)}
              {ele.temp_id === 0 &&
                <div>
                  {ele.rightchild.length ?
                    <p className= "span_txt_indicator green_badge">{ele.rightchild[0].temp_id !== 0 ? __('accept') : __('accept')}</p>
                    :
                  <p className={"span_txt_indicator green_badge"}>
                    {
                        this.state.tmp === "yes" ?
                          __('accept')
                          :
                        __('accept')
                      }
                    </p>
                  }
                </div>
              }
              <div className={ele.section_id !== 0 ? "next_right_section rmv_after_before" : "next_right_section"} >
                {ele.rightchild.length > 0 ?
                  this.child_node(ele.rightchild)
                  :
                  this.state.createOfferLoader && this.state.selectedDropdownId === ele.funnel_offers_id && this.state.direction === "0"
                    ?
                    <>
                      <LoaderSection createOfferLoader={this.state.createOfferLoader} />
                    </>
                    :
                    ele || (ele && ele.length <= 0)
                      ?
                      this.state.selectedDropdownId === ele.funnel_offers_id && this.state.direction === "0"
                        ?
                        this.state.tmp === "yes"
                          ?
                          <Dynamicthankyou templateDate={this.state.template_data} wrapperRef={this.wrapperRef} selectedOption={this.state.selectedOption} handleChange_thanks={this.handleChange_thanks} formatOptionLabel={formatOptionLabel} />
                          :
                          <DynamicAdd wrapperRef={this.wrapperRef} selectedOption={this.state.selectedOption} handleChange={this.handleChange} offer_options={this.state.offer_options} closeshowDropdown={this.closeshowDropdown} show_select={this.state.show_select} formatOptionLabel={formatOptionLabel} />
                        :
                        <>
                          {ele.temp_id !== 0 ? "" : <NextSection upElement={ele} upValue="up" addupshell={(e) => this.addupshell(e, ele.funnel_offers_id, ele)} thankyouClick={(e) => this.thankyouClick(e, ele.funnel_offers_id, ele)} addDownshell={(e) => this.addDownshell(e, ele.funnel_offers_id, ele)} addDownshellThankyou={(e) => this.addDownshellThankyou(e, ele.funnel_offers_id, ele)} />}
                        </>
                      :
                      ""
                }
              </div>
            </div>
          </div>
          {ele.downchild.length > 0 ?
            this.child_node(ele.downchild)
            :
            <div className={ele.temp_id !== 0 ? "next_bottom_section right_down_section rmv_after_before" : "next_bottom_section right_down_section"}>
              {
                this.state.offerUser_down[this.state.offerUser_down.length - 1] && (
                  <div className="next_bottom_section">
                    { this.state.createOfferLoader && this.state.selectedDropdownId === ele.funnel_offers_id && this.state.direction === "1" ?
                      <>
                        <LoaderSection createOfferLoader={this.state.createOfferLoader} />
                      </>
                      :
                      this.state.selectedDropdownId === ele.funnel_offers_id && this.state.direction === "1" ?
                        this.state.addDownshellThankyou ?
                          <Dynamicthankyou templateDate={this.state.template_data} wrapperRef={this.wrapperRef} selectedOption={this.state.selectedOption} handleChange_thanks={this.handleChange_thanks} formatOptionLabel={formatOptionLabel} />
                          :
                          <DynamicAdd wrapperRef={this.wrapperRef} selectedOption={this.state.selectedOption} handleChange={this.handleChange} offer_options={this.state.offer_options} closeshowDropdown={this.closeshowDropdown} show_select={this.state.show_select} formatOptionLabel={formatOptionLabel} />
                        :
                        <>
                          {ele.temp_id !== 0 ? "" : <NextSection upElement={ele} upValue="down" addupshell={(e) => this.addupshell(e, ele.funnel_offers_id, ele)} thankyouClick={(e) => this.thankyouClick(e, ele.funnel_offers_id, ele)} addDownshell={(e) => this.addDownshell(e, ele.funnel_offers_id, ele)} addDownshellThankyou={(e) => this.addDownshellThankyou(e, ele.funnel_offers_id, ele)} />}
                        </>
                    }
                  </div>
                )
              }
            </div>
          }
        </div>
      )
    });
    return <>{children}</>
  }
  rightCollpase() {
    this.setState({ right_arrowIcon: !this.state.right_arrowIcon })
  }
  onMyFrameLoad() {
    this.setState({ iframeLoader: false })
  }
  doubleclick() {
    this.setState({ showInput: true })
  }
  handleChangefunnelTitle(title) {
    this.setState({ funnel_title: title.target.value, isDraft: true, isPublish: true, rmvBoader: false, draftEnable: true })
  }
  openhelpvidio() {
    this.setState({ helpVidio: !this.state.helpVidio })
  }
  openWarningMsg(){
    this.setState({confirmationPhp : false})
  }
  handleChnageappfirstPopup() {
    this.setState({ publishFirst: !this.state.publishFirst })
  }
  redirecttoDashboard() {
    window.location.href = config.iFrame_url + this.state.version + "/client/" + "index" + ".php?app_hmac_auth=" + this.state.token;
  }
  changeToggle() {
    this.setState({
      toggle_status: !this.state.toggle_status,
      change_toggle: this.state.toggle_status === this.state.new_toggle_status,
      isDraft: true,
      draftEnable: true
    })
  }
  /**
   * IW0079
   * this function is used to convert premade template description percentage value 
   */
  premadeDescChasnge(str, percentage) {
    str = str.split("{{")
    for (var i = 1; i < str.length; i++) {
      let per = str[i].substring(0, str[i].indexOf('%'));
      let newPercentage = (per * percentage) / 100
      let res = str[i].split("}}")
      res[0] = newPercentage
      str[i] = res.join("")
    }
    str = str.join("")
    return str
  }
  /**
   * IW0079
   * this is used to change the premade template description according to the percentage value
   */
  valueChange(e) {
    let percentage = e
    if (percentage > 100) {
      percentage = "100"
    }
    else if (percentage < 0) {
      percentage = "0";
    }
    this.setState({ percentage: percentage })
    let description = this.premadeDescChasnge(this.state.premadeDesc, percentage)
    Object.assign(this.state.premadTmp[0], { 'description': description });
  }
  check_pp_app_status(flag) {
    const self = this;
    this.service.get("/funnel/api/check_pp_app_status?token=" + this.state.token + "&app_language=" + this.state.app_language + "&theme_language=" + this.state.theme_language, function (status, data) {
      if (status === 200 && data.status === "success") {
        self.setState({ check_pp_app_status: data.data });
        if (flag) {
          self.setState({
            check_status_popup_view: true,
            app_title: data.app_title
          })
        }
        else {
          self.setState({
            app_title: data.app_title
          })
        }
      }
      else {
        self.setState({ check_pp_app_status: 0 });
      }
    });
  }
  check_status_popup_view() {
    this.setState({ check_status_popup_view: false })
  }
  getBrowserName(name, flag) {
    let data = "";
    if (flag == "operating-system") {
      data = operating_systemData
      var browserDataName = data.filter(x => x.label.toLowerCase() === name.toLowerCase());
    return browserDataName[0].label;
    }
    else if (flag == "browser") {
      data = browserData
      var browserDataName = data.filter(x => x.label.toLowerCase() === name.toLowerCase() || x.value.toLowerCase() === name.toLowerCase());
      return browserDataName[0].label;
    }
    else if (flag == "device") {
      data = deviceData
      var browserDataName = data.filter(x => x.label.toLowerCase() === name.toLowerCase());
      return browserDataName[0].label;
    }
  }
  getTriggerData() {
    return (
      this.state.mainTrigger.map((main_tooltip, i) => (
        <div key={i}>
          {main_tooltip.trigger.map((tooltip, j) => (
            <div key={j}>
              {tooltip.category === "all orders" ? __("All orders")
                : <>
                  {tooltip.parameter === "order-value" || tooltip.parameter === "birthday" || tooltip.parameter === "customer-created" || tooltip.parameter === "number-of-orders" || tooltip.parameter === "time-since-last-order" || tooltip.parameter === "total-item-bought" || tooltip.parameter === "total-revenue-generated" || tooltip.parameter === "discount-value" || tooltip.parameter === "fraud-analysis" || tooltip.parameter === "order-date" || tooltip.parameter === "order-time" || tooltip.parameter === "refund-value" || tooltip.parameter === "shipping-value" || tooltip.parameter === "tax-value" || tooltip.parameter === "total-items-count" || tooltip.parameter === "total-revenue" || tooltip.parameter === "compare-at-price" || tooltip.parameter === "product-price" || tooltip.parameter === "inventory-quantity" || tooltip.parameter === "weight" || tooltip.parameter === "cost-per-item" || tooltip.parameter === "user-impressions-for-this-order" || tooltip.parameter === "user-impressions-for-all-orders" || tooltip.parameter === "operating-system" || tooltip.parameter === "browser" || tooltip.parameter === "device"
                    ?
                    <>
                      {tooltip.parameter === "order-value" || tooltip.parameter === "birthday" || tooltip.parameter === "customer-created" || tooltip.parameter === "number-of-orders" || tooltip.parameter === "time-since-last-order" || tooltip.parameter === "total-item-bought" || tooltip.parameter === "total-revenue-generated" || tooltip.parameter === "order-date" || tooltip.parameter === "order-time" || tooltip.parameter === "discount-value" || tooltip.parameter === "refund-value" || tooltip.parameter === "shipping-value" || tooltip.parameter === "tax-value" || tooltip.parameter === "total-items-count" || tooltip.parameter === "total-revenue" || tooltip.parameter === "fraud-analysis" || tooltip.parameter === "user-impressions-for-this-order" || tooltip.parameter === "user-impressions-for-all-orders"
                        ?
                        <>
                          {(tooltip.parameter === "fraud-analysis" || ((tooltip.parameter === "birthday") && (tooltip.conditions === "less_then_ago@$@" + tooltip.parameter || tooltip.conditions === "pass-x-time-ago@$@" + tooltip.parameter)))
                            ?
                            <>
                              {tooltip.parameter === "fraud-analysis"
                                ?
                                <p>
                                  {tooltip.category && category ? category.map(((e) => (e.value === tooltip.category ? e.label : ""))).join('') : ""}
                                  {tooltip.parameter && tooltip.parametersData ? " -> " + tooltip.parametersData.map(((e) => (e.value === tooltip.parameter ? e.label : ""))).join('') : ""}
                                  {tooltip.conditions && tooltip.conditionsDataOneFinal ? " -> " + tooltip.conditionsDataOneFinal.map(((e) => (e.value === tooltip.conditions ? e.label : ""))).join('') : ""}
                                  {tooltip.condition_values ? " -> " + tooltip.condition_values : "" + tooltip && tooltip.tags && tooltip.tags.length ? tooltip.tags.length > 0 ? " -> " : "" : ""}
                                </p>
                                :
                                <p>
                                  {tooltip.category && category ? category.map(((e) => (e.value === tooltip.category ? e.label : ""))).join('') : ""}
                                  {tooltip.parameter && tooltip.parametersData ? " -> " + tooltip.parametersData.map(((e) => (e.value === tooltip.parameter ? e.label : ""))).join('') : ""}
                                  {tooltip.conditions && tooltip.conditionsDataOneFinal ? " -> " + tooltip.conditionsDataOneFinal.map(((e) => (e.value === tooltip.conditions ? e.label : ""))).join('') : ""}
                                  {(tooltip.second_conditions && tooltip.secondconditionFinal)?<>{tooltip.parameter === "refund-value" &&  (tooltip.conditions === "is-empty@$@refund-value" || tooltip.conditions === "is-not-empty@$@refund-value") ? "" : " -> " +  tooltip.secondconditionFinal.map(((e) => (e.value === tooltip.second_conditions ? e.label : ""))).join('')} </> : ""}
                                  {tooltip.condition_values ? " -> " + tooltip.condition_values : "" + tooltip && tooltip.tags && tooltip.tags.length ? tooltip.tags.length > 0 ? " -> " : "" : ""}
                                </p>
                              }
                            </>
                            :
                            <p>
                              {tooltip.category && category ? category.map(((e) => (e.value === tooltip.category ? e.label : ""))).join('') : ""}
                              {tooltip.parameter && tooltip.parametersData ? " -> " + tooltip.parametersData.map(((e) => (e.value === tooltip.parameter ? e.label : ""))).join('') : ""}
                              {tooltip.conditions && tooltip.conditionsDataOneFinal ? " -> " + tooltip.conditionsDataOneFinal.map(((e) => (e.value === tooltip.conditions ? e.label : ""))).join('') : ""}
                              {(tooltip.second_conditions && tooltip.secondconditionFinal)?<>{tooltip.parameter === "refund-value" &&  (tooltip.conditions === "is-empty@$@refund-value" || tooltip.conditions === "is-not-empty@$@refund-value") ? "" : " -> " +  tooltip.secondconditionFinal.map(((e) => (e.value === tooltip.second_conditions ? e.label : ""))).join('')} </> : ""}
                              {tooltip.txt_valueFrom ? " -> " + tooltip.txt_valueFrom : "" + tooltip && tooltip.tags && tooltip.tags.length ? tooltip.tags.length > 0 ? " " : "" : ""}
                              {tooltip.txt_valueTo ? " - " + tooltip.txt_valueTo : "" + tooltip && tooltip.tags && tooltip.tags.length ? tooltip.tags.length > 0 ? " " : "" : ""}
                            </p>
                          }
                        </>
                        :
                        <>
                          {tooltip.parameter === "operating-system" || tooltip.parameter === "browser" || tooltip.parameter === "device"
                            ?
                            <p>
                              {tooltip.category && category ? category.map(((e) => (e.value === tooltip.category ? e.label : ""))).join('') : ""}
                              {tooltip.parameter && tooltip.parametersData ? " -> " + tooltip.parametersData.map(((e) => (e.value === tooltip.parameter ? e.label : ""))).join('') : ""}
                              {tooltip.condition_values ? " -> " + tooltip.condition_values : "" + tooltip && tooltip.tags && tooltip.tags.length ? tooltip.tags.length > 0 ? " -> " : "" : ""}
                              {tooltip && tooltip.tags ? Array.prototype.map.call(tooltip.tags, s => this.getBrowserName(s.text,tooltip.parameter)).toString() : ""}
                            </p>
                            :
                            <p>
                              {tooltip.category && category ? category.map(((e) => (e.value === tooltip.category ? e.label : ""))).join('') : ""}
                              {tooltip.parameter && tooltip.parametersData ? " -> " + tooltip.parametersData.map(((e) => (e.value === tooltip.parameter ? e.label : ""))).join('') : ""}
                              {(tooltip.second_conditions && tooltip.secondconditionFinal)?<>{tooltip.parameter === "refund-value" &&  (tooltip.conditions === "is-empty@$@refund-value" || tooltip.conditions === "is-not-empty@$@refund-value") ? "" : " -> " +  tooltip.secondconditionFinal.map(((e) => (e.value === tooltip.second_conditions ? e.label : ""))).join('')} </> : ""}
                              {tooltip.conditions && tooltip.conditionsDataOneFinal ? " -> " + tooltip.conditionsDataOneFinal.map(((e) => (e.value === tooltip.conditions ? e.label : ""))).join('') : ""}
                              {tooltip.txt_valueFrom ? " -> " + tooltip.txt_valueFrom : "" + tooltip && tooltip.tags && tooltip.tags.length ? tooltip.tags.length > 0 ? " - " : "" : ""}
                              {tooltip.txt_valueFrom && tooltip.weight_unit && tooltip.weight_unitFinal ? " " + tooltip.weight_unitFinal.map(((e) => (e.value === tooltip.weight_unit ? e.label : ""))).join('') : ""}
                              {tooltip.txt_valueTo ? " - " + tooltip.txt_valueTo : "" + tooltip && tooltip.tags && tooltip.tags.length ? tooltip.tags.length > 0 ? " - " : "" : ""}
                              {tooltip.txt_valueTo && tooltip.weight_unit && tooltip.weight_unitFinal ? " " + tooltip.weight_unitFinal.map(((e) => (e.value === tooltip.weight_unit ? e.label : ""))).join('') : ""}

                            </p>
                          }
                        </>
                      }
                    </>
                    :
                    <p>
                      {tooltip.category && category ? category.map(((e) => (e.value === tooltip.category ? e.label : ""))).join('') : ""}
                      {tooltip.parameter && tooltip.parametersData ? " -> " + tooltip.parametersData.map(((e) => (e.value === tooltip.parameter ? e.label : ""))).join('') : ""}
                      {(tooltip.second_conditions && tooltip.secondconditionFinal)?<>{tooltip.parameter === "refund-value" &&  (tooltip.conditions === "is-empty@$@refund-value" || tooltip.conditions === "is-not-empty@$@refund-value") ? "" : " -> " +  tooltip.secondconditionFinal.map(((e) => (e.value === tooltip.second_conditions ? e.label : ""))).join('')} </> : ""}
                      {tooltip.conditions && tooltip.conditionsDataOneFinal ? " -> " + tooltip.conditionsDataOneFinal.map(((e) => (e.value === tooltip.conditions ? e.label : ""))).join('') : ""}
                      {tooltip.condition_values ? " -> " + tooltip.condition_values : "" + tooltip && tooltip.tags && tooltip.tags.length ? tooltip.tags.length > 0 ? " -> " : "" : ""}
                      {tooltip && tooltip.tags ? tooltip.parameter === "specific-customers" || tooltip.parameter === "product-collection" || tooltip.parameter === "survey-taken" || tooltip.parameter === "specific-product" || tooltip.parameter === "language" || tooltip.parameter === "billing-country" || tooltip.parameter === "shipping-country" || tooltip.parameter === "currency" ?  this.getSpecificName(tooltip.parameter, tooltip.tags) : Array.prototype.map.call(tooltip.tags, s => s.text).toString() : ""}
                    </p>
                  }
                </>}
              <p> {main_tooltip.trigger.length !== j + 1 && "AND"} </p>
            </div>
          ))}
          <p>{this.state.mainTrigger.length !== i + 1 && "OR"}</p>
        </div>
      ))
    )
  }
  render() {
    let btn_class = this.state.page_dashboard === "1" ? "compactview_btn_page" : " compactview_btn"
    btn_class = this.state.check_pp_app_status == 0 || this.state.check_status_popup_view ? btn_class + ' rmv-compactview_btn' : btn_class

    const { active, sampleActive, premadeTemplate } = this.state;
    const trigger_Error_message = `"${this.state.trigger_errmessage.length}" ${__('Error found to save trigger:')}`;
    DataId({
      text:'Save',
      id:'button',
      dataAttribute:'save',
    })

    DataId({
      text:'#compactview_btn'
    })

    DataId({
      text:'#compactview_btn'
    })

    DataId({
      text:'Select',
      id:'.select2-results ul li'
    })


    
    return (
      <AppProvider i18n={enTranslations} >
        {this.state.respo ?
          <Frame>
            {this.state.show_toast ? (
              <Toast error={this.state.toast_error} content={this.state.toast_message} onDismiss={this.toggleSaveToaster.bind(this)} duration={2000} />
            ) : ("")}
            {this.state.iframeLoader ?
              <div className="sweet-loading custome_iframeLoader">
                <ClipLoader css={override} size={35} color={"#47c1bf"} loading={this.state.iframeLoader} />
              </div> : ""
            }
            <div className="App main_content">
              {this.state.page_dashboard === "1" ? "" :
                <div className="right_side_button">
                  <div className="header_devide_block">
                    <a className="back_icon_arrow" data-id="fnl_back" href={`${config.iFrame_url + this.state.version}/${this.state.redirect}?app_hmac_auth=${this.state.token}`} >
                      <span className="Polaris-Icon Polaris-Icon--colorInkLighter Polaris-Icon--isColored"><svg className="Polaris-Icon__Svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M17 9H5.414l3.293-3.293a.999.999 0 1 0-1.414-1.414l-5 5a.999.999 0 0 0 0 1.414l5 5a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L5.414 11H17a1 1 0 1 0 0-2" fillRule="evenodd"></path></svg></span>
                      <span>{__('Back')}</span>
                    </a>
                    {!this.state.showInput ?
                      <span className="funnel_name" data-id="funnel_name" onDoubleClick={this.doubleclick} title={this.state.funnel_title}>{this.state.funnel_title}</span>
                      :
                      <div className="titleInput"><input autoComplete="off" data-id="funnel_name" type="text" id="funnelTitle" className={this.state.rmvBoarder ? "rmvBoader" : ""} defaultValue={this.state.funnel_title} onChange={(e) => this.handleChangefunnelTitle(e)} ref={this.wrapperRef} /></div>
                    }
                    <button className="Polaris-btn-Button polaris-right-ten-mrg Polaris-Button--outline helpVidio_btn" type="button" onClick={this.openhelpvidio}>
                                          <span className="Polaris-Button__Content">
                                             <span className="Polaris-Button__Text">{__('Help video')}</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                              <g clipPath="url(#clip0)">
                                              <path fillRule="evenodd" clipRule="evenodd" d="M10 19.5C15.523 19.5 20 15.2469 20 10C20 4.75315 15.523 0.5 10 0.5C4.477 0.5 0 4.75315 0 10C0 15.2469 4.477 19.5 10 19.5ZM8 7.0189V12.9811C8.00003 13.0643 8.02305 13.146 8.06676 13.2181C8.11047 13.2901 8.17334 13.3501 8.24907 13.3918C8.32481 13.4335 8.41075 13.4557 8.49831 13.4559C8.58587 13.4562 8.67197 13.4347 8.748 13.3934L14.24 10.4123C14.3165 10.3707 14.38 10.3107 14.4242 10.2383C14.4684 10.1659 14.4917 10.0837 14.4917 10C14.4917 9.9163 14.4684 9.83409 14.4242 9.76169C14.38 9.68928 14.3165 9.62926 14.24 9.5877L8.748 6.60565C8.6719 6.56435 8.5857 6.54278 8.49806 6.54311C8.41042 6.54343 8.3244 6.56563 8.24864 6.60749C8.17288 6.64935 8.11002 6.70939 8.06639 6.7816C8.02275 6.8538 7.99985 6.93564 8 7.0189Z" fill="#5C5F62"/>
                                              </g>
                                              <defs>
                                              <clipPath id="clip0">
                                              <rect width="20" height="19" fill="white" transform="translate(0 0.5)"/>
                                              </clipPath>
                                              </defs>
                                              </svg>
                                          </span>
                                       </button>
                  </div>
                  <div className="header_devide_block">
                    {this.state.appStatus === "0" ?
                      this.state.is_default === "0" ?
                        <>
                         <p className="disabled_switch">{this.state.toggle_status?__("On"):__("Off")}</p>
                          <div className="toggleButton checkingData">
                            <Switch onChange={this.changeToggle} checked={this.state.toggle_status} disabled
                              width={40}
                              height={18}
                              offColor="#919EAB"
                              onColor="#007F60"
                              handleDiameter={14}
                              activeBoxShadow="none "
                              checkedIcon={<div> </div>}
                              uncheckedIcon={<div> </div>} />
                          </div>
                          
                          <Button onClick={(e) => this.save_funnel(e, "0", "0")} primary disabled={!this.state.isDraft} loading={this.state.butttonloading && this.state.isDefault === "0"}>{__('Save')}</Button>
                        </>
                        :
                        <>
                          <p className="defaultDraftBadge">{__('Draft - Default')}</p>
                          <Button data-id="save" onClick={(e) => this.save_funnel(e, "0", "1")} disabled={!this.state.draftEnable} loading={this.state.butttonloading && this.state.isbelowDefault === "0"}>{__('Save as draft')}</Button>
                          <Button data-id="save" onClick={(e) => this.publish_funnel(e, "1", "1")} primary disabled={!this.state.publishEnable} loading={this.state.butttonloading && this.state.isbelowDefault === "1"}>{__('Publish')}</Button>
                        </>
                      :
                      <>
                        {this.state.is_default === "0" ?
                          <>
                            <p>{this.state.toggle_status?__("On"):__("Off")}</p>
                            <div className="toggleButton">
                              <Switch onChange={this.changeToggle} checked={this.state.toggle_status}
                                width={40}
                                height={18}
                                offColor="#919EAB"
                                onColor="#007F60"
                                data-id="status"
                                handleDiameter={14}
                                activeBoxShadow="none "
                                checkedIcon={<div> </div>}
                                uncheckedIcon={<div> </div>} />
                            </div>
                            <Button data-id="save" onClick={(e) => this.save_funnel(e, "1", "0")} primary disabled={!this.state.isDraft} loading={this.state.butttonloading && this.state.isDefault === "0"}>{__('Save')}</Button>
                          </>
                          :
                          this.state.is_default === "2" ?
                            <>
                               <p>{this.state.toggle_status?__("On"):__("Off")}</p>
                              <div className="toggleButton">
                                <Switch onChange={this.changeToggle} checked={this.state.toggle_status}
                                  width={40}
                                  height={18}
                                  offColor="#919EAB"
                                  onColor="#007F60"
                                  data-id="status"
                                  handleDiameter={14}
                                  activeBoxShadow="none "
                                  checkedIcon={<div> </div>}
                                  uncheckedIcon={<div> </div>} />
                              </div>
                              <Button onClick={(e) => this.save_funnel(e, "1", "2")} primary disabled={!this.state.isDraft} loading={this.state.butttonloading && this.state.isDefault === "2"}>{__('Save')}</Button>
                            </>
                            :
                            <>
                              {this.state.toggle_status ? <p className="defaultBadge">{__('Live - Default')}</p> : ""}
                              <Button onClick={(e) => this.save_funnel(e, "1", "1")} primary disabled={!this.state.isDraft} loading={this.state.butttonloading && this.state.isDefault === "1"}>{__('Save')}</Button></>
                        }
                      </>

                    }
                  </div>
                </div>
              }
              {this.state.show_offerLoader ?
                <div className="sweet-loading page_loader">
                  <ClipLoader css={override} size={35} color={"#949393"} loading={this.props.createOfferLoader} />
                </div>
                :
                <>
                  {this.state.check_pp_app_status == 0 && (
                    <div className="error_message status-poupup">
                      <div className="Polaris-Banner Polaris-Banner--statusCritical Polaris-Banner--withinPage" tabIndex="0" role="alert" aria-live="polite" aria-labelledby="PolarisBanner1Heading" aria-describedby="PolarisBanner1Content">
                        <div className="Polaris-Banner__Ribbon">
                          <span className="Polaris-Icon Polaris-Icon--colorCritical Polaris-Icon--applyColor">
                            <svg viewBox="0 0 20 20" className="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                              <path d="M11.768.768a2.5 2.5 0 0 0-3.536 0L.768 8.232a2.5 2.5 0 0 0 0 3.536l7.464 7.464a2.5 2.5 0 0 0 3.536 0l7.464-7.464a2.5 2.5 0 0 0 0-3.536L11.768.768zM9 6a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0V6zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
                            </svg>
                          </span>
                        </div>
                        <div className="Polaris-Banner__ContentWrapper">
                          <div className="Polaris-Banner__Heading" id="PolarisBanner1Heading">
                            <p className="Polaris-Heading">
                              ReConvert is not defined as your post purchase upsell app.
                            </p>
                            <p>Post purchase one click offers will not be displayed to your customers until you set it up.</p>
                          </div>
                          <div className="Polaris-Banner__Content" id="PolarisBanner1Content">
                            <br />
                            <p>1. Go to<span><a style={{ textDecoration: "none", color: "#337ab7" }} target="_blank" href={`https://${this.state.shop}/admin/settings/checkout#post-purchase`}> Settings -&gt; Checkout -&gt; Post purchase page</a></span>.</p>
                            <p>2. Select {this.state.app_title}</p>
                            <p>3. Click the 'Save' button.</p>
                          </div>
                          <div className="Polaris-Banner__Actions">
                            <div className="Polaris-ButtonGroup">
                              <div className="Polaris-ButtonGroup__Item">
                                <div className="Polaris-Banner__PrimaryAction">
                                  <button className="Polaris-Banner__Button" onClick={this.check_pp_app_status.bind(true)}>
                                    <span className="Polaris-Button__Content"><span className="Polaris-Button__Text">Check status</span></span></button>
                                </div>
                              </div>
                              {this.state.check_status_popup_view && (
                                <div className="Polaris-Banner__Content" id="PolarisBanner2Content">
                                  <br />
                                  <p>ReConvert in not configured as your post purchase page app on Shopify. Please follow these instructions above</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.check_pp_app_status == true && this.state.check_status_popup_view == true && (
                    <div className="error_message status-poupup8">

                      <div class="Polaris-Banner Polaris-Banner--statusSuccess Polaris-Banner--hasDismiss Polaris-Banner--withinPage" tabindex="0" role="status" aria-live="polite" aria-labelledby="PolarisBanner8Heading" aria-describedby="PolarisBanner8Content">
                        <div class="Polaris-Banner__Dismiss">
                          <button class="Polaris-Button Polaris-Button--plain Polaris-Button--iconOnly" aria-label="Dismiss notification" type="button" onClick={this.check_status_popup_view.bind(this)}>
                            <span class="Polaris-Button__Content">
                              <span class="Polaris-Button__Icon">
                                <span class="Polaris-Icon">
                                  <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                    <path d="m11.414 10 4.293-4.293a.999.999 0 1 0-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L8.586 10l-4.293 4.293a.999.999 0 1 0 1.414 1.414L10 11.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z"></path>
                                  </svg>
                                </span>
                              </span>
                            </span>
                          </button>
                        </div>
                        <div class="Polaris-Banner__Ribbon">
                          <span class="Polaris-Icon Polaris-Icon--colorSuccess Polaris-Icon--applyColor">
                            <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                              <path fill-rule="evenodd" d="M0 10a10 10 0 1 0 20 0 10 10 0 0 0-20 0zm15.2-1.8a1 1 0 0 0-1.4-1.4L9 11.6 6.7 9.3a1 1 0 0 0-1.4 1.4l3 3c.4.4 1 .4 1.4 0l5.5-5.5z"></path>
                            </svg>
                          </span>
                        </div>
                        <div class="Polaris-Banner__ContentWrapper">
                          <div className="Polaris-Banner__Heading" id="PolarisBanner8Heading">
                            <p className="Polaris-Heading">
                              <i>Congratulations!</i>
                            </p>
                            <p>ReConvert is now configured as your post purchase upsell app</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className={btn_class}>
                    {this.state.expandView ?
                      <Button id="compactview_btn"  onClick={(e) => this.expandView()}>{__('Expand view')}</Button>
                      :
                      <Button id="compactview_btn" onClick={(e) => this.compactview_btn()}>{__('Compact view')}</Button>
                    }
                    {this.state.trigger_errmessage ?
                      <>
                        {/* <div className="error_message">
                        <div id="errorMsgBlockTriggerBase" className="error_banner">
                          <div className="error_svg"><span><svg className="Polaris-Icon__Svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><g fillRule="evenodd"><circle fill="currentColor" cx="10" cy="10" r="9"></circle><path d="M2 10c0-1.846.635-3.543 1.688-4.897l11.209 11.209A7.954 7.954 0 0 1 10 18c-4.411 0-8-3.589-8-8m14.312 4.897L5.103 3.688A7.954 7.954 0 0 1 10 2c4.411 0 8 3.589 8 8a7.952 7.952 0 0 1-1.688 4.897M0 10c0 5.514 4.486 10 10 10s10-4.486 10-10S15.514 0 10 0 0 4.486 0 10"></path></g></svg></span></div>
                          <div>
                            <div className="Polaris-Banner__Heading"><p className="Polaris-Heading">"{this.state.trigger_errmessage.length}" {__('Error found to save trigger:')}</p></div>
                            <div className="Polaris-Banner__Content"><ul>
                              {this.state.trigger_errmessage && this.state.trigger_errmessage.length && this.state.trigger_errmessage.map((err_msg, i) => (
                                <li key={i}>{err_msg.action}</li>
                              ))}
                            </ul>
                            </div>
                          </div>
                        </div>
                        </div> */}
                        {/* <div className="error_message">
                          <Banner
                            title={trigger_Error_message}
                            status="critical"

                          >
                            <ul>
                              {this.state.trigger_errmessage && this.state.trigger_errmessage.length && this.state.trigger_errmessage.map((err_msg, i) => (
                                <li key={i}>{err_msg.action}</li>
                              ))}
                            </ul>
                          </Banner>
                        </div> */}
                        <div class="error_message">
                          <div class="Polaris-Banner Polaris-Banner--statusCritical Polaris-Banner--withinPage" tabindex="0" role="alert" aria-live="polite" aria-labelledby="PolarisBanner1Heading" aria-describedby="PolarisBanner1Content">
                            <div class="Polaris-Banner__Ribbon">
                              <span class="Polaris-Icon Polaris-Icon--colorCritical Polaris-Icon--applyColor">
                                <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                  <path d="M11.768.768a2.5 2.5 0 0 0-3.536 0L.768 8.232a2.5 2.5 0 0 0 0 3.536l7.464 7.464a2.5 2.5 0 0 0 3.536 0l7.464-7.464a2.5 2.5 0 0 0 0-3.536L11.768.768zM9 6a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0V6zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
                                </svg>
                              </span>
                            </div>
                            <div class="Polaris-Banner__ContentWrapper">
                              <div class="Polaris-Banner__Heading" id="PolarisBanner1Heading">
                                <p class="Polaris-Heading">
                                  {trigger_Error_message}
                                </p>
                              </div>
                              <div class="Polaris-Banner__Content" id="PolarisBanner1Content">
                                <ul>
                                  {this.state.trigger_errmessage && this.state.trigger_errmessage.length && this.state.trigger_errmessage.map((err_msg, i) => (
                                    <li key={i}>{err_msg.action}</li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </> : ""}
                  </div>
                  <div className="content_section">
                    <div className="middle_section_left">
                      <span className="blue_badge">{__('order completed')} </span>
                    </div>
                    <div className={!this.state.right_arrowIcon ? "funnel_app collpase_right" : " funnel_app expand_right"}>
                      {this.state.right_arrowIcon ?
                        <div className="trigeer_heading add_spaceMargin">
                          <h3>{__('TRIGGER')}{this.state.right_arrowIcon}
                            <button data-id="expand_trigger" className={!this.state.right_arrowIcon ? "collpase_right"  : "expand_right"} onClick={this.rightCollpase.bind(this)}>
                              <Icon source={ChevronRightMinor} />
                            </button>
                          </h3>
                          <div className="editFunnelButton tooltip" onClick={this.rightCollpase.bind(this)}>
                            <button> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{marginRight:"5px"}}><g clipPath="url(#clip0)"><path d="M11.8768 1.12263L14.8784 4.12503L15.3784 3.62423C15.5755 3.42714 15.7318 3.19316 15.8385 2.93566C15.9452 2.67815 16.0001 2.40215 16.0001 2.12343C16.0001 1.8447 15.9452 1.56871 15.8385 1.3112C15.7318 1.05369 15.5755 0.819716 15.3784 0.622628C15.1813 0.42554 14.9473 0.269202 14.6898 0.162539C14.4323 0.0558754 14.1563 0.000976563 13.8776 0.000976562C13.3147 0.000976563 12.7748 0.224591 12.3768 0.622628L11.8768 1.12263ZM13.5 5.50023L10.4984 2.49783L0.9744 12.0226L0 15.9986L3.976 15.025L13.5 5.50023Z" fill="#5C5F62"/></g><defs><clipPath id="clip0"><rect width="16" height="16" fill="white"/></clipPath></defs></svg> {__('Edit')}</button>
                            <div className="tooltiptext trigger_tooltip">
                              {this.getTriggerData()}
                            </div>
                          </div>
                        </div>
                        : ""}
                      <div className={!this.state.right_arrowIcon ? "minwidth" : "add_overflow"}>
                        <div className="trigeer_heading">
                          <h3>{__("TRIGGER")}{this.state.right_arrowIcon}
                            <button className={!this.state.right_arrowIcon ? "collpase_right" : "expand_right"} onClick={this.rightCollpase.bind(this)}>
                              <Icon source={ChevronRightMinor} />
                            </button>
                          </h3>
                        </div>
                        <div className="funnel_section">
                          <h5>{__('When do you want to activate this funnel?')}</h5>
                          {this.state.mainTrigger.map((trigger, j) => (
                            <div className="topBoder" key={j}>
                              {j > 0 && (
                                <div className="or_section">
                                  <p>{__('OR')}</p>
                                  <span className="middle_line"></span>
                                  <Button onClick={(e) => this.deleteMainTrigger(e, j)} destructive id="dest_btn">
                                    {__('Delete')}
                                  </Button>
                                </div>
                              )}
                              {trigger.trigger.map((ele, i) => (
                                <div key={i} className="funnel_wrapper">
                                  {
                                    i > 0 && (
                                      <div className="or_section and_section">
                                        <p>{__('AND')}</p>
                                        <span className="middle_line"></span>
                                      </div>
                                    )
                                  }
                                  <div className="block_section" key={i}>
                                    <div>
                                      <p>{__('Category')}</p>
                                      <Select2 data={i === 0 && j === 0 ? this.state.category_array : this.state.category_array.slice(1, 5)}
                                        value={ele.category}
                                        update={(e) => this.selectCategoresChange(e, 'selectCategores', i, j, true, {})}>
                                      </Select2>
                                    </div>
                                    {ele.category === 'all orders' ?
                                      "" :
                                      <div>
                                        <p>{__('Parameter')}</p>
                                        <Select2 data={ele.parametersData ? ele.parametersData : []}
                                          open={(e) => this.openParameter(i, j)}
                                          value={ele.parametersData ? ele.parameter : ''}
                                          update={(e) => this.parameterChange(e, 'parameter', i, j, true, {})}
                                        >
                                        </Select2>
                                      </div>
                                    }
                                    {(ele.parameter === "shipping-address-1" || ele.parameter === "shipping-country" || ele.parameter === "shipping-province" || ele.parameter === "shipping-zip-code" || ele.parameter === "company" || ele.parameter === "shipping-address-2"
                                      || ele.parameter === "shipping-city") && (
                                        ele.category === "order" ? "" :
                                          <div>
                                            <p>{__('Address type')}</p>
                                            <Select2 data={this.state.custome_addressData}
                                              value={ele.second_conditions ? ele.second_conditions : this.state.custome_addressData[0].value}
                                              update={(e) => this.second_conditionChange(e, i, j, true)}>
                                            </Select2>
                                          </div>
                                      )}
                                    {ele.parameter === "phone-number" && (
                                      <div>
                                        <p>{__('Address type')}</p>
                                        <Select2 data={this.state.customer_conditionsData}
                                          value={ele.second_conditions ? ele.second_conditions : this.state.customer_conditionsData[0].value}
                                          update={(e) => this.second_conditionChange(e, i, j, true)}>
                                        </Select2>
                                      </div>
                                    )}
                                    {(ele.parameter === "available-at-sales-channel" || ele.parameter === "barcode" || ele.parameter === "charge-taxes-on-this-products" || ele.parameter === "compare-at-price" || ele.parameter === "product-collection" || ele.parameter === "specific-product" || ele.parameter === "harmonizedSystemCode" || ele.parameter === "inventory-policy" || ele.parameter === "overselling" || ele.parameter === "product-description" || ele.parameter === "product-price" || ele.parameter === "product-tags" || ele.parameter === "product-title" || ele.parameter === "product-type" || ele.parameter === "product-vendor" || ele.parameter === "inventory-quantity" || ele.parameter === "sku" || ele.parameter === "variant-name" || ele.parameter === "weight" || ele.parameter === "cost-per-item" || ele.parameter === "physical-product") && (
                                      <>
                                        {ele.category === 'all orders' ?
                                          "" :
                                          <div>
                                            <p>{__('Product condition')}</p>
                                            <Select2 data={this.state.product_conditionsData}
                                              value={ele.second_conditions ? ele.second_conditions : ''}
                                              update={(e) => this.second_conditionChange(e, i, j, true)}>
                                            </Select2>
                                          </div>
                                        }
                                      </>
                                    )}
                                    {ele.category !== "other" ? (
                                      <div>
                                        {((ele.parameter !== "accepts-marketing" && ele.parameter !== "tax-settings" && ele.parameter !== "total-revenue-generated" && ele.parameter !== "total-item-bought" && ele.parameter !== "time-since-last-order" && ele.parameter !== "tags" && ele.parameter !== "survey-taken" && ele.parameter !== "survey-answers" && ele.parameter !== "shipping-zip-code" && ele.parameter !== "shipping-province" && ele.parameter !== "shipping-country" && ele.parameter !== "shipping-city" && ele.parameter !== "shipping-address-2" && ele.parameter !== "shipping-address-1" && ele.parameter !== "number-of-orders" && ele.parameter !== "email" && ele.parameter !== "customer-created" && ele.parameter !== "customer-note" && ele.parameter !== "birthday" && ele.parameter !== "billing-address-1" && ele.parameter !== "billing-address-2" && ele.parameter !== "billing-city" && ele.parameter !== "billing-country" && ele.parameter !== "billing-province" && ele.parameter !== "billing-zip-code" && ele.parameter !== "billing-company" && ele.parameter !== "carrier" && ele.parameter !== "discount-code-used" && ele.parameter !== "discount-value" && ele.parameter !== "fraud-analysis" && ele.parameter !== "fulfillment-status" && ele.parameter !== "order-date" && ele.parameter !== "order-id" && ele.parameter !== "order-name" && ele.parameter !== "order-number" && ele.parameter !== "order-notes" && ele.parameter !== "order-tags" && ele.parameter !== "order-time" && ele.parameter !== "order-value" && ele.parameter !== "payment-method" && ele.parameter !== "refund-value" && ele.parameter !== "shipment-status" && ele.parameter !== "shipping-address-first-name" && ele.parameter !== "shipping-address-last-name" && ele.parameter !== "shipping-company" && ele.parameter !== "shipping-method" && ele.parameter !== "shipping-value" && ele.parameter !== "sales-channel" && ele.parameter !== "tax-value" && ele.parameter !== "total-items-count" && ele.parameter !== "total-revenue" && ele.parameter !== "tracking-number" && ele.parameter !== "timeline-comments" && ele.parameter !== "order-status" && ele.parameter !== "currency" && ele.parameter !== "available-at-sales-channel" && ele.parameter !== "barcode" && ele.parameter !== "charge-taxes-on-this-products" && ele.parameter !== "compare-at-price" && ele.parameter !== "product-collection" && ele.parameter !== "specific-product" && ele.parameter !== "harmonizedSystemCode" && ele.parameter !== "inventory-policy" && ele.parameter !== "overselling" && ele.parameter !== "product-price" && ele.parameter !== "product-tags" && ele.parameter !== "product-title" && ele.parameter !== "product-type" && ele.parameter !== "product-vendor" && ele.parameter !== "inventory-quantity" && ele.parameter !== "sku" && ele.parameter !== "variant-name" && ele.parameter !== "weight" && ele.parameter !== "physical-product") || ele.parameter === "accepts-marketing" || ele.parameter === "total-revenue-generated" || ele.parameter === "total-item-bought" || ele.parameter === "tags" || ele.parameter === "compare-at-price" || ele.parameter === "tax-settings" || ele.parameter === "time-since-last-order" || ele.parameter === "survey-taken" || ele.parameter === "survey-answers" || ele.parameter === "shipping-city" || ele.parameter === "shipping-address-2" || ele.parameter === "shipping-address-1" || ele.parameter === "email" || ele.parameter === "customer-note" || ele.parameter === "billing-address-2" || ele.parameter === "billing-company" || ele.parameter === "discount-code-used" || ele.parameter === "order-notes" || ele.parameter === "order-tags" || ele.parameter === "shipping-address-first-name" || ele.parameter === "shipping-company" || ele.parameter === "tracking-number" || ele.parameter === "barcode" || ele.parameter === "harmonizedSystemCode" || ele.parameter === "product-tags" || ele.parameter === "product-type" || ele.parameter === "sku" || ele.parameter === "variant-name" || ele.parameter === "order-number" || ele.parameter === "shipping-method" || ele.parameter === "shipping-zip-code" || ele.parameter === "shipping-province" || ele.parameter === "billing-address-1" || ele.parameter === "billing-city" || ele.parameter === "billing-province" || ele.parameter === "billing-zip-code" || ele.parameter === "order-id" || ele.parameter === "order-name" || ele.parameter === "shipping-address-last-name" || ele.parameter === "shipping-country" || ele.parameter === "billing-country" || ele.parameter === "carrier" || ele.parameter === "fraud-analysis" || ele.parameter === "fulfillment-status" || ele.parameter === "payment-method" || ele.parameter === "payment-status" || ele.parameter === "shipment-status" || ele.parameter === "sales-channel" || ele.parameter === "order-status" || ele.parameter === "currency" || ele.parameter === "specific-product" || ele.parameter === "product-vendor" || ele.parameter === "charge-taxes-on-this-products" || ele.parameter === "overselling" || ele.parameter === "physical-product" || ele.parameter === "number-of-orders" || ele.parameter === "total-items-count" || ele.parameter === "total-revenue" || ele.parameter === "inventory-quantity" || ele.parameter === "weight" || ele.parameter === "discount-value" || ele.parameter === "product-price" || ele.parameter === "refund-value" || ele.parameter === "shipping-value" || ele.parameter === "tax-value" || ele.parameter === "customer-created" || ele.parameter === "order-date" || ele.parameter === "order-time" || ele.parameter === "order-value" || ele.parameter === "birthday" || ele.parameter === "timeline-comments" || ele.parameter === "available-at-sales-channel" || ele.parameter === "product-collection" || ele.parameter === "inventory-policy" || ele.parameter === "product-title" || ele.parameter === "product-price" || ele.parameter === "number-of-orders") ?
                                          <>
                                            {ele.category === 'all orders' ?
                                              "" :
                                              <>
                                                <p>{__('Condition')}</p>
                                                <Select2 data={ele.conditionsDataOne ? ele.conditionsDataOne : []}
                                                  value={ele.conditions ? ele.conditions : ''}
                                                  update={(e) => this.conditionsChange(e, 'conditions', i, j, true)}>
                                                </Select2>
                                              </>
                                            }
                                          </>
                                          :
                                          ""
                                        }
                                      </div>
                                    ) : (
                                      <div>
                                        {(ele.parameter === "product-price") ?
                                          ""
                                          :
                                          [
                                            (ele.parameter === "operating-system" ?
                                              <div key="operating_system">
                                                {ele.category === 'all orders' ?
                                                  "" :
                                                  <div key="operating_system">
                                                    <p>{__('Status')}</p>
                                                    <Select2 data={this.state.operating_systemData}
                                                      placeholder={__("Select value")}
                                                      multiple
                                                      value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                                      update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                                    </Select2>
                                                  </div>
                                                }
                                              </div>
                                              :
                                              ele.parameter === "browser" ?
                                                <div key="browser">
                                                  {ele.category === 'all orders' ?
                                                    "" :
                                                    <div key="browser">
                                                      <p>{__('Status')}</p>
                                                      <Select2 data={this.state.browserData}
                                                        placeholder={__("Select value")}
                                                        multiple
                                                        value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                                        update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                                      </Select2>
                                                    </div>
                                                  }
                                                </div>
                                                :
                                                ele.parameter === "device" ?
                                                  <div key="device">
                                                    {ele.category === 'all orders' ?
                                                      "" :
                                                      <div key="device">
                                                        <p>{__('Status')}</p>
                                                        <Select2 data={this.state.deviceData}
                                                          placeholder={__("Select value")}
                                                          multiple
                                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                                        </Select2>
                                                      </div>
                                                    }
                                                  </div>
                                                  :
                                                  <div key="order">
                                                    {ele.category === 'all orders' ?
                                                      "" :
                                                      <div key="order">
                                                        <p>{__('Condition')}{" "}</p>
                                                        <Select2 data={ele.conditionsDataOne ? ele.conditionsDataOne : []}
                                                          value={ele.conditionsDataOne ? ele.conditions : ''}
                                                          update={(e) => this.conditionsChange(e, 'conditions', i, j, true)}>
                                                        </Select2>
                                                      </div>
                                                    }
                                                  </div>
                                            )
                                          ]
                                        }
                                      </div>
                                    )}
                                    {ele.parameter === "time-since-last-order" && (
                                      ele.conditions === "larger-than@$@" + ele.parameter || ele.conditions === "smaller-than@$@" + ele.parameter ?
                                        <>
                                          <div>
                                            <p>{__('Condition')} 2</p>
                                            <Select2 data={this.state.ConditionDatas}
                                              placeholder={__("Select value")}
                                              value={ele.second_conditions ? ele.second_conditions : this.state.ConditionDatas[0].value}
                                              update={(e) => this.second_conditionChange(e, i, j, true)}>
                                            </Select2>
                                          </div>
                                          <div id="space_txt">
                                            <input autoComplete="off" type="text" id="txt_valueFrom" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                          </div></>
                                        :
                                        <>
                                          <div>
                                            <p>{__('Condition')} 2</p>
                                            <Select2 data={this.state.ConditionDatas}
                                              placeholder={__("Select value")}
                                              value={ele.second_conditions ? ele.second_conditions : this.state.ConditionDatas[0].value}
                                              update={(e) => this.second_conditionChange(e, i, j, true)}>
                                            </Select2>
                                          </div>
                                          <div id="space_txt" className="custome_date">
                                            <input autoComplete="off" type="text" id="txt_valueFrom" className="leftdiv" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                            {__('To')}
                                            <input autoComplete="off" type="text" id="txt_valueTo" className="rightdiv" defaultValue={ele.txt_valueTo} onChange={(e) => this.handleChange_txt(e, "txt_valueTo", i, j)} />
                                          </div>
                                        </>
                                    )}
                                    {(ele.parameter === "discount-value" || ele.parameter === "refund-value") && (
                                      ele.conditions === "is-empty@$@" + ele.parameter || ele.conditions === "is-not-empty@$@" + ele.parameter ? "" :
                                        <>
                                          <div>
                                            <p>{__('Condition')} 2</p>
                                            <Select2 data={this.state.ConditionData && this.state.ConditionData.length ? this.state.ConditionData : []}
                                              placeholder={__("Select value")}
                                              value={ele.second_conditions ? ele.second_conditions : this.state.ConditionData[0].value}
                                              update={(e) => this.second_conditionChange(e, i, j, true)}>
                                            </Select2>
                                          </div>
                                        </>
                                    )}
                                    {ele.parameter === "fraud-analysis" ?
                                      <div key={i}>
                                        {ele.category === 'all orders' ?
                                          "" :
                                          <div>
                                            <p>{__('Status')}</p>
                                            <Select2 data={this.state.fraudAnalysisData}
                                              placeholder={__("Select value")}
                                              value={ele.condition_values}
                                              update={(e) => this.fraudAnalysisChange(e, 'fraudAnalysis', i, j, true)}>
                                            </Select2>
                                          </div>
                                        }
                                      </div>
                                      : ""}
                                    {ele.parameter === "fulfillment-status" ?
                                      <div>
                                        <p>{__('Status')}</p>
                                        <Select2 data={this.state.fulfillmentStatusData}
                                          placeholder='select a value'
                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                          multiple={true}
                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                        </Select2>
                                      </div>
                                      : ""}
                                    {ele.parameter === "carrier" ?
                                      <div>
                                        <p>{__('Status')}</p>
                                        <Select2 data={this.state.carrierData}
                                          placeholder={__("Select value")}
                                          multiple={true}
                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                        </Select2>
                                      </div>
                                      : ""}
                                    {ele.parameter === "payment-method" ?
                                      <div>
                                        <p>{__('Status')}</p>
                                        <Select2 data={this.state.paymentData}
                                          placeholder={__("Select value")}
                                          multiple={true}
                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                        </Select2>
                                      </div>
                                      : ""
                                    }
                                    {ele.parameter === "payment-status" ?
                                      <div>
                                        <p>{__('Status')}</p>
                                        <Select2 data={this.state.paymentSatatusData}
                                          placeholder={__("Select value")}
                                          multiple={true}
                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                        </Select2>
                                      </div>
                                      : ""
                                    }
                                    {ele.parameter === "survey-taken" && this.state.suveytaken !== '' ?
                                      ele.conditions === "none@$@" + ele.parameter ? "" :
                                        <div className="rmv_select_icon">
                                          <p>{__('Status')}</p>
                                          <Select2 data={this.state.suveytaken}
                                            placeholder={__("Select value")}
                                            value={ele.tags && ele.tags.length ? this.getDefaultSurveyOptions(ele.tags) : ""}
                                            multiple={true}
                                            update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                          </Select2>
                                        </div>
                                      : ""
                                    }
                                    {ele.parameter === "shipment-status" ?
                                      <div>
                                        <p>{__('Status')}</p>
                                        <Select2 data={this.state.shipmentData}
                                          placeholder={__("Select value")}
                                          multiple={true}
                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                        </Select2>
                                      </div>
                                      : ""
                                    }
                                    {ele.parameter === "sales-channel" ?
                                      <div>
                                        <p>{__('Status')}</p>
                                        <Select2 data={this.state.salesData}
                                          placeholder={__("Select value")}
                                          multiple={true}
                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                        </Select2>
                                      </div>
                                      : ""
                                    }
                                    {ele.parameter === "order-status" ?
                                      <div>
                                        <p>{__('Status')}</p>
                                        <Select2 data={this.state.orderStatusData}
                                          placeholder={__("Select value")}
                                          multiple={true}
                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                        </Select2>
                                      </div>
                                      : ""
                                    }
                                    {ele.parameter === "language" ?
                                      <div>
                                        <p>{__('Status')}</p>
                                        <Select2 data={this.state.languageData}
                                          placeholder={__("Select value")}
                                          multiple={true}
                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                        </Select2>
                                      </div>
                                      : ""
                                    }
                                    {ele.conditions === "is-empty@$@" + ele.parameter || ele.conditions === "is-not-empty@$@" + ele.parameter ? "" : ele.parameter === "product-type" && this.state.productTypeData !== '' ?
                                      <div id="space_txt">
                                        <Select2 data={this.state.productTypeData}
                                          placeholder={__("Select value")}
                                          multiple={true}
                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                        </Select2>
                                      </div>
                                      : ""
                                    }
                                    {ele.parameter === "product-vendor" && this.state.vendorData !== '' ?
                                      <div id="space_txt">
                                        <Select2 data={this.state.vendorData}
                                          placeholder={__("Select value")}
                                          multiple={true}
                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                        </Select2>
                                      </div>
                                      : ""
                                    }
                                    {/* first check for categores  */}
                                    {(ele.category === "customer" || ele.category === "order" || ele.category === "product") ?
                                      (ele.parameter === "tax-settings" || ele.parameter === "accepts-marketing" || ele.parameter === "time-since-last-order" || ele.parameter === "shipping-country" || ele.conditions === "is-empty@$@" + ele.parameter || ele.conditions === "is-not-empty@$@" + ele.parameter || ele.parameter === "billing-country" || ele.parameter === "fraud-analysis" || ele.parameter === "fulfillment-status" || ele.parameter === "order-time" || ele.parameter === "order-value" || ele.parameter === "refund-value" || ele.parameter === "shipment-status" || ele.parameter === "tax-value" || ele.parameter === "total-items-count" || ele.parameter === "total-revenue" || ele.parameter === "timeline-comments" || ele.parameter === "order-status" || ele.parameter === "currency" || ele.parameter === "available-at-sales-channel" || ele.parameter === "charge-taxes-on-this-products" || ele.parameter === "compare-at-price" || ele.parameter === "inventory-policy" || ele.parameter === "overselling" || ele.parameter === "product-price" || ele.parameter === "inventory-quantity" || ele.parameter === "physical-product" || ele.parameter === "survey-taken")
                                        ? ""
                                        : [
                                          (ele.parameter === "birthday" || ele.parameter === "customer-created" || ele.parameter === "order-date"
                                            ?
                                            (ele.conditions === "not-between@$@" + ele.parameter || ele.conditions === "between@$@" + ele.parameter) ?
                                              <div key={i} className="custome_date">
                                                <div key="startDate" id="space_txt" className="leftdiv">
                                                  <DatePicker
                                                    autoComplete="off"
                                                    selected={ele.txt_valueFrom && moment(ele.txt_valueFrom, 'yyyy-MM-dd').isValid() ? new Date(ele.txt_valueFrom) : ''}
                                                    onChange={(e) => this.handleDateChange(e, "startDate_between", i, j)}
                                                    selectsStart
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    startDate={ele.startDate}
                                                    endDate={ele.endDate}
                                                    id="startDate"
                                                    maxDate={new Date()}
                                                    dateFormat="yyyy-MM-dd" />
                                                </div>
                                                {__('To')}
                                                <div key="endDate" id="space_txt" className="rightdiv">
                                                  <DatePicker
                                                    autoComplete="off"
                                                    selected={ele.txt_valueTo && moment(ele.txt_valueTo, 'yyyy-MM-dd').isValid() ? new Date(ele.txt_valueTo) : ''}
                                                    onChange={(e) => this.handleDateChange(e, "endDate", i, j)}
                                                    selectsEnd
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    startDate={ele.startDate}
                                                    endDate={ele.endDate}
                                                    minDate={ele.startDate}
                                                    maxDate={new Date()}
                                                    id="endDate"
                                                    dateFormat="yyyy-MM-dd" />
                                                </div>
                                              </div>
                                              :
                                              (ele.conditions === "less_then_ago@$@" + ele.parameter || ele.conditions === "pass-x-time-ago@$@" + ele.parameter) ?
                                                <>
                                                  <div>
                                                    <p>{__('Condition')} 2</p>
                                                    <Select2 data={this.state.Condition2Data}
                                                      value={ele.second_conditions}
                                                      update={(e) => this.second_conditionChange(e, i, j, true)}>
                                                    </Select2>
                                                  </div>
                                                  <div id="space_txt" key="ytime">
                                                    <input autoComplete="off" type="text" id="txt_value" onChange={(e) => this.handleChangeCust(e.target.value, ele.parameter, i, j)} value={ele.condition_values ? ele.condition_values : ''} />
                                                  </div>
                                                </>
                                                :
                                                <div key="date">
                                                  <DatePicker
                                                    autoComplete="off"
                                                    id="space_txt"
                                                    maxDate={new Date()}
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={ele.txt_valueFrom && moment(ele.txt_valueFrom, 'yyyy-MM-dd').isValid() ? new Date(ele.txt_valueFrom) : ""}
                                                    onChange={(e) => this.handleDateChange(e, "startDate", i, j)} /* only when value has changed */
                                                    dateFormat="yyyy-MM-dd"
                                                    className="react_datePicker" />
                                                </div>
                                            :
                                            (ele.parameter === "discount-value") || (ele.parameter === "total-revenue-generated") || (ele.parameter === "shipping-value") || (ele.parameter === "total-item-bought") || (ele.parameter === "cost-per-item") || (ele.parameter === "number-of-orders") || (ele.parameter === "user-impressions-for-this-order") || (ele.parameter === "user-impressions-for-all-orders") ?
                                              "" : ele.parameter === "weight" ? "" :
                                                <div key="text" id="space_txt">
                                                  {ele.parameter === "order-value" || ele.parameter === "tax-value" || ele.parameter === "total-revenue" || ele.parameter === "compare-at-price" || ele.parameter === "product-price" ?
                                                    ele.second_conditions === "2" ?
                                                      <div className="lable">
                                                        <span className="suffix">{__('%')}</span>
                                                        <input autoComplete="off" type="text" className="snehainput suffix_input" id="txt_value" onChange={(e) => this.handleChangeCust(e.target.value, "discount-value", i, j)} defaultValue={ele.condition_values} />
                                                      </div> :
                                                      <div className="lable">
                                                        <span className="prefix">{this.state.currancyFormate}</span>
                                                        <input autoComplete="off" type="text" className="snehainput" id="txt_value" onChange={(e) => this.handleChangeCust(e.target.value, "discount-value", i, j)} defaultValue={ele.condition_values} />
                                                      </div> :
                                                    (ele.parameter === "first-name") || (ele.parameter === "last-name") ||
                                                      (ele.parameter === "order-tags") || (ele.parameter === "survey-answers") || (ele.parameter === "email") || (ele.parameter === "phone-number") || (ele.parameter === "shipping-city") || (ele.parameter === "shipping-zip-code") || (ele.parameter === "tags") || (ele.parameter === "company") || (ele.parameter === "billing-address-first-name") || (ele.parameter === "billing-address-last-name") || (ele.parameter === "billing-city") || (ele.parameter === "billing-zip-code") || (ele.parameter === "billing-company") || (ele.parameter === "discount-code-used") || (ele.parameter === "order-id") || (ele.parameter === "order-name") || (ele.parameter === "order-notes") || (ele.parameter === "shipping-address-first-name") || (ele.parameter === "shipping-address-last-name") || (ele.parameter === "shipping-city") || (ele.parameter === "shipping-company") || (ele.parameter === "shipping-zip-code") || (ele.parameter === "tracking-number") || (ele.parameter === "barcode") || (ele.parameter === "total-items-count") || (ele.parameter === "product-tags") || (ele.parameter === "product-description") || (ele.parameter === "product-title") || (ele.parameter === "sku") || (ele.parameter === "variant-name") ?
                                                      <div>
                                                        <ReactTags tags={ele.tags ? ele.tags : []}
                                                          handleDelete={(e) => this.handleDelete(e, i, j, ele.tags)}
                                                          handleAddition={(e) => this.handleAddition(e, i, j, ele.tags, ele.parameter)}
                                                          handleInputBlur={this.handleInputBlur}
                                                          delimiters={delimiters}
                                                          allowDragDrop={false}
                                                          allowUnique={true}
                                                          placeholder="" />
                                                      </div> :
                                                      (ele.parameter === "specific-customers" && this.state.specificCustomer !== '') ?
                                                        <>
                                                          <Select2 data={this.state.specificCustomer}
                                                            multiple={true}
                                                            value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                                            keydown={(e) => this.searchApi(e, ele.parameter)}
                                                            update={(e) => this.fulfillmentStatusChange(e, i, j, true)}
                                                            keepSearchText={false}
                                                            placeholder="Search for customers">
                                                          </Select2>
                                                        </> :
                                                        (ele.parameter === "product-collection" && this.state.getCollection !== '') ?
                                                      
                                                          <>
                                                            <CustomSelect
                                                              options={this.state.getCollection ? this.state.getCollection : ""}
                                                              defaultValue={ele.tags && ele.tags.length ? this.getDefaultProductOptions_product(ele.tags, 'product-collection') : ""}
                                                              onChange={(e) => this.productChnage(e ? e.map(a => a) : '', 'product-collection', i, j, true)}
                                                              multiple
                                                              onInputChange={(e) => this.searchCustomer(e, ele.parameter)}
                                                            />
                                                          </> :
                                                          (ele.parameter === "specific-product" && this.state.getproduct !== '') ?
                                                            <>
                                                              <CustomSelect
                                                                options={this.state.getproduct ? this.state.getproduct : ""}
                                                                defaultValue={ele.tags && ele.tags.length ? this.getDefaultProductOptions_product(ele.tags, 'product') : ""}
                                                                onChange={(e) => this.productChnage(e ? e.map(a => a) : "", 'specific-product', i, j, true)}
                                                                multiple
                                                                onInputChange={(e) => this.searchCustomer(e, ele.parameter)}
                                                              />
                                                            </> :
                                                            (ele.parameter === "customer-note") || (ele.parameter === "shipping-province") || (ele.parameter === "billing-address-1") || (ele.parameter === "billing-address-2") || (ele.parameter === "billing-province") || (ele.parameter === "order-number") || (ele.parameter === "shipping-method") || (ele.parameter === "harmonizedSystemCode") || (ele.parameter === "shipping-address-1") || (ele.parameter === "shipping-address-2") ?
                                                              <>
                                                                {""}
                                                                <input autoComplete="off" type="text" id="txt_value" onChange={(e) => this.handleChangeCust(e.target.value, ele.parameter, i, j)} value={ele.condition_values ? ele.condition_values : ''} />
                                                              </> :
                                                              (ele.parameter === "weight") ?
                                                                <>
                                                                  <input autoComplete="off" type="text" id="txt_value" className="weightPicker" onChange={(e) => this.handleChangeCust(e.target.value, ele.parameter, i, j)} defaultValue={ele.condition_values} />
                                                                </>
                                                                :
                                                                (ele.parameter === "accepts-marketing") || (ele.parameter === "carrier") || (ele.parameter === "payment-method") || (ele.parameter === "payment-status") || (ele.parameter === "sales-channel") || (ele.parameter === "language") || (ele.parameter === "product-type") || (ele.parameter === "product-vendor") || (ele.parameter === "total-revenue-generated") || (ele.parameter === "product-description") || (ele.parameter === "product-title") || (ele.parameter === "variant-name") || (ele.parameter === "customer-note") || (ele.parameter === "shipping-province") || (ele.parameter === "billing-address-2") || (ele.parameter === "billing-address-1") || (ele.parameter === "billing-province") || (ele.parameter === "order-number") || (ele.parameter === "shipping-method") || (ele.parameter === "harmonizedSystemCode") || (ele.parameter === "weight") ? "" :
                                                                  <>
                                                                    <input autoComplete="off" type="text" id="txt_value" onChange={(e) => this.handleChangeCust(e.target.value, ele.parameter, i, j)} defaultValue={ele.tags && ele.tags.length ? ele.tags[0].text : ""} />
                                                                  </>
                                                  }
                                                </div>
                                          )
                                        ]
                                      : ""
                                    }
                                    {(ele.parameter === "total-item-bought" || ele.parameter === "number-of-orders" || ele.parameter === "user-impressions-for-this-order" || ele.parameter === "user-impressions-for-all-orders") ?
                                      [
                                        (ele.conditions === "not-between@$@" + ele.parameter || ele.conditions === "between@$@" + ele.parameter ?
                                          <div key={i} className="custome_date">
                                            <div key="fromTime" id="space_txt" className="leftdiv">
                                              <input autoComplete="off" type="text" id="fromtime" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                            </div>
                                            {__('To')}
                                            <div key="toTime" id="space_txt" className="rightdiv">
                                              <input autoComplete="off" type="text" id="totime" defaultValue={ele.txt_valueTo} onChange={(e) => this.handleChange_txt(e, "txt_valueTo", i, j)} />
                                            </div>
                                          </div>
                                          :
                                          <div key="fromTime" id="space_txt">
                                            <input autoComplete="off" type="text" id="time" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                          </div>
                                        )
                                      ]
                                      : ""}
                                    {(ele.parameter === "shipping-value" || ele.parameter === "total-revenue-generated") ?
                                      ele.conditions === "is-empty@$@" + ele.parameter || ele.conditions === "is-not-empty@$@" + ele.parameter ? "" :
                                        (ele.conditions === "not-between@$@" + ele.parameter || ele.conditions === "between@$@" + ele.parameter ?
                                          <div key={i} className="custome_date">
                                            <div key="fromTime" id="space_txt" className="leftdiv">
                                              <div className="lable">
                                                <span className="prefix">{this.state.currancyFormate}</span>
                                                <input autoComplete="off" type="text" className="snehainput" id="fromtime" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                              </div>
                                            </div>
                                            {__('To')}
                                            <div key="toTime" id="space_txt" className="rightdiv">
                                              <div className="lable">
                                                <span className="prefix">{this.state.currancyFormate}</span>
                                                <input autoComplete="off" type="text" className="snehainput" id="totime" defaultValue={ele.txt_valueTo} onChange={(e) => this.handleChange_txt(e, "txt_valueTo", i, j)} />
                                              </div>
                                            </div>
                                          </div>
                                          :
                                          <div key="fromTime" id="space_txt">
                                            <div className="lable">
                                              <span className="prefix">{this.state.currancyFormate}</span>
                                              <input autoComplete="off" type="text" className="snehainput" id="txt_value" onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} defaultValue={ele.txt_valueFrom} />
                                            </div>
                                          </div>
                                        ) : ""
                                    }
                                    {(ele.parameter === "refund-value") ?
                                      [
                                        ele.conditions === "is-empty@$@" + ele.parameter || ele.conditions === "is-not-empty@$@" + ele.parameter ? "" :
                                          ele.second_conditions === "2" ?
                                            (ele.conditions === "not-between@$@" + ele.parameter || ele.conditions === "between@$@" + ele.parameter ?
                                              <div key={i} className="custome_date">
                                                <div key="fromTime" id="space_txt" className="leftdiv">
                                                  <div className="lable">
                                                    <span className="suffix">{__('%')}</span>
                                                    <input autoComplete="off" type="text" className="snehainput suffix_input" id="fromtime" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                                  </div>
                                                </div>
                                                {__('To')}
                                                <div key="toTime" id="space_txt" className="rightdiv">
                                                  <div className="lable">
                                                    <span className="suffix">{__('%')}</span>
                                                    <input autoComplete="off" type="text" className="snehainput suffix_input" id="totime" defaultValue={ele.txt_valueTo} onChange={(e) => this.handleChange_txt(e, "txt_valueTo", i, j)} />
                                                  </div>
                                                </div>
                                              </div>
                                              :
                                              <div key="fromTime" id="space_txt">
                                                <div className="lable">
                                                  <span className="suffix">{__('%')}</span>
                                                  <input autoComplete="off" type="text" className="snehainput suffix_input" id="txt_value" onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} defaultValue={ele.txt_valueFrom} />
                                                </div>
                                              </div>
                                            ) :
                                            (ele.conditions === "not-between@$@" + ele.parameter || ele.conditions === "between@$@" + ele.parameter ?
                                              <div key={i} className="custome_date">
                                                <div key="fromTime" id="space_txt" className="leftdiv">
                                                  <div className="lable">
                                                    <span className="prefix">{this.state.currancyFormate}</span>
                                                    <input autoComplete="off" type="text" className="snehainput" id="fromtime" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "fromtime", i, j)} />
                                                  </div>
                                                </div>
                                                {__('To')}
                                                <div key="toTime" id="space_txt" className="rightdiv">
                                                  <div className="lable">
                                                    <span className="prefix">{this.state.currancyFormate}</span>
                                                    <input autoComplete="off" type="text" className="snehainput" id="totime" defaultValue={ele.txt_valueTo} onChange={(e) => this.handleChange_txt(e, "totime", i, j)} />
                                                  </div>
                                                </div>
                                              </div>
                                              :
                                              <div key="fromTime" id="space_txt">
                                                <div className="lable">
                                                  <span className="prefix">{this.state.currancyFormate}</span>
                                                  <input autoComplete="off" type="text" className="snehainput" id="txt_value" onChange={(e) => this.handleChange_txt(e, "fromtime", i, j)} defaultValue={ele.txt_valueFrom} />
                                                </div>
                                              </div>
                                            )
                                      ]
                                      : ""}
                                    {(ele.parameter === "cost-per-item" || ele.parameter === "product-price") ?
                                      [
                                        ele.conditions === "is-empty@$@" + ele.parameter || ele.conditions === "is-not-empty@$@" + ele.parameter ? "" :
                                          ele.second_conditions === "2" ?
                                            (ele.conditions === "not-between@$@" + ele.parameter || ele.conditions === "between@$@" + ele.parameter ?
                                              <div key={i} className="custome_date">
                                                <div key="fromTime" id="space_txt" className="leftdiv">
                                                  <div className="lable">
                                                    <span className="prefix">{__('%')}</span>
                                                    <input autoComplete="off" type="text" className="snehainput" id="fromtime" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                                  </div>
                                                </div>
                                                {__('To')}
                                                <div key="toTime" id="space_txt" className="rightdiv">
                                                  <div className="lable">
                                                    <span className="prefix">{__('%')}</span>
                                                    <input autoComplete="off" type="text" className="snehainput" id="totime" defaultValue={ele.txt_valueTo} onChange={(e) => this.handleChange_txt(e, "txt_valueTo", i, j)} />
                                                  </div>
                                                </div>
                                              </div>
                                              :
                                              <div key="fromTime" id="space_txt">
                                                <div className="lable">
                                                  <span className="prefix">{__('%')}</span>
                                                  <input autoComplete="off" type="text" className="snehainput" id="txt_value" onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} defaultValue={ele.txt_valueFrom} />
                                                </div>
                                              </div>
                                            ) :
                                            (ele.conditions === "not-between@$@" + ele.parameter || ele.conditions === "between@$@" + ele.parameter ?
                                              <div key={i} className="custome_date">
                                                <div key="fromTime" id="space_txt" className="leftdiv">
                                                  <div className="lable">
                                                    <span className="prefix">{this.state.currancyFormate}</span>
                                                    <input autoComplete="off" type="text" className="snehainput" id="fromtime" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "fromtime", i, j)} />
                                                  </div>
                                                </div>
                                                {__('To')}
                                                <div key="toTime" id="space_txt" className="rightdiv">
                                                  <div className="lable">
                                                    <span className="prefix">{this.state.currancyFormate}</span>
                                                    <input autoComplete="off" type="text" className="snehainput" id="totime" defaultValue={ele.txt_valueTo} onChange={(e) => this.handleChange_txt(e, "totime", i, j)} />
                                                  </div>
                                                </div>
                                              </div>
                                              :
                                              <div key="fromTime" id="space_txt">
                                                <div className="lable">
                                                  <span className="prefix">{this.state.currancyFormate}</span>
                                                  <input autoComplete="off" type="text" className="snehainput" id="txt_value" onChange={(e) => this.handleChange_txt(e, "fromtime", i, j)} defaultValue={ele.txt_valueFrom} />
                                                </div>
                                              </div>
                                            )
                                      ]
                                      : ""}
                                    {(ele.parameter === "survey-taken") ? "" : ""}
                                    {
                                      (ele.parameter === "order-time") ?
                                        [
                                          (ele.conditions === "not-between@$@" + ele.parameter || ele.conditions === "between@$@" + ele.parameter ?
                                            <div key={i} className="custome_date">
                                              <div key="fromTime" id="space_txt" className="leftdiv">
                                                <input autoComplete="off" type="time" id="fromtime" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "fromtime", i, j)} />
                                              </div>
                                              {__('To')}
                                              <div key="toTime" id="space_txt" className="rightdiv">
                                                <input autoComplete="off" type="time" id="totime" defaultValue={ele.txt_valueTo} onChange={(e) => this.handleChange_txt(e, "totime", i, j)} />
                                              </div>
                                            </div>
                                            :
                                            <div key="fromTime" id="space_txt" ref={this.wrapperRef}>
                                              <input autoComplete="off" type="time" id="time" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "fromtime", i, j)} />
                                            </div>
                                          )
                                        ]
                                        :
                                        (ele.parameter === "order-value") ?
                                          [
                                            (ele.conditions === "not-between@$@" + ele.parameter || ele.conditions === "between@$@" + ele.parameter ?
                                              <div key={i} className="custome_date">
                                                <div key="fromTime" id="space_txt" className="leftdiv">
                                                  <div className="lable">
                                                    <span className="prefix">{this.state.currancyFormate}</span>
                                                    <input autoComplete="off" type="text" id="txt_valueFrom" className="snehainput" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                                  </div>
                                                </div>
                                                {__('To')}
                                                <div key="toTime" id="space_txt" className="rightdiv">
                                                  <div className="lable">
                                                    <span className="prefix">{this.state.currancyFormate}</span>
                                                    <input autoComplete="off" type="text" id="txt_valueTo" className="snehainput" defaultValue={ele.txt_valueTo} onChange={(e) => this.handleChange_txt(e, "txt_valueTo", i, j)} />
                                                  </div>
                                                </div>
                                              </div>
                                              :
                                              <div key="fromTime" id="space_txt">
                                                <div className="lable">
                                                  <span className="prefix">{this.state.currancyFormate}</span>
                                                  <input autoComplete="off" type="text" id="time" className="snehainput" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                                </div></div>)
                                          ] :
                                          (ele.parameter === "discount-value") ? [
                                            (ele.conditions === "not-between@$@" + ele.parameter || ele.conditions === "between@$@" + ele.parameter ?
                                              <div id="space_txt" key="1" className="discountValue">
                                                  <div className="lable leftdiv">
                                                  <span className={ele.second_conditions == "2" ? "suffix" : "prefix"}>{ele.second_conditions == "2" ? __('%') : this.state.currancyFormate}</span>
                                                  <input autoComplete="off" type="text" className={ele.second_conditions == "2" ? "snehainput suffix_input" : "snehainput"} id="txt_value" onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} defaultValue={ele.txt_valueFrom} />
                                                  </div>
                                                  {__('To')}
                                                  <div className="lable rightdiv">
                                                  <span className={ele.second_conditions == "2" ? "suffix" : "prefix"}>{ele.second_conditions == "2" ? __('%') : this.state.currancyFormate}</span>
                                                  <input autoComplete="off" type="text" className={ele.second_conditions == "2" ? "snehainput suffix_input" : "snehainput"} id="txt_value" onChange={(e) => this.handleChange_txt(e, "txt_valueTo", i, j)} defaultValue={ele.txt_valueTo} />
                                                </div>
                                              </div>
                                              :
                                              <div className="lable" id="space_txt" key="1">
                                                <span className={ele.second_conditions == "2" ? "suffix" : "prefix"}>{ele.second_conditions == "2" ? __('%') : this.state.currancyFormate}</span>
                                                <input autoComplete="off" type="text" className={ele.second_conditions == "2" ? "snehainput suffix_input" : "snehainput"} id="txt_value" onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} defaultValue={ele.txt_valueFrom} />
                                              </div>
                                            )
                                          ] :
                                            (ele.parameter === "tax-value") || (ele.parameter === "total-revenue") || (ele.parameter === "compare-at-price") ?
                                              [
                                                ele.conditions === "is-empty@$@" + ele.parameter || ele.conditions === "is-not-empty@$@" + ele.parameter ? "" :
                                                  (ele.conditions === "not-between@$@" + ele.parameter || ele.conditions === "between@$@" + ele.parameter ?
                                                    <div key="1" id="space_txt" className="discountValue">
                                                      <div className="lable leftdiv" >
                                                        <span className="prefix">{this.state.currancyFormate}</span>
                                                        <input autoComplete="off" type="text" className="snehainput" id="txt_value" onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} defaultValue={ele.txt_valueFrom} />
                                                      </div>
                                                      {__('To')}
                                                      <div className="lable rightdiv">
                                                        <span className="prefix">{this.state.currancyFormate}</span>
                                                        <input autoComplete="off" type="text" className="snehainput" id="txt_value" onChange={(e) => this.handleChange_txt(e, "txt_valueTo", i, j)} defaultValue={ele.txt_valueTo} />
                                                      </div>
                                                    </div>
                                                    :
                                                    <div className="lable" id="space_txt" key="1">
                                                      <span className="prefix">{this.state.currancyFormate}</span>
                                                      <input autoComplete="off" type="text" className="snehainput" id="txt_value" onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} defaultValue={ele.txt_valueFrom} />
                                                    </div>
                                                  )] :
                                              (ele.parameter === "total-items-count" || ele.parameter === "inventory-quantity") ?
                                                [
                                                  (ele.conditions === "not-between@$@" + ele.parameter || ele.conditions === "between@$@" + ele.parameter ?
                                                    <div key={i} className="custome_date">
                                                      <div key="fromTime" id="space_txt" className="leftdiv">
                                                        <input autoComplete="off" type="text" id="txt_valueFrom" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                                      </div>
                                                      {__('To')}
                                                      <div key="toTime" id="space_txt" className="rightdiv">
                                                        <input autoComplete="off" type="text" id="txt_valueTo" defaultValue={ele.txt_valueTo} onChange={(e) => this.handleChange_txt(e, "txt_valueTo", i, j)} />
                                                      </div>
                                                    </div>
                                                    :
                                                    <div key="fromTime" id="space_txt">
                                                      <input autoComplete="off" type="text" id="time" pattern="[0-9]*" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                                    </div>)
                                                ]
                                                :
                                                (ele.parameter === "order-status") ?
                                                  [
                                                    <div id="space_txt" key={ele}>
                                                    </div>
                                                  ]
                                                  :
                                                  (ele.parameter === "available-at-sales-channel") ?
                                                    [
                                                      <div key={i}>
                                                        {ele.category === 'all orders' ?
                                                          "" :
                                                          <div key={i}>
                                                            <p>{__('Status')}</p>
                                                            <Select2 data={this.state.fulfillmentStatusDataOne}
                                                              multiple={true}
                                                              value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                                              update={(e) => this.fulfillmentStatusChange(e, i, j, true)}
                                                              placeholder={__("Select value")}>
                                                            </Select2>
                                                          </div>
                                                        }
                                                      </div>
                                                    ]
                                                    :
                                                    ""
                                    }
                                    {(ele.parameter === "shipping-country" || ele.parameter === "billing-country") && (
                                      <div id="space_txt">
                                        <Select2 data={this.state.countryData}
                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                          multiple={true}
                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}>
                                        </Select2>
                                      </div>
                                    )}
                                    {(ele.parameter === "currency") && (
                                      <div id="space_txt">
                                        <Select2 data={this.state.currencyData}
                                          multiple={true}
                                          value={ele.tags && ele.tags.length ? ele.tags.map(a => a.id) : ""}
                                          update={(e) => this.fulfillmentStatusChange(e, i, j, true)}
                                        >
                                        </Select2>
                                      </div>
                                    )}
                                    {ele.parameter === "weight"
                                      ? [
                                        ele.conditions === "between@$@" + ele.parameter || ele.conditions === "not-between@$@" + ele.parameter ? (
                                          <>
                                            <div id="space_txt">
                                              <input autoComplete="off" type="text" id="txt_valueFrom" className="weightPicker" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                            </div>
                                            <div id="space_txt" className="weightSelect leftdiv">
                                              <Select2
                                                data={this.state.weight_unitData}
                                                value={ele.weight_unit ? ele.weight_unit : this.state.weight_unitData[0].value}
                                                update={(e) => this.weight_unitChange(e, i, j, true)}>
                                              </Select2>
                                            </div>
                                            <p className="weight_to">{__("To")}</p>
                                            <div id="space_txt" className="rightdiv">
                                              <input autoComplete="off" type="text" id="txt_valueTo" className="weightPicker" defaultValue={ele.txt_valueTo} onChange={(e) => this.handleChange_txt(e, "txt_valueTo", i, j)} />
                                            </div>
                                            <div id="space_txt" className="weightSelect">
                                              <Select2
                                                data={this.state.weight_unitData}
                                                disabled
                                                value={ele.weight_unit ? ele.weight_unit : this.state.weight_unitData[0].value}
                                                update={(e) => this.weight_unitChange(exports, i, j, true)}></Select2>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div id="space_txt">
                                              <input autoComplete="off" type="text" id="txt_valueFrom" className="weightPicker" defaultValue={ele.txt_valueFrom} onChange={(e) => this.handleChange_txt(e, "txt_valueFrom", i, j)} />
                                            </div>
                                            <div id="space_txt" className="weightSelect" key={i}>
                                              <Select2 data={this.state.weight_unitData}
                                                value={ele.weight_unit ? ele.weight_unit : this.state.weight_unitData[0].value}
                                                update={(e) => this.weight_unitChange(e, i, j, true)}
                                              ></Select2>
                                            </div>
                                          </>
                                        ),
                                      ]
                                      : ""}
                                    {trigger.trigger.length > 1 && (
                                      <Button onClick={(e) => this.deleteTrigger(e, ele, i, j)} id="deleteTrigger_btn">
                                        <DeleteTrigger />
                                      </Button>
                                    )}
                                  </div>
                                </div>
                              ))}
                              {this.state.mainTrigger[0].trigger[0].category !== "all orders" ?
                                <div className="andBtn_bg">
                                  <Button onClick={(e) => this.addTrigger(e, j, trigger.trigger.length - 1)} >
                                    {__('And')}
                                  </Button>
                                </div>
                                : ""}
                            </div>
                          ))}
                          {this.state.mainTrigger[0].trigger[0].category !== "all orders" ?
                            <Button onClick={(e) => this.OrTrigger(e, this.state.mainTrigger.length - 1)}>
                              {__('OR')}
                            </Button>
                            : ""
                          }
                        </div>
                        {/* Temporary Buttons only for localhost */}
                        {this.state.hostname === "localhost" && (
                          <>
                            <Button onClick={this.open_upsellModal.bind(this)} id="sample_button">
                              {__('Local Product Upsell Modal')}
                            </Button>
                            <Button onClick={this.open_recommendationsModal.bind(this)} id="sample_button">
                              {__('Local Product Recommendations Modal')}
                            </Button>
                            <Button onClick={this.open_devTemplateModal.bind(this)} id="sample_button">
                              {__('Dev Template Modal')}
                            </Button>
                            <Button onClick={this.open_localTemplateModal.bind(this)} id="sample_button">
                              {__('Local template')}
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                    <>
                      <div className="middle_section">
                        {
                          this.state.offerUser_down.length === 0 ?
                            this.state.addDownshellThankyou ?
                              <span className="blue_badge">{__('thank you')} </span>
                              :
                              this.state.show_select ?
                                <span className="blue_badge"> {__('UPSELL')} </span>
                                :
                                <span className="no_badge_here"></span>
                            :
                            this.state.offerUser_down[0].temp_id === 0 ?
                              <span className="blue_badge"> {__('UPSELL')} </span>
                              :
                              <span className="blue_badge"> {__('thank you')} </span>
                        }
                      </div>
                      {this.state.offerUser_down.length === 0 ? (
                        <div className="last_section">
                          {!this.state.addDownshellThankyou ?
                            <div>
                              {!this.state.show_select ?
                                <div>

                                  <h3>{__("What's next")}</h3>
                                  <div className="next_bottom_wrapper" >
                                    <button onClick={(e) => this.addDownshell(e, 0, [])} data-id="add_upsell">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                      <path d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM5 10C5 9.73478 5.10536 9.48043 5.29289 9.29289C5.48043 9.10536 5.73478 9 6 9H9V6C9 5.73478 9.10536 5.48043 9.29289 5.29289C9.48043 5.10536 9.73478 5 10 5C10.2652 5 10.5196 5.10536 10.7071 5.29289C10.8946 5.48043 11 5.73478 11 6V9H14C14.2652 9 14.5196 9.10536 14.7071 9.29289C14.8946 9.48043 15 9.73478 15 10C15 10.2652 14.8946 10.5196 14.7071 10.7071C14.5196 10.8946 14.2652 11 14 11H11V14C11 14.2652 10.8946 14.5196 10.7071 14.7071C10.5196 14.8946 10.2652 15 10 15C9.73478 15 9.48043 14.8946 9.29289 14.7071C9.10536 14.5196 9 14.2652 9 14V11H6C5.73478 11 5.48043 10.8946 5.29289 10.7071C5.10536 10.5196 5 10.2652 5 10Z" fill="#2C6ECB"/>
                                      </svg>
                                      {__('Add upsell')}
                                    </button>
                                    <button onClick={(e) => this.addDownshellThankyou(e, 0, [])} data-id="add_typ">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM5 10C5 9.73478 5.10536 9.48043 5.29289 9.29289C5.48043 9.10536 5.73478 9 6 9H9V6C9 5.73478 9.10536 5.48043 9.29289 5.29289C9.48043 5.10536 9.73478 5 10 5C10.2652 5 10.5196 5.10536 10.7071 5.29289C10.8946 5.48043 11 5.73478 11 6V9H14C14.2652 9 14.5196 9.10536 14.7071 9.29289C14.8946 9.48043 15 9.73478 15 10C15 10.2652 14.8946 10.5196 14.7071 10.7071C14.5196 10.8946 14.2652 11 14 11H11V14C11 14.2652 10.8946 14.5196 10.7071 14.7071C10.5196 14.8946 10.2652 15 10 15C9.73478 15 9.48043 14.8946 9.29289 14.7071C9.10536 14.5196 9 14.2652 9 14V11H6C5.73478 11 5.48043 10.8946 5.29289 10.7071C5.10536 10.5196 5 10.2652 5 10Z" fill="#2C6ECB"/>
                                        </svg>
                                      {__('Thank you page')}
                                    </button>
                                  </div>
                                </div>
                                :
                                <div>
                                  <h3>{__('select offer')}</h3>
                                  <div className="lastsection_content" ref={this.wrapperRef}>
                                    <Select
                                      className="dynamicadd"
                                      value={this.state.selectedOption}
                                      onChange={this.handleChange}
                                      options={this.state.offer_options}
                                      onClose={this.closeshowDropdown}
                                      formatOptionLabel={formatOptionLabel}
                                      defaultMenuIsOpen={true}
                                    />
                                  </div>
                                </div>
                              }
                            </div>
                            :
                            <div>
                              <h3>{__('select template')}</h3>
                              <div className="lastsection_content" ref={this.wrapperRef}>
                                <Select
                                  className="dynamic_dropDown"
                                  value={this.state.selectedOption}
                                  onChange={this.handleChange_thanks}
                                  options={this.state.template_data}
                                  formatOptionLabel={formatOptionLabel}
                                  defaultMenuIsOpen={true}
                                />
                              </div>
                            </div>
                          }
                        </div>
                      ) : (
                        <div className="last_section ">
                          {this.state.funnel_toast ? (
                            <Toast
                              content={this.state.toaster_msg}
                              onDismiss={this.toggleActive.bind(this)}
                              duration={2000}
                            />
                          ) : (
                            ""
                          )}
                          {this.state.funnel_toast_error ? (
                            <Toast
                              error
                              content={this.state.toaster_msg}
                              onDismiss={this.toggleFunnelError.bind(this)}
                              duration={5000}
                            />
                          ) : (
                            ""
                          )}
                          {this.child_node(this.state.offerUser_down)}
                        </div>
                      )}
                    </>
                  </div>
                </>
              }
            </div>

            <div>
              {active && (
                <Modal
                  open={active}
                  onClose={this.closeModal}
                  title={__("New offer")}
                  secondaryActions={{
                    content: "Cancel",
                    onAction: this.closeModal,
                  }}
                >
                  <Modal.Section>
                    <div className="sample_modalSection">
                      <p>{__('Select offer type:')}</p>
                      <div className="offer_section_type">
                        <label onClick={this.open_sampleModal.bind(this, 'recom', true, 25)}>
                          <input type="radio" name="offer_type" />
                          <div className="selct_ofr_type">
                            <svg width="639" height="240" viewBox="0 0 639 240" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="428.875" y="170.213" width="83.7471" height="17.631" rx="0.5" fill="#606EC6" />
                              <rect x="429.125" y="170.463" width="83.2471" height="17.131" rx="0.25" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="245.838" y="170.213" width="83.7471" height="17.631" rx="0.5" fill="#606EC6" />
                              <rect x="246.088" y="170.463" width="83.2471" height="17.131" rx="0.25" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="54.2173" y="170.213" width="83.7471" height="17.631" rx="0.5" fill="#606EC6" />
                              <rect x="54.4673" y="170.463" width="83.2471" height="17.131" rx="0.25" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="153.74" y="0.283203" width="333.017" height="17.631" rx="0.5" fill="#606EC6" />
                              <rect x="153.99" y="0.533203" width="332.517" height="17.131" rx="0.25" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="149.912" y="222.294" width="333.017" height="17.631" rx="0.5" fill="#606EC6" />
                              <rect x="150.162" y="222.544" width="332.517" height="17.131" rx="0.25" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="428.875" y="139.359" width="110.194" height="8.81549" rx="0.5" fill="#606EC6" />
                              <rect x="429.125" y="139.609" width="109.694" height="8.31549" rx="0.25" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="245.838" y="139.359" width="110.194" height="8.81549" rx="0.5" fill="#606EC6" />
                              <rect x="246.088" y="139.609" width="109.694" height="8.31549" rx="0.25" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="54.2173" y="139.359" width="110.194" height="8.81549" rx="0.5" fill="#606EC6" />
                              <rect x="54.4673" y="139.609" width="109.694" height="8.31549" rx="0.25" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="428.875" y="152.582" width="110.194" height="8.81549" rx="0.5" fill="#606EC6" />
                              <rect x="429.125" y="152.832" width="109.694" height="8.31549" rx="0.25" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="245.838" y="152.582" width="110.194" height="8.81549" rx="0.5" fill="#606EC6" />
                              <rect x="246.088" y="152.832" width="109.694" height="8.31549" rx="0.25" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="54.2173" y="152.582" width="110.194" height="8.81549" rx="0.5" fill="#606EC6" />
                              <rect x="54.4673" y="152.832" width="109.694" height="8.31549" rx="0.25" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="428.875" y="42.3887" width="149.863" height="92.5626" rx="1" fill="#606EC6" />
                              <rect x="429.125" y="42.6387" width="149.363" height="92.0626" rx="0.75" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="245.838" y="42.3887" width="149.863" height="92.5626" rx="1" fill="#606EC6" />
                              <rect x="246.088" y="42.6387" width="149.363" height="92.0626" rx="0.75" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="54.2173" y="42.3887" width="149.863" height="92.5626" rx="1" fill="#606EC6" />
                              <rect x="54.4673" y="42.6387" width="149.363" height="92.0626" rx="0.75" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect width="43.4333" height="13.7158" rx="6.85789" transform="matrix(-0.707107 0.707107 0.707107 0.707107 31.4463 50.0444)" fill="#3F4EAE" />
                              <rect x="10.3262" y="70.9194" width="43.4333" height="13.7158" rx="6.85789" transform="rotate(45 10.3262 70.9194)" fill="#3F4EAE" />
                              <rect width="43.4333" height="13.7158" rx="6.85789" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 607.459 111.33)" fill="#3F4EAE" />
                              <rect x="628.58" y="90.4551" width="43.4333" height="13.7158" rx="6.85789" transform="rotate(-135 628.58 90.4551)" fill="#3F4EAE" />
                            </svg>
                          </div>
                          <h3>{__('product Recommendations')}</h3>
                        </label>
                        <label onClick={this.open_sampleModal.bind(this, 'upsell', true, 24)}>
                          <input type="radio" name="offer_type" />
                          <div className="selct_ofr_type">
                            <svg width="359" height="413" viewBox="0 0 359 413" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g filter="url(#filter0_d)">
                                <rect x="3.6167" y="2.8667" width="352.155" height="405.744" rx="1" fill="#606EC6" />
                              </g>
                              <rect x="126.105" y="83.25" width="130.144" height="187.561" rx="1" fill="#3F4EAE" />
                              <rect x="126.355" y="83.5" width="129.644" height="187.061" rx="0.75" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="83.9995" y="44.9717" width="202.872" height="19.1389" rx="1" fill="#3F4EAE" />
                              <rect x="84.2495" y="45.2217" width="202.372" height="18.6389" rx="0.75" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="83.9995" y="22.0059" width="202.872" height="11.4833" rx="1" fill="#3F4EAE" />
                              <rect x="84.2495" y="22.2559" width="202.372" height="10.9833" rx="0.75" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="83.9995" y="301.434" width="202.872" height="38.2778" rx="1" fill="#3F4EAE" />
                              <rect x="84.2495" y="301.684" width="202.372" height="37.7778" rx="0.75" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <rect x="83.9995" y="355.022" width="202.872" height="22.9667" rx="1" fill="#3F4EAE" />
                              <rect x="84.2495" y="355.272" width="202.372" height="22.4667" rx="0.75" stroke="black" strokeOpacity="0.15" strokeWidth="0.5" />
                              <defs>
                                <filter id="filter0_d" x="0.616699" y="0.866699" width="358.155" height="411.744" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                                  <feOffset dy="1" />
                                  <feGaussianBlur stdDeviation="1.5" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                                </filter>
                              </defs>
                            </svg>
                          </div>
                          <h3>{__('product upsell')} </h3>
                        </label>
                      </div>
                    </div>
                  </Modal.Section>
                </Modal>
              )}
              <CommanModal onMyFrameLoad={this.onMyFrameLoad.bind(this)} sampleActive={sampleActive} close_sampleCloseModal={this.close_sampleCloseModal.bind(this)} sampleActiveURL={this.state.sampleActiveURL}></CommanModal>
              <Modal
                large
                limitHeight={false}
                open={this.state.templateActive}
                onClose={this.close_TemplateModal_loader.bind(this)}
                iFrameName="Edit_offer"
                loading={false}
              >
                <Modal.Section className="tmp_ifrm">
                  <iframe
                    title="Edit_offer"
                    name="Edit_offer"
                    id="Edit_offer"
                    src={this.state.templateURL + "&is_editor=1"}
                    width="100%"
                    height="750"
                    onLoad={this.onMyFrameLoad.bind(this)}
                  ></iframe>
                </Modal.Section>
              </Modal>
              <Modal
                open={premadeTemplate}
                onClose={this.handleClose_premade}
                title={this.state.premadeTemplate_rightSide ? <><button onClick={this.close_rightSide_template.bind(this)}><Icon source={MobileBackArrowMajor} /></button>{this.state.premadeTemplate_rightSide.title}</> : __("Explore free template")}
                footer={this.state.premadeTemplate_rightSide ? 
                  <div className="header_devide_block justify_content_flex_end">
                    <div className="margin_left_eight">
                      <div className="tooltip_title"> <Icon source={QuestionMarkMajor} color="base" /> <span className="tooltiptextdiscount">{__('Let us know the biggest % discount you are willing to offer and we will optimize your funnel accordingly')}</span></div>
                    </div>
                    <div className="margin_left_eight">{ __('Max discount:')}</div>
                    <div className="margin_left_eight"> <TextField type="number" value={this.state.percentage} min="0" max="100" suffix="%" onChange={(e) => this.valueChange(e)} defaultValue="30" /></div>
                    <div className="margin_left_eight"> <Button primary onClick={this.callFromPHP.bind(this)} disabled={this.state.addDisable} >{ __('Add') }</Button> </div>
                    </div> 
                    :
                    <div className="header_devide_block justify_content_flex_end"> <Button onClick={this.handleClose_premade}>{ __('Close') }</Button> </div> }
              >
                <Modal.Section>
                  {!this.state.premadeTemplate_rightSide ?
                    <div className="ui-stack ui-stack--wrap ui-stack--distribution-center ui-stack--alignment-center">
                      {this.state.premadTmp.map((tmp, i) => (
                        <div key={i} className="slider-modal-grid-item" onClick={(e) => this.open_premadeTemplate(tmp)}>
                          <div className="slider-modal-grid-item-image">
                            <img src={tmp.desktop_thumbnail} onError={(e) => { e.target.onerror = null; e.target.src = no_img_url }} alt="thmbnail" />
                          </div>
                          <div className="slider-modal-grid-item-desc">
                            <span>{tmp.title}</span>
                          </div>
                        </div>
                      ))}
                      <div className={this.state.emptyTemplate ? "slider-modal-grid-item divDisable" : "slider-modal-grid-item"} onClick={(e) => this.callFromPHP()}>
                        <div className="slider-modal-grid-item-image empty_template_img" style={{ backgroundImage: `url('${config.iFrame_url + this.state.version}/assets/img/onboarding_blank_page.svg')` }}></div>
                        <div className="slider-modal-grid-item-desc">
                          <span>{__('Empty template')}</span>
                        </div>
                      </div>
                    </div>
                    :
                    <div className={this.state.animateLeft ? "free-themes-modal-details sliderTo_left" : "free-themes-modal-details"}>
                      <div className="free-themes-modal-images">
                        <div className="free-themes-modal-mobile-screen-wrapper">
                          <img className="free-themes-modal-mobile-device" src={`${config.iFrame_url + this.state.version}/assets/img/free-themes-modal-mobile-device.png`} alt="" />
                          <img data-src="" alt="Customer Satisfaction aaa" data-handle="simple--light" className="free-themes-modal-mobile-image free-themes-modal-image--is-visible" src={this.state.premadeTemplate_rightSide.mobile_thumbnail} title="Customer Satisfaction"
                            onError={(e) => { e.target.onerror = null; e.target.src = no_img_url }} />
                        </div>
                        <img data-src="" alt="Customer Satisfaction" title="Customer Satisfaction" data-handle="simple--light" className="free-themes-modal-image free-themes-modal-image--is-visible" src={this.state.premadeTemplate_rightSide.desktop_thumbnail} onError={(e) => { e.target.onerror = null; e.target.src = no_img_url }} />
                      </div>
                      <div className="free-themes-modal-details-info">
                        {parse(this.state.premadeTemplate_rightSide.description)}
                      </div>
                    </div>
                  }
                </Modal.Section>
              </Modal>
              <Modal
                large
                limitHeight={false}
                open={this.state.open_iframe}
                onClose={this.close_upsellModal.bind(this)}
                iFrameName="product_upsell"
                loading={false}
              >
                <Modal.Section>
                  <iframe
                    title="product_upsell"
                    name="product_upsell"
                    id="product_upsell"
                    src={`http://localhost/stilyo-apps/reconvert`+this.state.version+`/client/editor/product_upsell_editor.php?id=1&shop=shipping-tags.myshopify.com`}
                    width="100%"
                    height="750"
                    onLoad={this.onMyFrameLoad.bind(this)}
                  ></iframe>
                </Modal.Section>
              </Modal>
              <Modal
                large
                limitHeight={false}
                open={this.state.open_devTemplate}
                onClose={this.close_devTemplateModal.bind(this)}
                iFrameName="dev_template"
                loading={false}
              >
                <Modal.Section>
                  <iframe
                    title="dev_template"
                    name="dev_template"
                    id="dev_template"
                    src={`https://dev.stilyoapps.com/reconvert`+this.state.version+`/client/editor.php?id=1454&scid=MWpPWVVFVTlhcld3QU5vRlNQODN3dz09&shop=reconvert-dev-branch.myshopify.com`}
                    width="100%"
                    height="750"
                    onLoad={this.onMyFrameLoad.bind(this)}
                  ></iframe>
                </Modal.Section>
              </Modal>
              <Modal
                large
                limitHeight={false}
                open={this.state.open_localTemplate}
                onClose={this.close_localTemplateModal.bind(this)}
                iFrameName="dev_template"
                loading={false}
              >
                <Modal.Section>
                  <iframe
                    title="local template"
                    name="local_template"
                    id="local_template"
                    src={`http://localhost/stilyo-apps/reconvert`+this.state.version+`/client/editor.php?id=5061&scid=VTVBaGFkN2pCeGExVWJ0aW9WRDFjZz09&shop=shipping-tags.myshopify.com`}
                    width="100%"
                    height="750"
                    onLoad={this.onMyFrameLoad.bind(this)}
                  ></iframe>
                </Modal.Section>
              </Modal>
              <Modal
                large
                limitHeight={false}
                open={this.state.open_recomm}
                onClose={this.close_recommendationsModal.bind(this)}
                iFrameName="product_recommendations"
                loading={false}
              >
                <Modal.Section>
                  <iframe
                    title="product_recommendations"
                    name="product_recommendations"
                    id="product_recommendations"
                    src={`http://localhost/stilyo-apps/reconvert`+this.state.version+`/client/editor/product_recommendations_editor.php?id=28&shop=shipping-tags.myshopify.com`}
                    width="100%"
                    height="750"
                    onLoad={this.onMyFrameLoad.bind(this)}
                  ></iframe>
                </Modal.Section>
              </Modal>
              <Modal
                open={this.state.delete_offer_template}
                onClose={this.delete_offer_templateModal.bind(this)}
                title={this.state.offer_delete ? __("Delete offer?") : __("Delete template?")}
                primaryAction={{
                  content: __("Delete"),
                  onAction: this.delete_offer,
                  destructive: true
                }}
                secondaryActions={{
                  content: this.state.offer_delete ? __("Keep offer") : __("Keep template"),
                  onAction: this.delete_offer_templateModal.bind(this),
                }}
                limitHeight={true}
                limitWidth={true}
              >
                <Modal.Section>
                  <TextContainer>
                    <div className="delete_txt_wrapper">
                      <p>{this.state.offer_delete ? __('By deleting this offer, you will also delete all downsells & thank you pages connected to this offer.') : "Are you sure you want to delete the template?"}</p>
                    </div>
                  </TextContainer>
                </Modal.Section>
              </Modal>
              {/* help video */}
              {/* <Modal
                open={this.state.helpVidio}
                onClose={this.openhelpvidio}
                title={__("Funnel editor")}
                secondaryActions={{
                  content: __('Close'),
                  onAction: this.openhelpvidio,
                }}
              >
                <Modal.Section>
                  <iframe title="help video" height="410px" width="100%" frameBorder="0" src="https://help.stilyoapps.com/en/article/funnel-editor-v30-55jmds/reader/"></iframe>
                </Modal.Section>
              </Modal> */}
              {this.state.helpVidio && (

                <div data-portal-id="modal-Polarisportal-video" >
                  <div>
                    <div class="Polaris-Modal-Dialog__Container" data-polaris-layer="true" data-polaris-overlay="true">
                      <div>
                        <div role="dialog" aria-labelledby="Polarismodal-header9" tabindex="-1" class="Polaris-Modal-Dialog">
                          <div class="Polaris-Modal-Dialog__Modal" ref={this.videoRef}>
                            <div class="Polaris-Modal-Header">
                              <div id="Polarismodal-header9" class="Polaris-Modal-Header__Title">
                                <h2 class="Polaris-DisplayText Polaris-DisplayText--sizeSmall">Funnel editor</h2>
                              </div>
                              <button class="Polaris-Modal-CloseButton" aria-label="Close" onClick={this.openhelpvidio}>
                                <span class="Polaris-Icon Polaris-Icon--colorInkLighter Polaris-Icon--isColored">
                                  <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                                    <path d="M11.414 10l6.293-6.293a.999.999 0 1 0-1.414-1.414L10 8.586 3.707 2.293a.999.999 0 1 0-1.414 1.414L8.586 10l-6.293 6.293a.999.999 0 1 0 1.414 1.414L10 11.414l6.293 6.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z" fill-rule="evenodd"></path>
                                  </svg>
                                </span>
                              </button>
                            </div>
                            <div class="Polaris-Modal__BodyWrapper">
                              <div class="Polaris-Modal__Body Polaris-Scrollable Polaris-Scrollable--vertical" data-polaris-scrollable="true">
                                <section class="Polaris-Modal-Section"><iframe title="help video" height="410px" width="100%" frameborder="0" src="https://help.stilyoapps.com/en/article/funnel-editor-v30-55jmds/reader/"></iframe></section>
                              </div>
                            </div>
                            <div class="Polaris-Modal-Footer">
                              <div class="Polaris-Modal-Footer__FooterContent">
                                <div class="Polaris-Stack Polaris-Stack--alignmentCenter">
                                  <div class="Polaris-Stack__Item Polaris-Stack__Item--fill"></div>
                                  <div class="Polaris-Stack__Item">
                                    <div class="Polaris-ButtonGroup">
                                      <div class="Polaris-ButtonGroup__Item"><button type="button" class="Polaris-Button" onClick={this.openhelpvidio}><span class="Polaris-Button__Content"><span class="Polaris-Button__Text">Close</span></span></button></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="Polaris-Backdrop"></div>
                </div>
              )}
              <Modal
                open={this.state.publishFirst}
                onClose={this.handleChnageappfirstPopup}
                title={__("Congratulations! ReConvert is now active on your store!")}
                primaryAction={{
                  content: __('Go to dashboard'),
                  onAction: this.redirecttoDashboard,
                }}
                secondaryActions={{
                  content: __('Close'),
                  onAction: this.handleChnageappfirstPopup,
                }}
              >
                <Modal.Section>
                  <TextContainer>
                    <p>{__('Customers will now see your post purchase funnels & optimized thank you page when they complete the checkout. We will start generating sales in the background')}  </p>
                    <img src={congoGif} alt="congoGif" />
                  </TextContainer>
                </Modal.Section>
              </Modal>
              {/* warning msg pop-up */}
              <Modal
                open={this.state.confirmationPhp}
                onClose={this.openWarningMsg.bind(this)}
                title={__("Unsaved changes")}
                primaryAction={{
                  content: __("Leave page"),
                  onAction: this.close_sampleCloseModal_Final.bind(this),
                  destructive: true
                }}
                secondaryActions={{
                  content: __("Cancel"),
                  onAction: this.openWarningMsg.bind(this),
                }}
                limitHeight={true}
                limitWidth={true}
              >
                <Modal.Section>
                  <TextContainer>
                    <div className="delete_txt_wrapper">
                      <p>{__('If you leave this page, any unsaved changes will be lost.')}</p>
                    </div>
                  </TextContainer>
                </Modal.Section>
              </Modal>
            </div>

            {/* fallback template */}
            {this.state.is_show_banner === 1 ?
            <div className={this.props.expandView ? "funnel_app fallback_template is_bottom is_open" : "funnel_app fallback_template is_bottom"}>
              <Banner
                title={this.state.top_banner_data.title}
                status={this.state.banner_type}
                action={{content: this.state.top_banner_data.button_text, url: this.state.top_banner_data.button_link}}
                onDismiss={() => {this.closeBanner(this.state.display_rules)}}
              >
                 <p>{this.state.top_banner_data.description}</p>
                 </Banner>
                 </div>
              :""
            }
            <FallbackTemplate table_selector={this.state.table_selector} funnel_id={this.state.funnel_id} handleChangeTemplateFallback={(ele) => this.handleChangeTemplateFallback(ele, true)} anaytics_data={this.state.anaytics_data} value={this.state.selectedOption_fallback} anaytics_data_value={this.state.anaytics_data_value} expandView={this.state.fallback_active} handleToggle={this.handleToggle} openfallback={this.openfallback}  />
          </Frame>
          : ""}
      </AppProvider>
    );
  }
}
export default Home;